import Select from "react-select";
import bcrypt from "bcryptjs";
import * as OTPAuth from "otpauth";
import { QRCodeSVG } from "qrcode.react";
import { FaTimesCircle, FaTachometerAlt, FaFileAlt, FaUsers, FaClipboardList, FaWallet, FaHandHoldingUsd, FaUserCog, FaHistory, FaCog, FaMapMarkerAlt, FaTools, FaRupeeSign, FaTags, FaUserCircle } from "react-icons/fa";

import {
  PieChart,
  Pie,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Cell,
  Tooltip,
  ResponsiveContainer
}
from "recharts";

import { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./premium-theme.css";
import PublicWebsite from "./PublicWebsite";

import * as XLSX from "xlsx";

import { saveAs } from "file-saver";
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  updateDoc,
  doc,
  query,
  where,
  runTransaction
} from "firebase/firestore";

import { db, storage } from "./firebase";
import { ref, uploadBytes, getDownloadURL, listAll, deleteObject } from "firebase/storage";

const PublicWebsiteOld = ({ publicPage, setPublicPage, onStaffLogin }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [lang, setLang] = useState("en");
  const [enquiry, setEnquiry] = useState({ name: "", mobile: "", service: "", message: "" });

  const t = (en, ta) => lang === "ta" ? ta : en;

  const sendWhatsAppEnquiry = () => {
    if (!enquiry.name || !enquiry.mobile || !enquiry.service) {
      alert(t("Please fill Name, Mobile Number and Service.", "பெயர், மொபைல் எண் மற்றும் சேவை தேர்ந்தெடுக்கவும்."));
      return;
    }
    const msg = `Hello SBM Udhayam,\n\nName: ${enquiry.name}\nMobile: ${enquiry.mobile}\nService: ${enquiry.service}\nMessage: ${enquiry.message || "No additional message"}\n\nThank you.`;
    window.open(`https://wa.me/918123454322?text=${encodeURIComponent(msg)}`, "_blank");
  };

  const services = [
    { icon: "📝", title: t("New Member Registration", "புதிய உறுப்பினர் பதிவு"), text: t("Guidance and assistance for eligible workers who wish to register as members.", "தகுதியான தொழிலாளர்களுக்கு உறுப்பினராக பதிவு செய்ய வழிகாட்டுதல் மற்றும் உதவி.") },
    { icon: "🔄", title: t("Membership Renewal", "உறுப்பினர் புதுப்பித்தல்"), text: t("Support and guidance for renewing existing memberships on time.", "உறுப்பினர் அட்டையை சரியான நேரத்தில் புதுப்பிக்க உதவி மற்றும் வழிகாட்டுதல்.") },
    { icon: "🎓", title: t("Educational Assistance", "கல்வி உதவித்தொகை"), text: t("Guidance for applying educational assistance for children of registered workers.", "பதிவுசெய்த தொழிலாளர்களின் குழந்தைகளுக்கு கல்வி உதவித்தொகை பெற வழிகாட்டுதல்.") },
    { icon: "💍", title: t("Marriage Assistance", "திருமண உதவித்தொகை"), text: t("Information and application guidance for marriage assistance benefits.", "திருமண உதவித்தொகை பெற விண்ணப்பிக்க தகவல் மற்றும் வழிகாட்டுதல்.") },
    { icon: "🤱", title: t("Maternity Assistance", "மகப்பேறு உதவித்தொகை"), text: t("Guidance regarding maternity-related welfare assistance for eligible workers.", "தகுதியான பெண் தொழிலாளர்களுக்கு மகப்பேறு நல உதவித்தொகை பெற வழிகாட்டுதல்.") },
    { icon: "🏠", title: t("Housing Assistance", "வீட்டு உதவித்தொகை"), text: t("Information regarding housing assistance schemes available for members.", "உறுப்பினர்களுக்கு கிடைக்கும் வீட்டு உதவி திட்டங்கள் பற்றிய தகவல்.") },
    { icon: "⚠️", title: t("Accidental Death Assistance", "விபத்து மரண உதவி"), text: t("Guidance for family assistance in case of accidental death of a member.", "உறுப்பினர் விபத்தில் இறந்தால் குடும்பத்திற்கு உதவி பெற வழிகாட்டுதல்.") },
    { icon: "🕊️", title: t("Natural Death Assistance", "இயற்கை மரண உதவி"), text: t("Application guidance for families of eligible deceased members.", "இறந்த தகுதியான உறுப்பினர் குடும்பத்திற்கு உதவி விண்ணப்பிக்க வழிகாட்டுதல்.") },
    { icon: "👴", title: t("Monthly Pension", "மாதாந்திர ஓய்வூதியம்"), text: t("Information and guidance regarding monthly pension benefits for aged members.", "வயதான உறுப்பினர்களுக்கு மாதாந்திர ஓய்வூதிய சலுகைகள் பற்றிய தகவல்.") },
  ];

  const go = (page) => { setPublicPage(page); window.scrollTo({ top: 0, behavior: "smooth" }); };

  const navLinks = [
    ["home", t("Home","முகப்பு")],
    ["services", t("Services","சேவைகள்")],
    ["about", t("About","எங்களை பற்றி")],
    ["contact", t("Contact","தொடர்பு")]
  ];

  return (
    <div lang={lang} style={{ fontFamily: lang === "ta" ? "'Noto Sans Tamil','Latha','Tamil MN',sans-serif" : "'Inter','Segoe UI',sans-serif", minHeight: "100vh", background: "#FBF3E7", color: "#1C1712", overflowX: "hidden" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=Inter:wght@300;400;500;600;700;800&family=Noto+Sans+Tamil:wght@400;500;600;700;800&display=swap');
        * { box-sizing: border-box; }
        :lang(ta), [lang="ta"], .ta-text {
          font-family: 'Noto Sans Tamil', 'Latha', 'Tamil MN', sans-serif !important;
          font-weight: 400;
          letter-spacing: 0;
        }
        :lang(ta) .pub-h1, :lang(ta) .pub-h2 {
          font-weight: 600 !important;
          letter-spacing: 0.3px !important;
          line-height: 1.6 !important;
        }
        :lang(ta) .pub-stat-num, :lang(ta) .pub-nav-cta, :lang(ta) .pub-btn-primary, :lang(ta) .pub-btn-ghost, :lang(ta) .pub-enquiry-btn {
          font-weight: 600 !important;
        }

        /* NAV */
        .pub-nav { position:fixed;top:0;left:0;right:0;z-index:1000;padding:0 6%;height:66px;display:flex;align-items:center;justify-content:space-between;background:#FBF3E7;border-bottom:1px solid rgba(28,23,18,0.08); }
        .pub-nav-link { background:none;border:none;color:#5c564e;font-size:14px;font-weight:500;cursor:pointer;padding:7px 13px;border-radius:8px;transition:all 0.2s;font-family:'Inter',sans-serif; }
        .pub-nav-link:hover,.pub-nav-link.active { color:#1C1712;background:rgba(28,23,18,0.06); }
        .pub-nav-cta { background:#1C1712;color:#FFF3E6;border:none;padding:10px 20px;border-radius:8px;font-size:13px;font-weight:700;cursor:pointer;transition:all 0.2s;font-family:'Inter',sans-serif; }
        .pub-nav-cta:hover { background:#332b22;transform:translateY(-1px); }
        .pub-lang-toggle { display:flex;background:#efe6d8;border-radius:8px;padding:3px; }
        .pub-lang-btn { padding:5px 12px;border-radius:6px;border:none;font-size:12px;font-weight:700;cursor:pointer;transition:all 0.2s;font-family:'Inter',sans-serif; }

        /* HERO — Dawn gradient */
        .pub-hero { min-height:92vh;display:flex;align-items:center;padding:110px 6% 70px;position:relative;overflow:hidden;background:linear-gradient(155deg,#16213E 0%,#16213E 38%,#C94B3C 68%,#FFB238 100%); }
        .pub-hero-grid { display:none; }
        .pub-hero-glow { position:absolute;inset:0;background:radial-gradient(circle at 78% 60%,rgba(255,178,56,0.35),transparent 55%);animation:dawnGlow 8s ease-in-out infinite;pointer-events:none; }
        @keyframes dawnGlow { 0%,100%{opacity:0.65} 50%{opacity:1} }
        .pub-badge { display:inline-flex;align-items:center;gap:8px;padding:6px 16px;background:transparent;border:1px solid rgba(255,243,230,0.35);border-radius:99px;color:#FFE8C2;font-size:12px;font-weight:600;letter-spacing:0.5px;margin-bottom:28px; }
        .pub-h1 { font-family:'Space Grotesk',sans-serif;font-size:clamp(34px,4.6vw,58px);font-weight:700;line-height:1.12;letter-spacing:-1px;color:#FFF3E6;margin-bottom:22px; }
        .pub-h1-grad { color:#FFB238; }
        .pub-hero-p { color:#F3E4D2;font-size:17px;line-height:1.8;max-width:520px;margin-bottom:36px; }
        .pub-btn-primary { background:#FFB238;color:#16213E;border:none;padding:15px 28px;border-radius:8px;font-size:15px;font-weight:700;cursor:pointer;transition:all 0.2s;font-family:'Inter',sans-serif; }
        .pub-btn-primary:hover { background:#ffc35e;transform:translateY(-2px); }
        .pub-btn-ghost { background:transparent;color:#FFF3E6;border:1.5px solid rgba(255,243,230,0.45);padding:14px 28px;border-radius:8px;font-size:15px;font-weight:600;cursor:pointer;transition:all 0.2s;font-family:'Inter',sans-serif; }
        .pub-btn-ghost:hover { background:rgba(255,243,230,0.1); }
        .pub-stat-row { display:flex;gap:40px;flex-wrap:wrap;margin-top:44px;padding-top:32px;border-top:1px solid rgba(255,243,230,0.2); }
        .pub-stat-num { font-family:'Space Grotesk';font-size:28px;font-weight:700;color:#FFB238; }
        .pub-stat-label { font-size:12px;color:#cbbfae;font-weight:500;margin-top:2px; }
        .pub-horizon { height:5px;background:linear-gradient(90deg,#16213E,#C94B3C 40%,#FFB238 75%,#FFF3E6); }

        /* SECTION */
        .pub-section { padding:80px 6%; }
        .pub-eyebrow { font-size:11px;font-weight:700;letter-spacing:1px;color:#C94B3C;margin-bottom:12px; }
        .pub-h2 { font-family:'Space Grotesk';font-size:clamp(26px,3vw,40px);font-weight:700;color:#1C1712;letter-spacing:-0.5px;line-height:1.15;margin-bottom:12px; }
        .pub-h2-grad { color:#C94B3C; }
        .pub-section-sub { color:#5c564e;font-size:15.5px;line-height:1.7;max-width:540px;margin:0 auto; }

        /* SERVICE CARDS — color-bar style, not uniform SaaS cards */
        .pub-svc-card { background:#FFF3E6;border:none;border-left:5px solid #FF6B4A;border-radius:6px;padding:28px 24px;height:100%;transition:transform 0.2s; }
        .pub-svc-card:nth-child(3n+2) { border-left-color:#FFB238; }
        .pub-svc-card:nth-child(3n+3) { border-left-color:#16213E; }
        .pub-svc-card:hover { transform:translateY(-3px); }
        .pub-svc-icon { font-size:26px;margin-bottom:18px; }
        .pub-svc-title { font-size:15.5px;font-weight:700;color:#1C1712;margin-bottom:8px; }
        .pub-svc-text { font-size:13.5px;color:#5c564e;line-height:1.65; }
        .pub-svc-link { display:inline-flex;align-items:center;gap:6px;color:#C94B3C;font-size:13px;font-weight:600;margin-top:18px;cursor:pointer;border:none;background:none;padding:0;font-family:'Inter',sans-serif;transition:gap 0.2s; }
        .pub-svc-link:hover { gap:10px; }

        /* STEPS — genuine sequence, numbered legitimately */
        .pub-step { border-top:3px solid #FFB238;padding-top:18px;height:100%; }
        .pub-step-num { font-family:'Space Grotesk';font-size:26px;font-weight:700;color:#C94B3C;margin-bottom:8px; }
        .pub-step-title { font-size:15px;font-weight:700;color:#1C1712;margin-bottom:6px; }
        .pub-step-text { font-size:13px;color:#5c564e;line-height:1.6; }

        /* WHY CARDS */
        .pub-why-card { background:#FBF3E7;border:1px solid rgba(28,23,18,0.08);border-radius:6px;padding:26px;transition:0.2s;height:100%;border-top:3px solid #C94B3C; }
        .pub-why-card:hover { transform:translateY(-3px); }
        .pub-why-title { font-size:15px;font-weight:700;color:#1C1712;margin-bottom:7px; }
        .pub-why-text { font-size:14px;color:#5c564e;line-height:1.6; }

        /* ABOUT */
        .pub-about-box { background:#FBF3E7;border:1px solid rgba(28,23,18,0.08);border-radius:12px;padding:36px; }
        .pub-mission-block { padding:22px;background:#FFF3E6;border-left:3px solid #C94B3C;border-radius:6px;margin-bottom:14px; }

        /* CONTACT */
        .pub-contact-card { background:#FFF3E6;border:1px solid rgba(28,23,18,0.08);border-radius:10px;padding:32px;height:100%;transition:0.2s; }
        .pub-contact-card:hover { transform:translateY(-3px); }
        .pub-contact-icon { width:52px;height:52px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:24px;margin-bottom:20px; }
        .pub-enquiry-input { width:100%;background:#FBF3E7;border:1.5px solid rgba(28,23,18,0.12);border-radius:8px;padding:12px 14px;color:#1C1712;font-size:14px;margin-bottom:12px;outline:none;transition:0.2s;font-family:'Inter',sans-serif; }
        .pub-enquiry-input:focus { border-color:#C94B3C;box-shadow:0 0 0 3px rgba(201,75,60,0.12);background:#fff; }
        .pub-enquiry-input::placeholder { color:#a39a8c; }
        .pub-enquiry-btn { width:100%;background:#FFB238;color:#16213E;border:none;padding:13px;border-radius:8px;font-size:15px;font-weight:700;cursor:pointer;transition:0.2s;font-family:'Inter',sans-serif; }
        .pub-enquiry-btn:hover { filter:brightness(1.05);transform:translateY(-1px); }

        /* FOOTER */
        .pub-footer { background:#16213E;border-top:3px solid #FFB238;padding:56px 6% 28px; }
        .pub-footer-link { background:none;border:none;color:#b9c2d8;font-size:14px;cursor:pointer;padding:5px 0;display:block;transition:0.2s;text-align:left;font-family:'Inter',sans-serif; }
        .pub-footer-link:hover { color:#FFB238; }
        .pub-divider { border:none;border-top:1px solid rgba(255,243,230,0.1);margin:36px 0 22px; }

        /* WHATSAPP */
        .pub-wa-float { position:fixed;bottom:28px;right:28px;z-index:9999;background:linear-gradient(135deg,#FF6B4A,#FFB238);color:#16213E;width:52px;height:52px;border-radius:50%;font-size:24px;cursor:pointer;box-shadow:0 6px 20px rgba(255,107,74,0.4);display:flex;align-items:center;justify-content:center;text-decoration:none;transition:0.2s; }
        .pub-wa-float:hover { transform:scale(1.1); }

        /* MOBILE */
        @media (max-width:768px) {
          .pub-desktop-links { display:none !important; }
          .pub-hero { padding:90px 5% 60px; }
          .pub-section { padding:60px 5%; }
          .pub-h1 { letter-spacing:-1px; }
        }
        @media (min-width:769px) {
          .pub-mobile-toggle { display:none !important; }
        }

        @keyframes fadeUp { from{opacity:0;transform:translateY(16px)} to{opacity:1;transform:translateY(0)} }
        .pub-fadein { animation:fadeUp 0.5s ease both; }

        @keyframes workerFloat {
          0%,100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        @keyframes glowPulse {
          0%,100% { opacity: 0.5; transform: scale(1); }
          50% { opacity: 0.8; transform: scale(1.08); }
        }
        .worker-illust { animation: workerFloat 3.5s ease-in-out infinite; transition: transform 0.3s; }
        .worker-illust:hover { transform: translateY(-6px) scale(1.04); }
        .worker-illust-wrap:nth-child(2) .worker-illust { animation-delay: 0.4s; }
        .worker-illust-wrap:nth-child(3) .worker-illust { animation-delay: 0.8s; }
        .worker-glow { animation: glowPulse 3s ease-in-out infinite; }
      `}</style>

      {/* ── NAVBAR ── */}
      <nav className="pub-nav">
        <div onClick={() => go("home")} style={{ display:"flex",alignItems:"center",gap:"10px",cursor:"pointer" }}>
          <img
  src="/sbm-logo.jpeg"
  alt="SBM Udhayam Logo"
  style={{
    width: "65px",
    height: "65px",
    objectFit: "contain",
    borderRadius: "10px"
  }}
/>
          <div>
            <div style={{ color:"#1C1712",fontFamily:"'Space Grotesk'",fontWeight:"700",fontSize:"14px",letterSpacing:"-0.3px" }}>SBM UDHAYAM</div>
            <div style={{ color:"#a39a8c",fontSize:"10px",marginTop:"1px" }}>WORKER WELFARE</div>
          </div>
        </div>

        <div className="pub-desktop-links" style={{ display:"flex",alignItems:"center",gap:"2px" }}>
          {navLinks.map(([p,l]) => (
            <button key={p} className={`pub-nav-link ${publicPage===p?"active":""}`} onClick={() => go(p)}>{l}</button>
          ))}
        </div>

        <div style={{ display:"flex",alignItems:"center",gap:"10px" }}>
          {/* Language Toggle */}
          <div className="pub-lang-toggle">
            <button className="pub-lang-btn" onClick={() => setLang("en")}
              style={{ background:lang==="en"?"#fff":"transparent", color:lang==="en"?"#0f172a":"#94a3b8", boxShadow:lang==="en"?"0 1px 4px rgba(0,0,0,0.1)":"none" }}>
              EN
            </button>
            <button className="pub-lang-btn" onClick={() => setLang("ta")}
              style={{ background:lang==="ta"?"#fff":"transparent", color:lang==="ta"?"#0f172a":"#94a3b8", boxShadow:lang==="ta"?"0 1px 4px rgba(0,0,0,0.1)":"none" }}>
              தமிழ்
            </button>
          </div>
          <button className="pub-nav-cta" onClick={onStaffLogin}>{t("Staff Portal →","அலுவலர் உள்நுழைவு →")}</button>
          <button className="pub-mobile-toggle" onClick={() => setMenuOpen(!menuOpen)}
            style={{ background:"none",border:"none",color:"#0f172a",fontSize:"22px",cursor:"pointer" }}>
            {menuOpen ? "✕" : "☰"}
          </button>
        </div>
      </nav>

      {/* MOBILE MENU */}
      {menuOpen && (
        <div style={{ position:"fixed",top:"64px",left:0,right:0,background:"#fff",borderBottom:"1px solid #e2e8f0",padding:"16px",zIndex:999,boxShadow:"0 8px 24px rgba(0,0,0,0.08)" }}>
          {navLinks.map(([p,l]) => (
            <button key={p} style={{ display:"block",width:"100%",textAlign:"left",background:"none",border:"none",color:"#374151",fontSize:"15px",fontWeight:"600",padding:"13px 8px",cursor:"pointer",borderBottom:"1px solid #f3f4f6",fontFamily:"Inter,sans-serif" }}
              onClick={() => { go(p); setMenuOpen(false); }}>{l}</button>
          ))}
          <button onClick={() => { onStaffLogin(); setMenuOpen(false); }}
            style={{ width:"100%",marginTop:"14px",padding:"13px",background:"#0f172a",color:"#fff",border:"none",borderRadius:"10px",fontWeight:"700",cursor:"pointer",fontFamily:"Inter,sans-serif" }}>
            {t("Staff Portal →","அலுவலர் உள்நுழைவு →")}
          </button>
        </div>
      )}

      {/* ── HOME ── */}
      {publicPage === "home" && (<>

        {/* HERO */}
        <section className="pub-hero">
          <div className="pub-hero-glow"/>
          <div style={{ maxWidth:"1280px",margin:"0 auto",width:"100%",position:"relative",zIndex:1 }}>
            <div className="row align-items-center g-5">
              <div className="col-lg-6 pub-fadein">
                <div className="pub-badge">✦ {t("WORKER WELFARE SUPPORT","தொழிலாளர் நல உதவி")}</div>
                <h1 className="pub-h1" style={lang === "ta" ? { fontSize: "clamp(28px,3.6vw,44px)", letterSpacing: "0.3px", lineHeight: "2", fontWeight: 500 } : {}}>
                  {t("SBM Udhayam – Supporting Workers","SBM உதயம்")}{" "}
                  <span className="pub-h1-grad">{t("Empowering Families","தொழிலாளர் நலம் குடும்ப நலம்")}</span>
                </h1>
                <p className="pub-hero-p">
                  {t(
                    "SBM Udhayam provides clear guidance and personal assistance for construction and unorganised workers seeking government welfare services.",
                    "SBM உதயம் கட்டுமானம் மற்றும் அமைப்புசாரா சங்கம் தொழிலாளர்களுக்கு அரசு நல சேவைகளில் தெளிவான வழிகாட்டுதல் மற்றும் தனிப்பட்ட உதவி வழங்குகிறது."
                  )}
                </p>
                <div style={{ display:"flex",gap:"12px",flexWrap:"wrap" }}>
                  <button className="pub-btn-primary" onClick={() => go("services")}>{t("Explore Services →","சேவைகளை காண →")}</button>
                  <button className="pub-btn-ghost" onClick={() => go("contact")}>{t("Contact Our Team","எங்களை தொடர்பு கொள்ளுங்கள்")}</button>
                </div>
                <div className="pub-stat-row">
                  {[
                    ["9+", t("Welfare Schemes","நல திட்டங்கள்")],
                    ["3", t("Worker Categories","தொழிலாளர் வகைகள்")],
                    ["100%", t("Personal Support","தனிப்பட்ட உதவி")]
                  ].map(([n,l]) => (
                    <div key={l}>
                      <div className="pub-stat-num">{n}</div>
                      <div className="pub-stat-label">{l}</div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-lg-6">
                <div style={{ background:"rgba(22,33,62,0.55)",border:"1px solid rgba(255,243,230,0.15)",borderRadius:"14px",padding:"36px" }}>
                  <div style={{ fontSize:"11px",fontWeight:"700",color:"#FFB238",letterSpacing:"1px",marginBottom:"20px" }}>
                    {t("Government Welfare Schemes","அரசு நல திட்டங்கள்")}
                  </div>
                  <div style={{ display:"flex",flexDirection:"column",gap:"10px" }}>
                    {[
                      { icon:"🎓", label:t("Educational Assistance","கல்வி உதவித்தொகை"), color:"#FFB238" },
                      { icon:"💍", label:t("Marriage Assistance","திருமண உதவித்தொகை"), color:"#FF6B4A" },
                      { icon:"👴", label:t("Monthly Pension","மாதாந்திர ஓய்வூதியம்"), color:"#FFB238" },
                      { icon:"🕊️", label:t("Death Claim Assistance","மரண உதவித்தொகை"), color:"#FF6B4A" },
                      { icon:"🤱", label:t("Maternity Assistance","மகப்பேறு உதவித்தொகை"), color:"#FFB238" },
                      { icon:"🏠", label:t("Housing Assistance","வீட்டு உதவித்தொகை"), color:"#FF6B4A" },
                    ].map(s => (
                      <div key={s.label} style={{ display:"flex",alignItems:"center",gap:"12px",padding:"11px 14px",background:"rgba(255,243,230,0.06)",border:"1px solid rgba(255,243,230,0.1)",borderRadius:"8px" }}>
                        <div style={{ width:"32px",height:"32px",background:`${s.color}25`,borderRadius:"7px",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"15px",flexShrink:0 }}>{s.icon}</div>
                        <span style={{ color:"#F3E4D2",fontSize:"14px",fontWeight:"500",flex:1 }}>{s.label}</span>
                        <div style={{ width:"6px",height:"6px",borderRadius:"50%",background:s.color }}/>
                      </div>
                    ))}
                  </div>
                  <div style={{ marginTop:"18px",padding:"14px",background:"rgba(255,178,56,0.12)",border:"1px solid rgba(255,178,56,0.25)",borderRadius:"8px",display:"flex",alignItems:"center",gap:"12px" }}>
                    <span style={{ fontSize:"20px" }}>📞</span>
                    <div>
                      <div style={{ color:"#FFB238",fontWeight:"700",fontSize:"14px" }}>+91 81234 54322</div>
                      <div style={{ color:"#FFE8C2",fontSize:"12px" }}>{t("Call us for free guidance","இலவச வழிகாட்டுதலுக்கு அழைக்கவும்")}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* WORKER CATEGORIES ILLUSTRATION */}
        <section className="pub-section" style={{ background:"#FBF3E7", paddingTop:"64px", paddingBottom:"64px" }}>
          <div style={{ maxWidth:"1280px",margin:"0 auto" }}>
            <div className="text-center mb-5">
              <div className="pub-eyebrow">{t("WHO WE SERVE","நாங்கள் யாருக்கு உதவுகிறோம்")}</div>
              <h2 className="pub-h2">{t("Every worker,","ஒவ்வொரு தொழிலாளரும்,")}{" "}<span className="pub-h2-grad">{t("every category","ஒவ்வொரு பிரிவும்")}</span></h2>
            </div>
            <div className="row g-4 justify-content-center">

              <svg width="0" height="0" style={{ position:"absolute" }}>
                <defs>
                  <linearGradient id="gradVest" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stopColor="#fbbf24"/><stop offset="100%" stopColor="#d97706"/>
                  </linearGradient>
                  <linearGradient id="gradHelmet" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stopColor="#fde047"/><stop offset="100%" stopColor="#ca8a04"/>
                  </linearGradient>
                  <linearGradient id="gradAuto" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stopColor="#fde047"/><stop offset="100%" stopColor="#eab308"/>
                  </linearGradient>
                  <linearGradient id="gradShirt" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stopColor="#a78bfa"/><stop offset="100%" stopColor="#7c3aed"/>
                  </linearGradient>
                  <linearGradient id="gradSkin" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stopColor="#fed7aa"/><stop offset="100%" stopColor="#fb923c"/>
                  </linearGradient>
                  <radialGradient id="gradGlow" cx="50%" cy="50%" r="50%">
                    <stop offset="0%" stopColor="#FFB238" stopOpacity="0.35"/><stop offset="100%" stopColor="#FFB238" stopOpacity="0"/>
                  </radialGradient>
                </defs>
              </svg>

              {/* Construction Worker */}
              <div className="col-md-4 text-center worker-illust-wrap">
                <div style={{ position:"relative", display:"inline-block" }}>
                  <ellipse className="worker-glow" cx="80" cy="90" rx="80" ry="80" fill="url(#gradGlow)" style={{ position:"absolute", top:0, left:0 }}/>
                  <svg viewBox="0 0 200 220" className="worker-illust" style={{ width:"170px", height:"187px", position:"relative", filter:"drop-shadow(0 8px 16px rgba(99,102,241,0.15))" }}>
                    <ellipse cx="100" cy="208" rx="50" ry="8" fill="#c7d2fe" opacity="0.5"/>
                    <rect x="70" y="120" width="60" height="70" rx="16" fill="url(#gradVest)"/>
                    <rect x="82" y="130" width="10" height="45" rx="4" fill="#78350f"/>
                    <rect x="108" y="130" width="10" height="45" rx="4" fill="#78350f"/>
                    <rect x="78" y="175" width="20" height="35" rx="6" fill="#1e293b"/>
                    <rect x="102" y="175" width="20" height="35" rx="6" fill="#1e293b"/>
                    <rect x="76" y="205" width="24" height="8" rx="3" fill="#0f172a"/>
                    <rect x="100" y="205" width="24" height="8" rx="3" fill="#0f172a"/>
                    <circle cx="100" cy="95" r="30" fill="url(#gradSkin)"/>
                    <path d="M70 90 a30 30 0 0 1 60 0 v-6 a30 22 0 0 0 -60 0 z" fill="url(#gradHelmet)"/>
                    <rect x="66" y="82" width="68" height="10" rx="5" fill="#ca8a04"/>
                    <rect x="45" y="130" width="16" height="45" rx="8" fill="url(#gradVest)"/>
                    <rect x="139" y="130" width="16" height="45" rx="8" fill="url(#gradVest)"/>
                    <rect x="40" y="165" width="26" height="7" rx="3" fill="#78350f"/>
                    <circle cx="112" cy="93" r="3" fill="#78350f"/>
                    <path d="M92 105 q8 5 16 0" stroke="#78350f" strokeWidth="2" fill="none" strokeLinecap="round"/>
                  </svg>
                </div>
                <div className="pub-svc-title mt-2">{t("Construction Workers","கட்டுமான தொழிலாளர்கள்")}</div>
              </div>

              {/* Auto Driver */}
              <div className="col-md-4 text-center worker-illust-wrap">
                <div style={{ position:"relative", display:"inline-block" }}>
                  <ellipse className="worker-glow" cx="80" cy="90" rx="80" ry="80" fill="url(#gradGlow)" style={{ position:"absolute", top:0, left:0 }}/>
                  <svg viewBox="0 0 200 220" className="worker-illust" style={{ width:"170px", height:"187px", position:"relative", filter:"drop-shadow(0 8px 16px rgba(99,102,241,0.15))" }}>
                    <ellipse cx="100" cy="208" rx="55" ry="8" fill="#c7d2fe" opacity="0.5"/>
                    <path d="M45 195 v-55 a55 45 0 0 1 110 0 v55 z" fill="url(#gradAuto)"/>
                    <rect x="45" y="150" width="110" height="12" fill="#1e293b"/>
                    <circle cx="65" cy="195" r="15" fill="#1e293b"/>
                    <circle cx="135" cy="195" r="15" fill="#1e293b"/>
                    <circle cx="65" cy="195" r="6" fill="#cbd5e1"/>
                    <circle cx="135" cy="195" r="6" fill="#cbd5e1"/>
                    <rect x="55" y="105" width="90" height="50" rx="8" fill="#fffbeb" opacity="0.9"/>
                    <circle cx="100" cy="95" r="24" fill="url(#gradSkin)"/>
                    <path d="M76 90 a24 24 0 0 1 48 0 v-4 a24 18 0 0 0 -48 0 z" fill="#1e293b"/>
                    <rect x="88" y="120" width="24" height="28" rx="6" fill="#3b82f6"/>
                    <path d="M90 100 q10 6 20 0" stroke="#78350f" strokeWidth="2" fill="none" strokeLinecap="round"/>
                  </svg>
                </div>
                <div className="pub-svc-title mt-2">{t("Drivers","ஓட்டுநர்கள்")}</div>
              </div>

              {/* Manual Worker */}
              <div className="col-md-4 text-center worker-illust-wrap">
                <div style={{ position:"relative", display:"inline-block" }}>
                  <ellipse className="worker-glow" cx="80" cy="90" rx="80" ry="80" fill="url(#gradGlow)" style={{ position:"absolute", top:0, left:0 }}/>
                  <svg viewBox="0 0 200 220" className="worker-illust" style={{ width:"170px", height:"187px", position:"relative", filter:"drop-shadow(0 8px 16px rgba(99,102,241,0.15))" }}>
                    <ellipse cx="100" cy="208" rx="50" ry="8" fill="#c7d2fe" opacity="0.5"/>
                    <rect x="72" y="120" width="56" height="65" rx="16" fill="url(#gradShirt)"/>
                    <rect x="80" y="175" width="20" height="35" rx="6" fill="#1e293b"/>
                    <rect x="104" y="175" width="20" height="35" rx="6" fill="#1e293b"/>
                    <rect x="76" y="205" width="24" height="8" rx="3" fill="#0f172a"/>
                    <rect x="100" y="205" width="24" height="8" rx="3" fill="#0f172a"/>
                    <circle cx="100" cy="95" r="30" fill="url(#gradSkin)"/>
                    <path d="M72 88 q28 -34 56 0 v10 h-56 z" fill="#4c1d95"/>
                    <rect x="35" y="150" width="60" height="10" rx="5" fill="#78350f" transform="rotate(-25 65 155)"/>
                    <circle cx="35" cy="140" r="9" fill="#cbd5e1"/>
                    <rect x="132" y="128" width="16" height="45" rx="8" fill="url(#gradShirt)"/>
                    <circle cx="140" cy="185" r="14" fill="#f472b6"/>
                    <path d="M92 105 q8 5 16 0" stroke="#78350f" strokeWidth="2" fill="none" strokeLinecap="round"/>
                  </svg>
                </div>
                <div className="pub-svc-title mt-2">{t("Manual Workers","மற்ற வேலை செய்பவர்கள்")}</div>
              </div>

            </div>
          </div>
        </section>

        {/* SERVICES PREVIEW */}
        <section className="pub-section" style={{ background:"#fff",borderTop:"1px solid #f0f4ff" }}>
          <div style={{ maxWidth:"1280px",margin:"0 auto" }}>
            <div className="text-center mb-5">
              <div className="pub-eyebrow">{t("OUR SERVICES","எங்கள் சேவைகள்")}</div>
              <h2 className="pub-h2">{t("Welfare support for","நல உதவி")}{" "}<span className="pub-h2-grad">{t("every worker","ஒவ்வொரு தொழிலாளருக்கும்")}</span></h2>
              <p className="pub-section-sub">{t("We guide you through every step of the government welfare application process.","அரசு நல விண்ணப்ப செயல்முறையின் ஒவ்வொரு படியிலும் நாங்கள் உங்களுக்கு வழிகாட்டுகிறோம்.")}</p>
            </div>
            <div className="row g-4">
              {services.slice(0,6).map(s => (
                <div className="col-md-4" key={s.title}>
                  <div className="pub-svc-card">
                    <div className="pub-svc-icon">{s.icon}</div>
                    <div className="pub-svc-title">{s.title}</div>
                    <div className="pub-svc-text">{s.text}</div>
                  </div>
                </div>
              ))}
            </div>
            <div className="text-center mt-5">
              <button className="pub-btn-ghost" onClick={() => go("services")}>{t("View All Services →","அனைத்து சேவைகளும் காண →")}</button>
            </div>
          </div>
        </section>

        {/* HOW IT WORKS */}
        <section className="pub-section" style={{ background:"#f8fafc",borderTop:"1px solid #f0f4ff" }}>
          <div style={{ maxWidth:"1280px",margin:"0 auto" }}>
            <div className="text-center mb-5">
              <div className="pub-eyebrow">{t("HOW IT WORKS","எவ்வாறு செயல்படுகிறது")}</div>
              <h2 className="pub-h2">{t("Simple Clear","எளிமை தெளிவு")}{" "}<span className="pub-h2-grad">{t("Supportive","ஆதரவு")}</span></h2>
            </div>
            <div className="row g-3">
              {[
                ["01", t("Contact Us","தொடர்பு கொள்ளுங்கள்"), t("Reach us through phone, WhatsApp, or visit our Tenkasi office.","தொலைபேசி, WhatsApp மூலம் தொடர்பு கொள்ளுங்கள் அல்லது எங்கள் தென்காசி அலுவலகத்தை வாருங்கள்.")],
                ["02", t("Get Guidance","வழிகாட்டுதல் பெறுங்கள்"), t("Our team explains the scheme requirements clearly in simple terms.","எங்கள் குழு திட்ட தேவைகளை எளிய வார்த்தைகளில் தெளிவாக விளக்குகிறது.")],
                ["03", t("Prepare Documents","ஆவணங்கள் தயார்"), t("We guide you on exactly which documents are needed for your application.","உங்கள் விண்ணப்பத்திற்கு எந்த ஆவணங்கள் தேவை என்று சரியாக வழிகாட்டுகிறோம்.")],
                ["04", t("Application Support","விண்ணப்ப உதவி"), t("We assist you through the complete application process until completion.","விண்ணப்பம் முடியும் வரை முழு செயல்முறையிலும் நாங்கள் உங்களுக்கு உதவுகிறோம்.")],
              ].map(([n,title,desc]) => (
                <div className="col-md-6" key={n}>
                  <div className="pub-step">
                    <div className="pub-step-num">{n}</div>
                    <div className="pub-step-title">{title}</div>
                    <div className="pub-step-text">{desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* WHY US */}
        <section className="pub-section" style={{ background:"#fff",borderTop:"1px solid #f0f4ff" }}>
          <div style={{ maxWidth:"1280px",margin:"0 auto" }}>
            <div className="text-center mb-5">
              <div className="pub-eyebrow">{t("WHY CHOOSE US","ஏன் எங்களை தேர்வு செய்யணும்")}</div>
              <h2 className="pub-h2">{t("Guidance you can","நம்பகமான")}{" "}<span className="pub-h2-grad">{t("trust","வழிகாட்டுதல்")}</span></h2>
            </div>
            <div className="row g-4">
              {[
                ["🎯", t("Clear Guidance","தெளிவான வழிகாட்டுதல்"), t("No confusing jargon — we explain everything in simple, clear terms.","குழப்பமான வார்த்தைகள் இல்லாமல் — எல்லாவற்றையும் எளிமையாக விளக்குகிறோம்.")],
                ["📋", t("Document Assistance","ஆவண உதவி"), t("We tell you exactly what documents are needed and how to get them.","தேவையான ஆவணங்கள் என்னென்ன, எப்படி பெறுவது என்று சொல்கிறோம்.")],
                ["💬", t("Personal Support","தனிப்பட்ட உதவி"), t("Direct one-on-one help — not automated responses.","நேரடியான ஒருவர்-ஒருவர் உதவி — தானியங்கி பதில்கள் அல்ல.")],
                ["🏛️", t("Local Expertise","உள்ளூர் நிபுணத்துவம்"), t("Based in Tenkasi, we understand local worker welfare needs perfectly.","தென்காசியில் அமைந்துள்ள எங்களுக்கு உள்ளூர் தொழிலாளர் நல தேவைகள் நன்றாக தெரியும்.")],
              ].map(([icon,title,text]) => (
                <div className="col-md-3" key={title}>
                  <div className="pub-why-card">
                    <div style={{ fontSize:"26px",marginBottom:"12px" }}>{icon}</div>
                    <div className="pub-why-title">{title}</div>
                    <div className="pub-why-text">{text}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

      </>)}

      {/* ── SERVICES PAGE ── */}
      {publicPage === "services" && (
        <section className="pub-section" style={{ paddingTop:"120px" }}>
          <div style={{ maxWidth:"1280px",margin:"0 auto" }}>
            <div className="text-center mb-5">
              <div className="pub-eyebrow">{t("ALL SERVICES","அனைத்து சேவைகளும்")}</div>
                            <h1 className="pub-h2">{t("Every scheme.","ஒவ்வொரு திட்டமும்")}{" "}<span className="pub-h2-grad">{t("Clear guidance.","தெளிவான வழிகாட்டுதல்")}</span></h1>
              <p className="pub-section-sub">{t("We help construction and unorganised workers navigate every government welfare benefit available to them.","கட்டுமானம் மற்றும் அமைப்புசாரா தொழிலாளர்களுக்கு கிடைக்கும் அனைத்து அரசு நல சலுகைகளையும் பெற உதவுகிறோம்.")}</p>
            </div>
            <div className="row g-4">
              {services.map(s => (
                <div className="col-md-4" key={s.title}>
                  <div className="pub-svc-card" style={{ minHeight:"200px" }}>
                    <div className="pub-svc-icon">{s.icon}</div>
                    <div className="pub-svc-title">{s.title}</div>
                    <div className="pub-svc-text">{s.text}</div>
                  </div>
                </div>
              ))}
            </div>
            <div style={{ marginTop:"56px",padding:"36px",background:"#FFF3E6",border:"1px solid rgba(28,23,18,0.1)",borderTop:"3px solid #FFB238",borderRadius:"12px",textAlign:"center" }}>
              <div style={{ fontSize:"26px",marginBottom:"12px" }}>📞</div>
              <h3 style={{ color:"#1C1712",fontWeight:"700",marginBottom:"10px",letterSpacing:"-0.5px" }}>{t("Not sure which scheme applies to you?","எந்த திட்டம் உங்களுக்கு பொருந்தும் என்று தெரியவில்லையா?")}</h3>
              <p style={{ color:"#5c564e",marginBottom:"22px" }}>{t("Call us — we'll guide you to the right benefit for your situation.","அழைக்கவும் — உங்கள் நிலைக்கு சரியான சலுகையை நாங்கள் வழிகாட்டுவோம்.")}</p>
              <button className="pub-btn-primary" onClick={() => go("contact")}>{t("Contact Our Team →","எங்கள் குழுவை தொடர்பு கொள்ளுங்கள் →")}</button>
            </div>
          </div>
        </section>
      )}

      {/* ── ABOUT PAGE ── */}
      {publicPage === "about" && (
        <section className="pub-section" style={{ paddingTop:"120px" }}>
          <div style={{ maxWidth:"1280px",margin:"0 auto" }}>
            <div className="row align-items-start g-5">
              <div className="col-lg-6">
                <div className="pub-eyebrow">{t("ABOUT SBM UDHAYAM","SBM உதயம் பற்றி")}</div>
                <h1 className="pub-h2">{t("Built to support","உங்களைப் போன்ற")}{" "}<span className="pub-h2-grad">{t("workers like you","தொழிலாளர்களுக்கான ஆதரவு")}</span></h1>
                <p style={{ color:"#64748b",fontSize:"16px",lineHeight:"1.8",marginBottom:"18px" }}>
                  {t(
                    "SBM Udhayam is a welfare support organization based in Tenkasi, Tamil Nadu. We specialize in helping construction workers, auto drivers, and other unorganised workers understand and access their government welfare benefits.",
                    "SBM உதயம் தமிழ்நாட்டின் தென்காசியில் அமைந்த ஒரு நல ஆதரவு அமைப்பு. கட்டுமான தொழிலாளர்கள், ஆட்டோ ஓட்டுனர்கள் மற்றும் பிற அமைப்புசாரா தொழிலாளர்கள் தங்களுக்கு உரிய அரசு நல சேவைகளை புரிந்துகொண்டு பெறுவதற்கு உதவுகிறோம்."
                  )}
                </p>
                <p style={{ color:"#64748b",fontSize:"16px",lineHeight:"1.8",marginBottom:"30px" }}>
                  {t(
                    "Our team provides personal, one-on-one guidance through registration, renewal, and welfare benefit applications — making sure no worker is left behind.",
                    "எங்கள் குழு பதிவு, புதுப்பித்தல் மற்றும் நல விண்ணப்பங்கள் மூலம் தனிப்பட்ட வழிகாட்டுதல் வழங்குகிறது — எந்த தொழிலாளரும் பின்தங்காமல் உறுதி செய்கிறோம்."
                  )}
                </p>
                <div style={{ display:"flex",gap:"12px",flexWrap:"wrap" }}>
                  {[
                    [t("Construction Welfare","கட்டுமான நலன்"),"🏗️"],
                    [t("Driver Welfare","ஓட்டுனர் நலன்"),"🚗"],
                    [t("Manual Workers","கையால் வேலை செய்பவர்"),"⚒️"]
                  ].map(([l,i]) => (
                    <div key={l} style={{ padding:"9px 16px",background:"rgba(99,102,241,0.08)",border:"1px solid rgba(99,102,241,0.15)",borderRadius:"99px",color:"#818cf8",fontSize:"13px",fontWeight:"600" }}>
                      {i} {l}
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="pub-about-box">
                  <div className="pub-mission-block">
                    <div style={{ color:"#C94B3C",fontWeight:"700",fontSize:"11px",letterSpacing:"1px",marginBottom:"10px" }}>🎯 {t("OUR MISSION","எங்கள் நோக்கம்")}</div>
                    <p style={{ color:"#475569",fontSize:"15px",lineHeight:"1.7",margin:0 }}>
                      {t(
                        "To make welfare service information accessible and understandable for every worker — removing barriers created by complex processes.",
                        "ஒவ்வொரு தொழிலாளருக்கும் நல சேவை தகவல்களை அணுகக்கூடியதாகவும் புரிந்துகொள்ளக்கூடியதாகவும் மாற்றுவது — சிக்கலான செயல்முறைகள் உருவாக்கும் தடைகளை நீக்குவது."
                      )}
                    </p>
                  </div>
                  <div className="pub-mission-block" style={{ marginBottom:0 }}>
                    <div style={{ color:"#FFB238",fontWeight:"700",fontSize:"11px",letterSpacing:"1px",marginBottom:"10px" }}>🌟 {t("OUR VISION","எங்கள் தொலைநோக்கு")}</div>
                    <p style={{ color:"#475569",fontSize:"15px",lineHeight:"1.7",margin:0 }}>
                      {t(
                        "A Tamil Nadu where every unorganised worker gets the welfare support they're entitled to — without confusion or delays.",
                        "ஒவ்வொரு அமைப்புசாரா தொழிலாளரும் தங்களுக்கு உரிய நல ஆதரவை குழப்பம் அல்லது தாமதமின்றி பெறும் ஒரு தமிழ்நாடு."
                      )}
                    </p>
                  </div>
                  <div style={{ marginTop:"22px",display:"flex",gap:"10px" }}>
                    {[
                      ["9+",t("Welfare Schemes","நல திட்டங்கள்")],
                      ["3",t("Worker Categories","தொழிலாளர் வகைகள்")],
                      ["📍",t("Tenkasi, TN","தென்காசி")]
                    ].map(([n,l]) => (
                      <div key={l} style={{ flex:1,padding:"14px",background:"rgba(255,255,255,0.7)",border:"1px solid #e2e8f0",borderRadius:"12px",textAlign:"center" }}>
                        <div style={{ fontSize:"22px",fontWeight:"800",color:"#0f172a" }}>{n}</div>
                        <div style={{ fontSize:"11px",color:"#94a3b8",marginTop:"4px" }}>{l}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* ── CONTACT PAGE ── */}
      {publicPage === "contact" && (
        <section className="pub-section" style={{ paddingTop:"120px" }}>
          <div style={{ maxWidth:"1280px",margin:"0 auto" }}>
            <div className="text-center mb-5">
              <div className="pub-eyebrow">{t("CONTACT US","தொடர்பு கொள்ளுங்கள்")}</div>
              <h1 className="pub-h2">{t("We're here to","மேலும் ")}{" "}<span className="pub-h2-grad">{t("help you.","உதவிக்கு")}</span></h1>
              <p className="pub-section-sub">{t("Reach out for free guidance on any government welfare scheme for construction and unorganised workers.","கட்டுமானம் மற்றும் அமைப்புசாரா தொழிலாளர்களுக்கான எந்த அரசு நல திட்டத்திற்கும் இலவச வழிகாட்டுதலுக்கு தொடர்பு கொள்ளுங்கள்.")}</p>
            </div>

            <div className="row g-4">
              <div className="col-lg-4">
                <div className="pub-contact-card">
                  <div className="pub-contact-icon" style={{ background:"rgba(255,178,56,0.15)",border:"1px solid rgba(255,178,56,0.3)" }}>📞</div>
                  <h4 style={{ color:"#1C1712",fontWeight:"700",marginBottom:"8px" }}>{t("Call Us","அழைக்கவும்")}</h4>
                  <p style={{ color:"#5c564e",fontSize:"14px",lineHeight:"1.7",marginBottom:"18px" }}>{t("Speak directly with our team for welfare guidance — Mon to Sat, 9.30am to 6.30pm.","திங்கள் - சனி, காலை 9.30 மணி - மாலை 6.30 மணி வரை நேரடியாக பேசுங்கள்.")}</p>
                  <a href="tel:+918123454322" style={{ color:"#C94B3C",fontWeight:"700",textDecoration:"none",fontSize:"18px" }}>+91 81234 54322</a>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="pub-contact-card">
                  <div className="pub-contact-icon" style={{ background:"rgba(37,211,102,0.1)",border:"1px solid rgba(37,211,102,0.2)" }}>💬</div>
                  <h4 style={{ color:"#0f172a",fontWeight:"700",marginBottom:"8px" }}>WhatsApp</h4>
                  <p style={{ color:"#64748b",fontSize:"14px",lineHeight:"1.7",marginBottom:"18px" }}>{t("Send us a message and our team will respond quickly to guide you.","செய்தி அனுப்பவும், எங்கள் குழு விரைவாக பதில் அளிக்கும்.")}</p>
                  <a href="https://wa.me/918123454322" target="_blank" rel="noreferrer" style={{ color:"#16a34a",fontWeight:"700",textDecoration:"none",fontSize:"16px" }}>{t("Chat on WhatsApp →","WhatsApp-ல் பேசுங்கள் →")}</a>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="pub-contact-card">
                  <div className="pub-contact-icon" style={{ background:"rgba(239,68,68,0.08)",border:"1px solid rgba(239,68,68,0.18)" }}>📍</div>
                  <h4 style={{ color:"#0f172a",fontWeight:"700",marginBottom:"8px" }}>{t("Visit Us","நேரில் வாருங்கள்")}</h4>
                  <p style={{ color:"#64748b",fontSize:"14px",lineHeight:"1.7",marginBottom:"18px" }}>{t("Come visit our office directly in Tenkasi for in-person guidance.","நேரடி வழிகாட்டுதலுக்கு தென்காசியில் உள்ள எங்கள் அலுவலகத்திற்கு வாருங்கள்.")}</p>
                  <div style={{ color:"#ef4444",fontWeight:"600",fontSize:"14px",lineHeight:"1.6" }}>SBM Udhayam,<br/>MelaMutharamman Kovil Street,<br/>Tenkasi — 627 811</div>
                </div>
              </div>
            </div>

            {/* ENQUIRY FORM */}
            <div style={{ maxWidth:"580px",margin:"48px auto 0" }}>
              <div style={{ background:"#fff",border:"1px solid #e2e8f0",borderRadius:"22px",padding:"36px",boxShadow:"0 4px 24px rgba(0,0,0,0.06)" }}>
                <div className="pub-eyebrow" style={{ marginBottom:"6px" }}>{t("QUICK ENQUIRY","விரைவு விசாரணை")}</div>
                <h3 style={{ color:"#0f172a",fontWeight:"800",marginBottom:"22px",letterSpacing:"-0.5px" }}>{t("Send us a WhatsApp message","WhatsApp செய்தி அனுப்புங்கள்")}</h3>
                <input className="pub-enquiry-input" placeholder={t("Your Name *","உங்கள் பெயர் *")} value={enquiry.name} onChange={e => setEnquiry({...enquiry,name:e.target.value})} />
                <input className="pub-enquiry-input" placeholder={t("Mobile Number *","மொபைல் எண் *")} value={enquiry.mobile} onChange={e => setEnquiry({...enquiry,mobile:e.target.value})} />
                <select className="pub-enquiry-input" value={enquiry.service} onChange={e => setEnquiry({...enquiry,service:e.target.value})} style={{ appearance:"none" }}>
                  <option value="">{t("Select Service *","சேவை தேர்ந்தெடுக்கவும் *")}</option>
                  {services.map(s => <option key={s.title} value={s.title}>{s.icon} {s.title}</option>)}
                </select>
                <textarea className="pub-enquiry-input" placeholder={t("Message (optional)","செய்தி (விருப்பமானது)")} rows={3} style={{ resize:"vertical" }} value={enquiry.message} onChange={e => setEnquiry({...enquiry,message:e.target.value})} />
                <button className="pub-enquiry-btn" onClick={sendWhatsAppEnquiry}>💬 {t("Send WhatsApp Enquiry","WhatsApp விசாரணை அனுப்பவும்")}</button>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* ── FOOTER ── */}
      <footer className="pub-footer">
        <div style={{ maxWidth:"1280px",margin:"0 auto" }}>
          <div className="row g-4">
            <div className="col-md-5">
                           <div style={{ display:"flex",alignItems:"center",gap:"10px",marginBottom:"12px" }}>
                <div style={{ width:"30px",height:"30px",background:"linear-gradient(135deg,#FF6B4A,#FFB238)",borderRadius:"8px",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"15px" }}>🏛️</div>
                <div style={{ fontSize:"17px",fontFamily:"'Space Grotesk'",fontWeight:"700",color:"#FFF3E6",letterSpacing:"-0.3px" }}>SBM UDHAYAM</div>
              </div>
              <div style={{ color:"#b9c2d8",fontSize:"13px",lineHeight:"1.7",maxWidth:"280px" }}>
                {t("Supporting construction and unorganised workers with welfare service guidance. Tenkasi, Tamil Nadu.","கட்டுமானம் மற்றும் அமைப்புசாரா தொழிலாளர்களுக்கு நல சேவை வழிகாட்டுதல் வழங்குகிறோம். தென்காசி, தமிழ்நாடு.")}
              </div>
            </div>
            <div className="col-md-3">
              <div style={{ fontSize:"11px",fontWeight:"700",color:"#FFB238",letterSpacing:"1px",marginBottom:"12px" }}>{t("NAVIGATE","வழிசெலுத்தல்")}</div>
              {navLinks.map(([p,l]) => (
                <button key={p} className="pub-footer-link" onClick={() => go(p)}>{l}</button>
              ))}
            </div>
            <div className="col-md-4">
              <div style={{ fontSize:"11px",fontWeight:"700",color:"#FFB238",letterSpacing:"1px",marginBottom:"12px" }}>{t("CONTACT","தொடர்பு")}</div>
              <div style={{ color:"#b9c2d8",fontSize:"14px",lineHeight:"1.9" }}>
                <div>📞 +91 81234 54322</div>
                <div>📍 MelaMutharamman Kovil St, Tenkasi</div>
                <a href="https://wa.me/918123454322" target="_blank" rel="noreferrer" style={{ color:"#FFB238",fontWeight:"600",textDecoration:"none",display:"block",marginTop:"8px" }}>💬 {t("WhatsApp Us","WhatsApp அனுப்பவும்")}</a>
              </div>
            </div>
          </div>
          <hr className="pub-divider"/>
          <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:"10px" }}>
            <div style={{ color:"#8a92a8",fontSize:"12px" }}>© 2026 SBM Udhayam. {t("All Rights Reserved.","அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.")}</div>
            <button onClick={onStaffLogin} style={{ background:"none",border:"1px solid rgba(255,243,230,0.2)",color:"#F3E4D2",padding:"7px 16px",borderRadius:"8px",fontSize:"12px",cursor:"pointer",fontFamily:"Inter,sans-serif" }}>
              {t("Staff Portal →"," அலுவலர் உள்நுழைவு →")}
            </button>
          </div>
        </div>
      </footer>

      <a href="https://wa.me/918123454322" target="_blank" rel="noreferrer" className="pub-wa-float">💬</a>

    </div>
  );
};

function LocationManager({ db, onLocationsUpdated, showToast }) {
  const [locations, setLocations] = useState([]);
  const [newLocation, setNewLocation] = useState("");
  const [editLocId, setEditLocId] = useState(null);
  const [editLocName, setEditLocName] = useState("");

  useEffect(() => { fetchLocs(); }, []);

  const fetchLocs = async () => {
    const querySnapshot = await getDocs(collection(db, "locations"));
    const data = [];
    querySnapshot.forEach((doc) => { data.push({ firestoreId: doc.id, ...doc.data() }); });
    data.sort((a, b) => a.name.localeCompare(b.name));
    setLocations(data);
  };

  const addLocation = async () => {
    const trimmed = newLocation.trim();
    if (!trimmed) { showToast("Enter location name", "error"); return; }
    const exists = locations.find(l => l.name.toLowerCase() === trimmed.toLowerCase());
    if (exists) { showToast("Location already exists!", "error"); return; }
    try {
      await addDoc(collection(db, "locations"), { name: trimmed });
      setNewLocation("");
      await fetchLocs();
      onLocationsUpdated();
      showToast("Location Added!");
    } catch (error) {
      console.error(error);
      showToast("Failed to add location: " + error.message, "error");
    }
  };

  const saveEditLocation = async () => {
    const trimmed = editLocName.trim();
    if (!trimmed) { showToast("Enter location name", "error"); return; }
    const exists = locations.find(l => l.name.toLowerCase() === trimmed.toLowerCase() && l.firestoreId !== editLocId);
    if (exists) { showToast("Location already exists!", "error"); return; }
    const confirmed = window.confirm(`Save location as "${trimmed}"? This will update all existing records.`);
    if (!confirmed) return;
    try {
      await updateDoc(doc(db, "locations", editLocId), { name: trimmed });
    } catch (error) {
      console.log(error);
      showToast("Location Update Failed");
      return;
    }
    const oldLoc = locations.find(l => l.firestoreId === editLocId);
    if (oldLoc) {
      const customersSnap = await getDocs(collection(db, "customers"));
      const batch = [];
      customersSnap.forEach((d) => {
        if (d.data().location === oldLoc.name) {
          batch.push(updateDoc(doc(db, "customers", d.id), { location: trimmed }));
        }
      });
      await Promise.all(batch);
    }
    setEditLocId(null);
    setEditLocName("");
    await fetchLocs();
    onLocationsUpdated();
    showToast("Location updated in all records!");
  };

  const deleteLocation = async (id, name) => {
    const confirmed = window.confirm(`Delete location "${name}"?`);
    if (!confirmed) return;
    await deleteDoc(doc(db, "locations", id));
    await fetchLocs();
    onLocationsUpdated();
    showToast("Location Deleted!");
  };

  return (
    <div className="mt-4">
      <div className="card shadow p-4 mb-4">
        <h5>Add New Location</h5>
        <div className="d-flex gap-2 mt-3">
          <input
            type="text"
            className="form-control"
            placeholder="Enter location name"
            value={newLocation}
            onChange={(e) => setNewLocation(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && addLocation()}
          />
          <button className="btn btn-success" onClick={addLocation}>Add</button>
        </div>
      </div>
      <div className="card shadow p-4">
        <h5>Location List ({locations.length})</h5>
        <table className="table table-bordered mt-3">
          <thead className="table-success">
            <tr><th>#</th><th>Location Name</th><th>Action</th></tr>
          </thead>
          <tbody>
            {locations.map((loc, i) => (
              <tr key={loc.firestoreId}>
                <td>{i + 1}</td>
                <td>
                  {editLocId === loc.firestoreId ? (
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={editLocName}
                      onChange={(e) => setEditLocName(e.target.value)}
                      onKeyDown={(e) => e.key === "Enter" && saveEditLocation()}
                      autoFocus
                    />
                  ) : (
                    <>📍 {loc.name}</>
                  )}
                </td>
                <td>
                  <div className="d-flex gap-2">
                    {editLocId === loc.firestoreId ? (
                      <>
                        <button className="btn btn-success btn-sm" onClick={saveEditLocation}>Save</button>
                        <button className="btn btn-secondary btn-sm" onClick={() => { setEditLocId(null); setEditLocName(""); }}>Cancel</button>
                      </>
                    ) : (
                      <>
                        <button className="btn btn-outline-primary btn-sm" onClick={() => { setEditLocId(loc.firestoreId); setEditLocName(loc.name); }}>Edit</button>
                        <button className="btn btn-outline-danger btn-sm" onClick={() => deleteLocation(loc.firestoreId, loc.name)}>Delete</button>
                      </>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function ServiceCategoryManager({ db, onUpdated, showToast }) {
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const [editCatId, setEditCatId] = useState(null);
  const [editCatName, setEditCatName] = useState("");

  useEffect(() => { fetchCats(); }, []);

  const fetchCats = async () => {
    const querySnapshot = await getDocs(collection(db, "serviceCategories"));
    const data = [];
    querySnapshot.forEach((doc) => { data.push({ firestoreId: doc.id, ...doc.data() }); });
    data.sort((a, b) => a.name.localeCompare(b.name));
    setCategories(data);
  };

  const addCategory = async () => {
    const trimmed = newCategory.trim();
    if (!trimmed) { showToast("Enter category name", "error"); return; }
    const exists = categories.find(c => c.name.toLowerCase() === trimmed.toLowerCase());
    if (exists) { showToast("Category already exists!", "error"); return; }
    await addDoc(collection(db, "serviceCategories"), { name: trimmed });
    setNewCategory("");
    await fetchCats();
    onUpdated();
    showToast("Category Added!");
  };

  const saveEditCategory = async () => {
    const trimmed = editCatName.trim();
    if (!trimmed) { showToast("Enter category name", "error"); return; }
    await updateDoc(doc(db, "serviceCategories", editCatId), { name: trimmed });
    setEditCatId(null);
    setEditCatName("");
    await fetchCats();
    onUpdated();
    showToast("Category Updated!");
  };

  const deleteCategory = async (id, name) => {
    const confirmed = window.confirm(`Delete category "${name}"?`);
    if (!confirmed) return;
    await deleteDoc(doc(db, "serviceCategories", id));
    await fetchCats();
    onUpdated();
    showToast("Category Deleted!");
  };

  return (
    <div className="mt-4">
      <div className="card shadow p-4 mb-4">
        <h5>Add New Service Category</h5>
        <div className="d-flex gap-2 mt-3">
          <input
            type="text"
            className="form-control"
            placeholder="Enter category name"
            value={newCategory}
            onChange={(e) => setNewCategory(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && addCategory()}
          />
          <button className="btn btn-success" onClick={addCategory}>Add</button>
        </div>
      </div>
      <div className="card shadow p-4">
        <h5>Service Category List ({categories.length})</h5>
        <table className="table table-bordered mt-3">
          <thead className="table-success">
            <tr><th>#</th><th>Category Name</th><th>Action</th></tr>
          </thead>
          <tbody>
            {categories.map((cat, i) => (
              <tr key={cat.firestoreId}>
                <td>{i + 1}</td>
                <td>
                  {editCatId === cat.firestoreId ? (
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={editCatName}
                      onChange={(e) => setEditCatName(e.target.value)}
                      onKeyDown={(e) => e.key === "Enter" && saveEditCategory()}
                      autoFocus
                    />
                  ) : (
                    <>🧾 {cat.name}</>
                  )}
                </td>
                <td>
                  <div className="d-flex gap-2">
                    {editCatId === cat.firestoreId ? (
                      <>
                        <button className="btn btn-success btn-sm" onClick={saveEditCategory}>Save</button>
                        <button className="btn btn-secondary btn-sm" onClick={() => { setEditCatId(null); setEditCatName(""); }}>Cancel</button>
                      </>
                    ) : (
                      <>
                        <button className="btn btn-outline-primary btn-sm" onClick={() => { setEditCatId(cat.firestoreId); setEditCatName(cat.name); }}>Edit</button>
                        <button className="btn btn-outline-danger btn-sm" onClick={() => deleteCategory(cat.firestoreId, cat.name)}>Delete</button>
                      </>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function AmountCategoryManager({ db, onUpdated, showToast }) {
  const [amountCategories, setAmountCategories] = useState([]);
  const [newCatName, setNewCatName] = useState("");
  const [newCatAmount, setNewCatAmount] = useState("");
  const [editAmtCatId, setEditAmtCatId] = useState(null);
  const [editAmtCatAmount, setEditAmtCatAmount] = useState("");

  useEffect(() => { fetchAmtCats(); }, []);

  const fetchAmtCats = async () => {
    const querySnapshot = await getDocs(collection(db, "amountCategories"));
    const data = [];
    querySnapshot.forEach((doc) => { data.push({ firestoreId: doc.id, ...doc.data() }); });
    data.sort((a, b) => a.name.localeCompare(b.name));
    setAmountCategories(data);
  };

  const addAmtCat = async () => {
    const trimmed = newCatName.trim();
    if (!trimmed || !newCatAmount) { showToast("Category name and Amount are required"); return; }
    const exists = amountCategories.find(c => c.name.toLowerCase() === trimmed.toLowerCase());
    if (exists) { showToast("Category already exists!", "error"); return; }
    await addDoc(collection(db, "amountCategories"), { name: trimmed, amount: Number(newCatAmount) });
    setNewCatName("");
    setNewCatAmount("");
    await fetchAmtCats();
    onUpdated();
    showToast("Category Added!");
  };

  const saveEditAmtCat = async (id) => {
    if (!editAmtCatAmount) { showToast("Enter amount", "error"); return; }
    await updateDoc(doc(db, "amountCategories", id), { amount: Number(editAmtCatAmount) });
    setEditAmtCatId(null);
    setEditAmtCatAmount("");
    await fetchAmtCats();
    onUpdated();
    showToast("Amount Updated!");
  };

  const deleteAmtCat = async (id, name) => {
    const confirmed = window.confirm(`Delete category "${name}"?`);
    if (!confirmed) return;
    await deleteDoc(doc(db, "amountCategories", id));
    await fetchAmtCats();
    onUpdated();
    showToast("Category Deleted!");
  };

  return (
    <div className="mt-4">
      <div className="card shadow p-4 mb-4">
        <h5>Add New "Applying For" Category with Fixed Amount</h5>
        <div className="row mt-3">
          <div className="col-md-6 mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Category name (e.g. New, Marriage, Pension)"
              value={newCatName}
              onChange={(e) => setNewCatName(e.target.value)}
            />
          </div>
          <div className="col-md-4 mb-3">
            <input
              type="number"
              className="form-control"
              placeholder="Fixed Amount (₹)"
              value={newCatAmount}
              onChange={(e) => setNewCatAmount(e.target.value)}
            />
          </div>
          <div className="col-md-2">
            <button className="btn btn-success w-100" onClick={addAmtCat}>Add</button>
          </div>
        </div>
      </div>
      <div className="card shadow p-4">
        <h5>Categories ({amountCategories.length})</h5>
        <table className="table table-bordered mt-3">
          <thead className="table-success">
            <tr><th>#</th><th>Category Name</th><th>Fixed Amount</th><th>Action</th></tr>
          </thead>
          <tbody>
            {amountCategories.map((cat, i) => (
              <tr key={cat.firestoreId}>
                <td>{i + 1}</td>
                <td>💰 {cat.name}</td>
                <td>
                  {editAmtCatId === cat.firestoreId ? (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      value={editAmtCatAmount}
                      onChange={(e) => setEditAmtCatAmount(e.target.value)}
                      autoFocus
                    />
                  ) : (
                    <>₹{cat.amount}</>
                  )}
                </td>
                <td>
                  <div className="d-flex gap-2">
                    {editAmtCatId === cat.firestoreId ? (
                      <>
                        <button className="btn btn-success btn-sm" onClick={() => saveEditAmtCat(cat.firestoreId)}>Save</button>
                        <button className="btn btn-secondary btn-sm" onClick={() => { setEditAmtCatId(null); setEditAmtCatAmount(""); }}>Cancel</button>
                      </>
                    ) : (
                      <>
                        <button className="btn btn-outline-primary btn-sm" onClick={() => { setEditAmtCatId(cat.firestoreId); setEditAmtCatAmount(String(cat.amount)); }}>Edit</button>
                        <button className="btn btn-outline-danger btn-sm" onClick={() => deleteAmtCat(cat.firestoreId, cat.name)}>Delete</button>
                      </>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function ExpenseCategoryManager({ db, onUpdated, showToast }) {
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const [editCatId, setEditCatId] = useState(null);
  const [editCatName, setEditCatName] = useState("");

  useEffect(() => { fetchCats(); }, []);

  const fetchCats = async () => {
    const querySnapshot = await getDocs(collection(db, "expenseCategories"));
    const data = [];
    querySnapshot.forEach((doc) => { data.push({ firestoreId: doc.id, ...doc.data() }); });
    data.sort((a, b) => a.name.localeCompare(b.name));
    setCategories(data);
  };

  const addCategory = async () => {
    const trimmed = newCategory.trim();
    if (!trimmed) { showToast("Enter category name", "error"); return; }
    const exists = categories.find(c => c.name.toLowerCase() === trimmed.toLowerCase());
    if (exists) { showToast("Category already exists!", "error"); return; }
    await addDoc(collection(db, "expenseCategories"), { name: trimmed });
    setNewCategory("");
    await fetchCats();
    onUpdated();
    showToast("Category Added!");
  };

  const saveEditCategory = async () => {
    const trimmed = editCatName.trim();
    if (!trimmed) { showToast("Enter category name", "error"); return; }
    await updateDoc(doc(db, "expenseCategories", editCatId), { name: trimmed });
    setEditCatId(null);
    setEditCatName("");
    await fetchCats();
    onUpdated();
    showToast("Category Updated!");
  };

  const deleteCategory = async (id, name) => {
    const confirmed = window.confirm(`Delete category "${name}"?`);
    if (!confirmed) return;
    await deleteDoc(doc(db, "expenseCategories", id));
    await fetchCats();
    onUpdated();
    showToast("Category Deleted!");
  };

  return (
    <div className="mt-4">
      <div className="card shadow p-4 mb-4">
        <h5>Add New Expense Category</h5>
        <div className="d-flex gap-2 mt-3">
          <input
            type="text"
            className="form-control"
            placeholder="Enter category name"
            value={newCategory}
            onChange={(e) => setNewCategory(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && addCategory()}
          />
          <button className="btn btn-success" onClick={addCategory}>Add</button>
        </div>
      </div>
      <div className="card shadow p-4">
        <h5>Expense Category List ({categories.length})</h5>
        <table className="table table-bordered mt-3">
          <thead className="table-success">
            <tr><th>#</th><th>Category Name</th><th>Action</th></tr>
          </thead>
          <tbody>
            {categories.map((cat, i) => (
              <tr key={cat.firestoreId}>
                <td>{i + 1}</td>
                <td>
                  {editCatId === cat.firestoreId ? (
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={editCatName}
                      onChange={(e) => setEditCatName(e.target.value)}
                      onKeyDown={(e) => e.key === "Enter" && saveEditCategory()}
                      autoFocus
                    />
                  ) : (
                    <>🔴 {cat.name}</>
                  )}
                </td>
                <td>
                  <div className="d-flex gap-2">
                    {editCatId === cat.firestoreId ? (
                      <>
                        <button className="btn btn-success btn-sm" onClick={saveEditCategory}>Save</button>
                        <button className="btn btn-secondary btn-sm" onClick={() => { setEditCatId(null); setEditCatName(""); }}>Cancel</button>
                      </>
                    ) : (
                      <>
                        <button className="btn btn-outline-primary btn-sm" onClick={() => { setEditCatId(cat.firestoreId); setEditCatName(cat.name); }}>Edit</button>
                        <button className="btn btn-outline-danger btn-sm" onClick={() => deleteCategory(cat.firestoreId, cat.name)}>Delete</button>
                      </>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function LoanManager({ db, showToast }) {
  const [loans, setLoans] = useState([]);
  const [repayments, setRepayments] = useState([]);
  const [lenderName, setLenderName] = useState("");
  const [loanAmount, setLoanAmount] = useState("");
  const [loanDate, setLoanDate] = useState("");
  const [loanNotes, setLoanNotes] = useState("");
  const [expandedLoanId, setExpandedLoanId] = useState(null);
  const [repayAmount, setRepayAmount] = useState("");
  const [repayDate, setRepayDate] = useState("");
  const [repayNotes, setRepayNotes] = useState("");

  useEffect(() => { fetchLoans(); fetchRepayments(); }, []);

  const getTodayStr = () => {
    const d = new Date();
    return String(d.getDate()).padStart(2,"0") + "/" + String(d.getMonth()+1).padStart(2,"0") + "/" + d.getFullYear();
  };

  const fetchLoans = async () => {
    const querySnapshot = await getDocs(collection(db, "loans"));
    const data = [];
    querySnapshot.forEach((doc) => { data.push({ firestoreId: doc.id, ...doc.data() }); });
    data.sort((a, b) => {
      const da = a.date ? a.date.split("/").reverse().join("-") : "";
      const db2 = b.date ? b.date.split("/").reverse().join("-") : "";
      return new Date(db2) - new Date(da);
    });
    setLoans(data);
  };

  const fetchRepayments = async () => {
    const querySnapshot = await getDocs(collection(db, "loanRepayments"));
    const data = [];
    querySnapshot.forEach((doc) => { data.push({ firestoreId: doc.id, ...doc.data() }); });
    setRepayments(data);
  };

  const addLoan = async () => {
    if (!lenderName.trim() || !loanAmount) { showToast("Lender name and Amount தேவை", "error"); return; }
    await addDoc(collection(db, "loans"), {
      lender: lenderName.trim(),
      amount: Number(loanAmount),
      date: loanDate || getTodayStr(),
      notes: loanNotes,
      createdAt: new Date().toISOString()
    });
    setLenderName(""); setLoanAmount(""); setLoanDate(""); setLoanNotes("");
    fetchLoans();
    showToast("Loan Added!");
  };

  const deleteLoan = async (id, lender) => {
    if (!window.confirm(`"${lender}" loan-ஐ delete பண்ணலாமா? இதனுடன் தொடர்புடைய repayments-ம் delete ஆகும்.`)) return;
    await deleteDoc(doc(db, "loans", id));
    const relatedRepayments = repayments.filter(r => r.loanId === id);
    for (const r of relatedRepayments) {
      await deleteDoc(doc(db, "loanRepayments", r.firestoreId));
    }
    fetchLoans();
    fetchRepayments();
    showToast("Loan Deleted!");
  };

  const addRepayment = async (loanId) => {
    if (!repayAmount || !repayDate) { showToast("Amount and Date தேவை", "error"); return; }
    await addDoc(collection(db, "loanRepayments"), {
      loanId,
      amount: Number(repayAmount),
      date: repayDate,
      notes: repayNotes,
      createdBy: localStorage.getItem("loggedUser"),
      createdAt: new Date().toISOString()
    });
    setRepayAmount(""); setRepayDate(""); setRepayNotes("");
    fetchRepayments();
    showToast("Repayment Added!");
  };

  const deleteRepayment = async (id) => {
    if (!window.confirm("இந்த repayment-ஐ delete பண்ணலாமா?")) return;
    await deleteDoc(doc(db, "loanRepayments", id));
    fetchRepayments();
    showToast("Repayment Deleted!");
  };

  const totalLoanAmount = loans.reduce((t, l) => t + Number(l.amount || 0), 0);
  const totalRepaid = repayments.reduce((t, r) => t + Number(r.amount || 0), 0);
  const totalOutstanding = totalLoanAmount - totalRepaid;

  return (
    <div className="mt-4">
      <div className="row g-3 mb-4">
        <div className="col-md-4">
          <div className="card shadow p-4 text-center">
            <h6 className="text-muted">💵 Total Loans Taken</h6>
            <h2 style={{ color: "#2563eb" }}>₹{totalLoanAmount.toLocaleString()}</h2>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card shadow p-4 text-center">
            <h6 className="text-muted">✅ Total Repaid</h6>
            <h2 style={{ color: "#22c55e" }}>₹{totalRepaid.toLocaleString()}</h2>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card shadow p-4 text-center">
            <h6 className="text-muted">⚠️ Outstanding Balance</h6>
            <h2 style={{ color: totalOutstanding > 0 ? "#ef4444" : "#22c55e" }}>₹{totalOutstanding.toLocaleString()}</h2>
          </div>
        </div>
      </div>

      <div className="card shadow p-4 mb-4">
        <h5>➕ Add New Loan</h5>
        <div className="row mt-3">
          <div className="col-md-3 mb-3">
            <label>Lender Name <span className="text-danger">*</span></label>
            <input type="text" className="form-control" placeholder="Enter lender name" value={lenderName} onChange={(e) => setLenderName(e.target.value)} />
          </div>
          <div className="col-md-3 mb-3">
            <label>Loan Amount <span className="text-danger">*</span></label>
            <input type="number" className="form-control" placeholder="Amount" value={loanAmount} onChange={(e) => setLoanAmount(e.target.value)} />
          </div>
          <div className="col-md-3 mb-3">
            <label>Date</label>
            <input type="text" className="form-control" placeholder="DD/MM/YYYY" maxLength={10} value={loanDate}
              onChange={(e) => {
                let v = e.target.value.replace(/[^0-9]/g, "");
                if (v.length > 2) v = v.slice(0,2) + "/" + v.slice(2);
                if (v.length > 5) v = v.slice(0,5) + "/" + v.slice(5);
                setLoanDate(v.slice(0,10));
              }}
            />
          </div>
          <div className="col-md-3 mb-3">
            <label>Notes</label>
            <input type="text" className="form-control" placeholder="Optional notes" value={loanNotes} onChange={(e) => setLoanNotes(e.target.value)} />
          </div>
          <div className="col-md-12">
            <button className="btn btn-primary" onClick={addLoan}>Add Loan</button>
          </div>
        </div>
      </div>

      <div className="card shadow p-4">
        <h5>📋 Loan List ({loans.length})</h5>
        {loans.length === 0 ? (
          <p className="text-muted">No loans recorded</p>
        ) : (
          loans.map((loan) => {
            const parseRepayDate = (s) => {
              if (!s) return new Date(0);
              const p = s.split("/");
              if (p.length === 3) return new Date(Number(p[2]), Number(p[1]) - 1, Number(p[0]));
              return new Date(s);
            };
            const loanRepayments = repayments.filter(r => r.loanId === loan.firestoreId).sort((a,b) => parseRepayDate(a.date) - parseRepayDate(b.date));
            const repaid = loanRepayments.reduce((t, r) => t + Number(r.amount || 0), 0);
            const outstanding = Number(loan.amount) - repaid;
            const isExpanded = expandedLoanId === loan.firestoreId;
            return (
              <div key={loan.firestoreId} className="card border mb-3 p-3">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                  <div>
                    <h6 className="mb-1">👤 {loan.lender}</h6>
                    <small className="text-muted">Loan Date: {loan.date} {loan.notes && `| ${loan.notes}`}</small>
                  </div>
                  <div className="d-flex gap-3 align-items-center">
                    <div style={{ textAlign: "center" }}>
                      <small className="text-muted d-block">Loan Amount</small>
                      <strong>₹{loan.amount}</strong>
                    </div>
                    <div style={{ textAlign: "center" }}>
                      <small className="text-muted d-block">Repaid</small>
                      <strong style={{ color: "#22c55e" }}>₹{repaid}</strong>
                    </div>
                    <div style={{ textAlign: "center" }}>
                      <small className="text-muted d-block">Outstanding</small>
                      <strong style={{ color: outstanding > 0 ? "#ef4444" : "#22c55e" }}>
                        {outstanding > 0 ? `₹${outstanding}` : "✅ Fully Paid"}
                      </strong>
                    </div>
                    <button className="btn btn-outline-primary btn-sm" onClick={() => setExpandedLoanId(isExpanded ? null : loan.firestoreId)}>
                      {isExpanded ? "▲ Hide" : "▼ Repayments"}
                    </button>
                    {localStorage.getItem("role") === "Admin" && (
                      <button className="btn btn-outline-danger btn-sm" onClick={() => deleteLoan(loan.firestoreId, loan.lender)}>Delete</button>
                    )}
                  </div>
                </div>

                {isExpanded && (
                  <div className="mt-3 pt-3" style={{ borderTop: "1px solid #e5e7eb" }}>
                    {outstanding > 0 && (
                      <div className="row g-2 mb-3">
                        <div className="col-md-3">
                          <input type="number" className="form-control form-control-sm" placeholder="Repay Amount" value={repayAmount} onChange={(e) => setRepayAmount(e.target.value)} />
                        </div>
                        <div className="col-md-3" style={{ position: "relative" }}>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="DD/MM/YYYY"
                            maxLength={10}
                            value={repayDate}
                            onChange={(e) => {
                              let v = e.target.value.replace(/[^0-9]/g, "");
                              if (v.length > 2) v = v.slice(0,2) + "/" + v.slice(2);
                              if (v.length > 5) v = v.slice(0,5) + "/" + v.slice(5);
                              setRepayDate(v.slice(0,10));
                            }}
                            style={{ paddingRight: "28px" }}
                          />
                          <input
                            type="date"
                            style={{ position: "absolute", top: 0, right: 0, width: "28px", height: "100%", opacity: 0, cursor: "pointer" }}
                            onChange={(e) => {
                              if (!e.target.value) return;
                              const [y, m, d] = e.target.value.split("-");
                              setRepayDate(`${d}/${m}/${y}`);
                            }}
                          />
                        </div>
                        <div className="col-md-3">
                          <input type="text" className="form-control form-control-sm" placeholder="Notes" value={repayNotes} onChange={(e) => setRepayNotes(e.target.value)} />
                        </div>
                        <div className="col-md-3">
                          <button className="btn btn-success btn-sm w-100" onClick={() => addRepayment(loan.firestoreId)}>💰 Add Repayment</button>
                        </div>
                      </div>
                    )}
                    {loanRepayments.length === 0 ? (
                      <p className="text-muted mb-0">No repayments yet</p>
                    ) : (
                      <table className="table table-bordered table-sm mb-0">
                        <thead className="table-light">
                          <tr><th>Date</th><th>Amount</th><th>Notes</th><th>Added By</th><th>Action</th></tr>
                        </thead>
                        <tbody>
                          {loanRepayments.map((r) => (
                            <tr key={r.firestoreId}>
                              <td>{r.date}</td>
                              <td>₹{r.amount}</td>
                              <td>{r.notes || "-"}</td>
                              <td><span className="badge bg-secondary">{r.createdBy}</span></td>
                              <td>
                                {localStorage.getItem("role") === "Admin" && (
                                  <button className="btn btn-outline-danger btn-sm" onClick={() => deleteRepayment(r.firestoreId)}>🗑️</button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

function RentalPage({ db, showToast }) {
  const [activeTab, setActiveTab] = useState("items");

  const [items, setItems] = useState([]);
  const [itemName, setItemName] = useState("");
  const [itemQty, setItemQty] = useState("");
  const [editItemId, setEditItemId] = useState(null);
  const [editItemName, setEditItemName] = useState("");
  const [editItemQty, setEditItemQty] = useState("");

  const [bookings, setBookings] = useState([]);
  const [bookingItemId, setBookingItemId] = useState("");
  const [bookingCustomerName, setBookingCustomerName] = useState("");
  const [bookingMobile, setBookingMobile] = useState("");
  const [bookingDocType, setBookingDocType] = useState("");
  const [bookingDocNumber, setBookingDocNumber] = useState("");
  const [bookingLocation, setBookingLocation] = useState("");
  const [bookingRentDate, setBookingRentDate] = useState("");
  const [bookingReturnDate, setBookingReturnDate] = useState("");
  const [bookingAmount, setBookingAmount] = useState("");
  const [bookingFilter, setBookingFilter] = useState("All");

  const getTodayStr = () => {
    const d = new Date();
    return String(d.getDate()).padStart(2, "0") + "/" + String(d.getMonth() + 1).padStart(2, "0") + "/" + d.getFullYear();
  };

  useEffect(() => { fetchItems(); fetchBookings(); }, []);

  const fetchItems = async () => {
    const snap = await getDocs(collection(db, "rentalItems"));
    const data = [];
    snap.forEach(d => data.push({ firestoreId: d.id, ...d.data() }));
    data.sort((a, b) => a.name.localeCompare(b.name));
    setItems(data);
  };

  const fetchBookings = async () => {
    const snap = await getDocs(collection(db, "rentalBookings"));
    const data = [];
    snap.forEach(d => data.push({ firestoreId: d.id, ...d.data() }));
    const parseSort = (s) => {
      if (!s) return new Date(0);
      const p = s.split("/");
      if (p.length === 3) return new Date(Number(p[2]), Number(p[1]) - 1, Number(p[0]));
      return new Date(0);
    };
    data.sort((a, b) => parseSort(b.rentDate) - parseSort(a.rentDate));
    setBookings(data);
  };

  const addItem = async () => {
    const trimmed = itemName.trim();
    if (!trimmed || !itemQty) { showToast("Item name and Quantity தேவை", "error"); return; }
    const exists = items.find(i => i.name.toLowerCase() === trimmed.toLowerCase());
    if (exists) { showToast("Item already exists!", "error"); return; }
    await addDoc(collection(db, "rentalItems"), { name: trimmed, totalQuantity: Number(itemQty) });
    setItemName(""); setItemQty("");
    fetchItems();
    showToast("Item Added!");
  };

  const saveEditItem = async () => {
    if (!editItemName.trim() || !editItemQty) { showToast("Name and Quantity தேவை", "error"); return; }
    await updateDoc(doc(db, "rentalItems", editItemId), { name: editItemName.trim(), totalQuantity: Number(editItemQty) });
    setEditItemId(null); setEditItemName(""); setEditItemQty("");
    fetchItems();
    showToast("Item Updated!");
  };

  const deleteItem = async (id, name) => {
    if (!window.confirm(`"${name}" item-ஐ delete பண்ணலாமா?`)) return;
    await deleteDoc(doc(db, "rentalItems", id));
    fetchItems();
    showToast("Item Deleted!");
  };

  const getActiveCount = (itemId) => bookings.filter(b => b.itemId === itemId && b.status === "Rented").length;
  const getAvailable = (item) => Number(item.totalQuantity || 0) - getActiveCount(item.firestoreId);

  const addBooking = async () => {
    if (!bookingItemId || !bookingCustomerName.trim() || !bookingRentDate || !bookingAmount) {
      showToast("Item, Customer Name, Rent Date, Amount தேவை", "error");
      return;
    }
    const item = items.find(i => i.firestoreId === bookingItemId);
    if (item && getAvailable(item) <= 0) {
      showToast(`"${item.name}" stock இல்ல! Available: 0`, "error");
      return;
    }
    await addDoc(collection(db, "rentalBookings"), {
      itemId: bookingItemId,
      itemName: item ? item.name : "",
      customerName: bookingCustomerName.trim(),
      mobile: bookingMobile,
      docType: bookingDocType,
      docNumber: bookingDocNumber,
      location: bookingLocation,
      rentDate: bookingRentDate,
      expectedReturnDate: bookingReturnDate,
      actualReturnDate: "",
      amount: Number(bookingAmount),
      status: "Rented",
      createdBy: localStorage.getItem("loggedUser"),
      createdAt: new Date().toISOString()
    });
    setBookingItemId(""); setBookingCustomerName(""); setBookingMobile("");
    setBookingDocType(""); setBookingDocNumber(""); setBookingLocation("");
    setBookingRentDate(""); setBookingReturnDate(""); setBookingAmount("");
    fetchBookings();
    showToast("Booking Added!");
  };

  const markReturned = async (id) => {
    if (!window.confirm("இந்த item திரும்ப வந்துடுச்சுன்னு mark பண்ணலாமா?")) return;
    await updateDoc(doc(db, "rentalBookings", id), { status: "Returned", actualReturnDate: getTodayStr() });
    fetchBookings();
    showToast("Marked as Returned!");
  };

  const deleteBooking = async (id) => {
    if (!window.confirm("இந்த booking-ஐ delete பண்ணலாமா?")) return;
    await deleteDoc(doc(db, "rentalBookings", id));
    fetchBookings();
    showToast("Booking Deleted!");
  };

  const totalBookings = bookings.length;
  const activeBookings = bookings.filter(b => b.status === "Rented").length;
  const totalIncome = bookings.reduce((t, b) => t + Number(b.amount || 0), 0);

  const filteredBookings = bookings.filter(b => {
    if (bookingFilter === "Active") return b.status === "Rented";
    if (bookingFilter === "Returned") return b.status === "Returned";
    return true;
  });

  return (
    <div className="mt-4">
      <div className="d-flex gap-2 mb-4 flex-wrap">
        {[
          { key: "items", label: "📦 Items" },
          { key: "bookings", label: "📋 Bookings" },
        ].map(tab => (
          <button
            key={tab.key}
            className={`btn ${activeTab === tab.key ? "btn-dark" : "btn-outline-dark"}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === "items" && (
        <div>
          <div className="card shadow p-4 mb-4">
            <h5>➕ Add New Rental Item</h5>
            <div className="row mt-3">
              <div className="col-md-5 mb-3">
                <label>Item Name <span className="text-danger">*</span></label>
                <input type="text" className="form-control" placeholder="e.g. Ladder, Mukkali, Chair" value={itemName} onChange={(e) => setItemName(e.target.value)} />
              </div>
              <div className="col-md-4 mb-3">
                <label>Total Quantity <span className="text-danger">*</span></label>
                <input type="number" className="form-control" placeholder="Stock count" value={itemQty} onChange={(e) => setItemQty(e.target.value)} />
              </div>
              <div className="col-md-3 d-flex align-items-end mb-3">
                <button className="btn btn-success w-100" onClick={addItem}>Add Item</button>
              </div>
            </div>
          </div>

          <div className="card shadow p-4">
            <h5>Item List ({items.length})</h5>
            <table className="table table-bordered mt-3">
              <thead className="table-success">
                <tr><th>#</th><th>Item Name</th><th>Total Qty</th><th>Currently Rented</th><th>Available</th><th>Action</th></tr>
              </thead>
              <tbody>
                {items.map((item, i) => (
                  <tr key={item.firestoreId}>
                    <td>{i + 1}</td>
                    <td>
                      {editItemId === item.firestoreId ? (
                        <input type="text" className="form-control form-control-sm" value={editItemName} onChange={(e) => setEditItemName(e.target.value)} autoFocus />
                      ) : (<>🪜 {item.name}</>)}
                    </td>
                    <td>
                      {editItemId === item.firestoreId ? (
                        <input type="number" className="form-control form-control-sm" value={editItemQty} onChange={(e) => setEditItemQty(e.target.value)} />
                      ) : item.totalQuantity}
                    </td>
                    <td>{getActiveCount(item.firestoreId)}</td>
                    <td>
                      <span className={getAvailable(item) > 0 ? "badge bg-success" : "badge bg-danger"}>
                        {getAvailable(item)}
                      </span>
                    </td>
                    <td>
                      <div className="d-flex gap-2">
                        {editItemId === item.firestoreId ? (
                          <>
                            <button className="btn btn-success btn-sm" onClick={saveEditItem}>Save</button>
                            <button className="btn btn-secondary btn-sm" onClick={() => { setEditItemId(null); setEditItemName(""); setEditItemQty(""); }}>Cancel</button>
                          </>
                        ) : (
                          <>
                            <button className="btn btn-outline-primary btn-sm" onClick={() => { setEditItemId(item.firestoreId); setEditItemName(item.name); setEditItemQty(String(item.totalQuantity)); }}>Edit</button>
                            <button className="btn btn-outline-danger btn-sm" onClick={() => deleteItem(item.firestoreId, item.name)}>Delete</button>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {activeTab === "bookings" && (
        <div>
          <div className="row g-3 mb-4">
            <div className="col-md-4">
              <div className="card shadow p-4 text-center">
                <h6 className="text-muted">📋 Total Bookings</h6>
                <h2 style={{ color: "#2563eb" }}>{totalBookings}</h2>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card shadow p-4 text-center">
                <h6 className="text-muted">🔄 Active Rentals</h6>
                <h2 style={{ color: "#f59e0b" }}>{activeBookings}</h2>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card shadow p-4 text-center">
                <h6 className="text-muted">💰 Total Income</h6>
                <h2 style={{ color: "#22c55e" }}>₹{totalIncome.toLocaleString()}</h2>
              </div>
            </div>
          </div>

          <div className="card shadow p-4 mb-4">
            <h5>➕ New Booking</h5>
            <div className="row mt-3">
              <div className="col-md-3 mb-3">
                <label>Item <span className="text-danger">*</span></label>
                <select className="form-control" value={bookingItemId} onChange={(e) => setBookingItemId(e.target.value)}>
                  <option value="">Select Item</option>
                  {items.map(item => (
                    <option key={item.firestoreId} value={item.firestoreId}>
                      {item.name} (Available: {getAvailable(item)})
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-3 mb-3">
                <label>Customer Name <span className="text-danger">*</span></label>
                <input type="text" className="form-control" placeholder="Customer name" value={bookingCustomerName} onChange={(e) => setBookingCustomerName(e.target.value)} />
              </div>
              <div className="col-md-2 mb-3">
                <label>Mobile</label>
                <input type="text" className="form-control" placeholder="Mobile" maxLength={10} value={bookingMobile} onChange={(e) => setBookingMobile(e.target.value.replace(/[^0-9]/g, ""))} />
              </div>
              <div className="col-md-3 mb-3">
                <label>Document Type</label>
                <select className="form-control" value={bookingDocType} onChange={(e) => setBookingDocType(e.target.value)}>
                  <option value="">Select Document</option>
                  <option>Aadhar</option>
                  <option>Voter ID</option>
                  <option>License</option>
                  <option>Pan Card</option>
                  <option>Bike Number</option>
                </select>
              </div>
              <div className="col-md-3 mb-3">
                <label>Document Number</label>
                <input type="text" className="form-control" placeholder="Document number" value={bookingDocNumber} onChange={(e) => setBookingDocNumber(e.target.value)} />
              </div>
              <div className="col-md-3 mb-3">
                <label>Location</label>
                <input type="text" className="form-control" placeholder="Customer location/address" value={bookingLocation} onChange={(e) => setBookingLocation(e.target.value)} />
              </div>
              <div className="col-md-2 mb-3">
                <label>Rent Date <span className="text-danger">*</span></label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="DD/MM/YYYY"
                  maxLength={10}
                  value={bookingRentDate}
                  onChange={(e) => {
                    let v = e.target.value.replace(/[^0-9]/g, "");
                    if (v.length > 2) v = v.slice(0, 2) + "/" + v.slice(2);
                    if (v.length > 5) v = v.slice(0, 5) + "/" + v.slice(5);
                    setBookingRentDate(v.slice(0, 10));
                  }}
                />
              </div>
              <div className="col-md-2 mb-3">
                <label>Expected Return</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="DD/MM/YYYY"
                  maxLength={10}
                  value={bookingReturnDate}
                  onChange={(e) => {
                    let v = e.target.value.replace(/[^0-9]/g, "");
                    if (v.length > 2) v = v.slice(0, 2) + "/" + v.slice(2);
                    if (v.length > 5) v = v.slice(0, 5) + "/" + v.slice(5);
                    setBookingReturnDate(v.slice(0, 10));
                  }}
                />
              </div>
              <div className="col-md-3 mb-3">
                <label>Amount (₹) <span className="text-danger">*</span></label>
                <input type="number" className="form-control" placeholder="Rental amount" value={bookingAmount} onChange={(e) => setBookingAmount(e.target.value)} />
              </div>
              <div className="col-md-3 d-flex align-items-end mb-3">
                <button className="btn btn-success w-100" onClick={addBooking}>Add Booking</button>
              </div>
            </div>
          </div>

          <div className="card shadow p-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5>Booking List ({filteredBookings.length})</h5>
              <div className="d-flex gap-2">
                {["All", "Active", "Returned"].map(f => (
                  <button key={f} className={`btn btn-sm ${bookingFilter === f ? "btn-dark" : "btn-outline-dark"}`} onClick={() => setBookingFilter(f)}>{f}</button>
                ))}
              </div>
            </div>
            <table className="table table-bordered mt-3">
              <thead className="table-success">
                <tr>
                  <th>Item</th><th>Customer</th><th>Mobile</th><th>ID Proof</th><th>Location</th><th>Rent Date</th><th>Expected Return</th><th>Actual Return</th><th>Amount</th><th>Status</th><th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredBookings.length === 0 ? (
                  <tr><td colSpan="11" className="text-center text-muted">No bookings found</td></tr>
                ) : filteredBookings.map((b) => (
                  <tr key={b.firestoreId}>
                    <td>🪜 {b.itemName}</td>
                    <td>{b.customerName}</td>
                    <td>{b.mobile || "-"}</td>
                    <td>{b.docType ? `${b.docType}: ${b.docNumber || "-"}` : "-"}</td>
                    <td>{b.location || "-"}</td>
                    <td>{b.rentDate}</td>
                    <td>{b.expectedReturnDate || "-"}</td>
                    <td>{b.actualReturnDate || "-"}</td>
                    <td>₹{b.amount}</td>
                    <td>
                      <span className={b.status === "Rented" ? "badge bg-warning text-dark" : "badge bg-success"}>
                        {b.status === "Rented" ? "🔄 Rented" : "✅ Returned"}
                      </span>
                    </td>
                    <td>
                      <div className="d-flex gap-2">
                        {b.status === "Rented" && (
                          <button className="btn btn-outline-success btn-sm" onClick={() => markReturned(b.firestoreId)}>✅ Mark Returned</button>
                        )}
                        {localStorage.getItem("role") === "Admin" && (
                          <button className="btn btn-outline-danger btn-sm" onClick={() => deleteBooking(b.firestoreId)}>🗑️</button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
              {filteredBookings.length > 0 && (
                <tfoot>
                  <tr className="table-success fw-bold">
                    <td colSpan="8">Total</td>
                    <td>₹{filteredBookings.reduce((t, b) => t + Number(b.amount || 0), 0)}</td>
                    <td colSpan="2"></td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

function AnimatedNumber({ value }) {
  const [display, setDisplay] = useState(0);
  useEffect(() => {
    const target = Number(value) || 0;
    let startVal = 0;
    let start = null;
    const duration = 700;
    const step = (ts) => {
      if (!start) start = ts;
      const progress = Math.min((ts - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplay(Math.round(startVal + (target - startVal) * eased));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
    // eslint-disable-next-line
  }, [value]);
  return <>{display.toLocaleString()}</>;
}

function App() {

  const [forcePasswordChange,
setForcePasswordChange] =
useState(false);

const [newUserPassword,
setNewUserPassword] =
useState("");

const [confirmPassword,
setConfirmPassword] =
useState("");

  // Login States

 const [isLoggedIn, setIsLoggedIn] = useState(() => {
  try {
    return localStorage.getItem("isLoggedIn") === "true";
  } catch (e) {
    console.error("localStorage error:", e);
    return false;
  }
});

const [showPublicSite, setShowPublicSite] = useState(true);
const [publicPage, setPublicPage] = useState("home");

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [otpStep, setOtpStep] = useState(false);
const [otpToken, setOtpToken] = useState("");
const [tempUser, setTempUser] = useState(null);
const [showQR, setShowQR] = useState(false);
const [qrUri, setQrUri] = useState("");

  // CRM States

const [customers, setCustomers] = useState([]);
const [loading, setLoading] = useState(true);

const [serviceType, setServiceType] = useState("");
const [serviceCustomerName, setServiceCustomerName] = useState("");
const [serviceMobile, setServiceMobile] = useState("");
const [serviceAmount, setServiceAmount] = useState("");
const [serviceRemarks, setServiceRemarks] = useState("");
const [serviceDate, setServiceDate] = useState("");

const [serviceEntries, setServiceEntries] = useState([]);

const [selectedProfile, setSelectedProfile] = useState(null);

useEffect(() => {
  fetchCustomers();
  fetchLocations();
  fetchServices();
  fetchServiceCategories();
  fetchAmountCategories();
  fetchExpenseCategories();
  fetchAllPaymentsData();
  checkIdsFixedFlag();
}, []);

const checkIdsFixedFlag = async () => {
  try {
    const { getDoc } = await import("firebase/firestore");
    const flagDoc = await getDoc(doc(db, "settings", "migrationFlags"));
    if (flagDoc.exists() && flagDoc.data().customerIdsFixed) {
      setIdsFixed(true);
    }
  } catch (err) {
    console.error("Flag check failed:", err);
  }
};

const fetchLocations = async () => {
  const querySnapshot = await getDocs(collection(db, "locations"));
  const data = [];
  querySnapshot.forEach((doc) => { data.push({ firestoreId: doc.id, ...doc.data() }); });
  data.sort((a, b) => a.name.localeCompare(b.name));
  setLocations(data);
};

const fetchServiceCategories = async () => {
  const querySnapshot = await getDocs(collection(db, "serviceCategories"));
  const data = [];
  querySnapshot.forEach((doc) => { data.push({ firestoreId: doc.id, ...doc.data() }); });
  data.sort((a, b) => a.name.localeCompare(b.name));
  setServiceCategories(data);
};

const fetchAmountCategories = async () => {
  const querySnapshot = await getDocs(collection(db, "amountCategories"));
  const data = [];
  querySnapshot.forEach((doc) => { data.push({ firestoreId: doc.id, ...doc.data() }); });
  setAmountCategories(data);
};

const fetchExpenseCategories = async () => {
  const querySnapshot = await getDocs(collection(db, "expenseCategories"));
  const data = [];
  querySnapshot.forEach((doc) => { data.push({ firestoreId: doc.id, ...doc.data() }); });
  data.sort((a, b) => a.name.localeCompare(b.name));
  setExpenseCategories(data);
};

const fetchAllPaymentsData = async () => {
  const querySnapshot = await getDocs(collection(db, "payments"));
  const data = [];
  querySnapshot.forEach((doc) => { data.push({ id: doc.id, ...doc.data() }); });
  setAllPaymentsData(data);
};
const fetchServices = async () => {

  const querySnapshot =
    await getDocs(
      collection(db, "serviceEntries")
    );

  const data = [];

  querySnapshot.forEach((doc) => {

    data.push({
      firestoreId: doc.id,
      ...doc.data()
    });

  });

  setServiceEntries(data);

};

const fetchStorageDocs = async (customerId) => {
  if (!customerId) { setLiveStorageDocs([]); return; }
  setLoadingDocs(true);
  try {
    const docListResult = await listAll(ref(storage, `documents/${customerId}`)).catch(() => ({ items: [] }));
    const memListResult = await listAll(ref(storage, `membership/${customerId}`)).catch(() => ({ items: [] }));
    const docs = await Promise.all(
      docListResult.items.map(async (item) => ({
        url: await getDownloadURL(item),
        name: item.name.replace(/^\d+_/, ""),
        type: "document",
        storageRef: item
      }))
    );
    const mems = await Promise.all(
      memListResult.items.map(async (item) => ({
        url: await getDownloadURL(item),
        name: item.name.replace(/^\d+_/, ""),
        type: "membership",
        storageRef: item
      }))
    );
    setLiveStorageDocs([...docs, ...mems]);
  } catch (err) {
    console.error("Storage fetch error:", err);
    setLiveStorageDocs([]);
  }
  setLoadingDocs(false);
};

const fetchCustomers = async () => {
  setLoading(true);
  const querySnapshot = await getDocs(collection(db, "customers"));
  const customerData = [];
  querySnapshot.forEach((doc) => {
    customerData.push({ firestoreId: doc.id, ...doc.data() });
  });
  setCustomers(customerData);
  setLoading(false);
};
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [scheme, setScheme] = useState("");
  const [status, setStatus] = useState("Pending");
  const [search, setSearch] = useState("");
  const [remarks, setRemarks] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [guardianName, setGuardianName] = useState("");
  const [dob, setDob] = useState("");
  const [location, setLocation] = useState("");
  const [applyingFor, setApplyingFor] = useState("");
  const [amountReceived, setAmountReceived] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [pendingAmount, setPendingAmount] =
  useState("");
  const [editId, setEditId] = useState(null);
const [editMode, setEditMode] = useState("full"); // "full" | "customer" | "application"
const [fieldErrors, setFieldErrors] = useState({});
  const [customerListFilter, setCustomerListFilter] = useState("All");
const [locations, setLocations] = useState([]);
const [serviceCategories, setServiceCategories] = useState([]);
const [amountCategories, setAmountCategories] = useState([]);
const [expenseCategories, setExpenseCategories] = useState([]);
const [locationSearch, setLocationSearch] = useState("");
const [customerListLocation, setCustomerListLocation] = useState("");
const [customerListScheme, setCustomerListScheme] = useState("");
  const [mobileDuplicateWarning, setMobileDuplicateWarning] = useState("");
const [uploadedFiles, setUploadedFiles] = useState([]);
const [uploadError, setUploadError] = useState("");
const [uploading, setUploading] = useState(false);
const [membershipForm, setMembershipForm] = useState(null);
const [membershipFormError, setMembershipFormError] = useState("");
const [fileInputKey, setFileInputKey] = useState(0);
const [applicationDate, setApplicationDate] = useState("");
const [liveStorageDocs, setLiveStorageDocs] = useState([]);
const [loadingDocs, setLoadingDocs] = useState(false);
  const [financialFilter, setFinancialFilter] = useState("All");
  const [clFromDate, setClFromDate] = useState("");
const [clToDate, setClToDate] = useState("");
const [clFilterMonth, setClFilterMonth] = useState("");
const [clFilterYear, setClFilterYear] = useState("");
const [clFilterStatus, setClFilterStatus] = useState("");
const [clFilterPayment, setClFilterPayment] = useState("");
const [clFilterLocation, setClFilterLocation] = useState("");
const [alFilterLocation, setAlFilterLocation] = useState("");
const [alFilterApplyingFor, setAlFilterApplyingFor] = useState("");
const [alFilterPayment, setAlFilterPayment] = useState("");
const [showAppListFilter, setShowAppListFilter] = useState(false);
const [showSettings, setShowSettings] = useState(false);
const [idsFixed, setIdsFixed] = useState(false);
const [showAdvFilter, setShowAdvFilter] = useState(false);
  const [fromDate, setFromDate] = useState("");
const [toDate, setToDate] = useState("");
const [filterMonth, setFilterMonth] = useState("");
const [filterYear, setFilterYear] = useState("");
  const [lockFields,
setLockFields] =
useState(false);
const [isExistingCustomer, setIsExistingCustomer] = useState(false);
  const [viewCustomer, setViewCustomer] =
  useState(null);

  // Dashboard Filter

const [filterStatus, setFilterStatus] =
  useState("All");
  const [appListSortField, setAppListSortField] = useState(null);
  const [appListSortDir, setAppListSortDir] = useState("asc");
  const [clSortField, setClSortField] = useState(null);
  const [clSortDir, setClSortDir] = useState("asc");

  // Menu Navigation

  const [activeMenu, setActiveMenu] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("view") || "Dashboard";
  });
  const [lastActivity, setLastActivity] = useState(Date.now());
const SESSION_TIMEOUT = 10 * 60 * 1000; // 10 minutes

  // Temporary Status

  const [tempStatuses, setTempStatuses] = useState({});
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [globalSearch, setGlobalSearch] = useState("");
  const [profilePayments, setProfilePayments] = useState([]);
  const [profilePaymentsLoading, setProfilePaymentsLoading] = useState(false);
  const [allPaymentsData, setAllPaymentsData] = useState([]);
  const [showGlobalResults, setShowGlobalResults] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentCustomer, setPaymentCustomer] = useState(null);
  const [paymentAmount, setPaymentAmount] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [paymentNotes, setPaymentNotes] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [paymentSaving, setPaymentSaving] = useState(false);
  const [toast, setToast] = useState(null); // { message: "...", type: "success" }

  const showToast = (message, type = "success") => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 2500);
  };

      // Session Timeout
useEffect(() => {
  if (!isLoggedIn) return;
  let warned = false;

  const checkSession = setInterval(() => {
    const now = Date.now();
    const remaining = SESSION_TIMEOUT - (now - lastActivity);
    if (remaining <= 0) {
      showToast("Session expired due to inactivity. Please login again.");
      logout();
    } else if (remaining <= 60000 && !warned) {
      warned = true;
      showToast("⚠️ Inactive-ஆ இருந்தா 1 நிமிடத்தில் logout ஆகும்!", "error");
    } else if (remaining > 60000) {
      warned = false;
    }
  }, 15000);

  return () => clearInterval(checkSession);
}, [isLoggedIn, lastActivity]);

// Profile Payments — selectedProfile மாறும்போது fetch
useEffect(() => {
  if (!selectedProfile?.firestoreId) return;
  let cancelled = false;
  const fetchProfilePayments = async () => {
    setProfilePaymentsLoading(true);
    const q = query(collection(db, "payments"), where("customerId", "==", selectedProfile.firestoreId));
    const snap = await getDocs(q);
    if (cancelled) return;
    const data = [];
    snap.forEach(d => data.push({ id: d.id, ...d.data() }));
    data.sort((a, b) => new Date(a.date) - new Date(b.date));
    setProfilePayments(data);
    setProfilePaymentsLoading(false);
  };
  fetchProfilePayments();
  return () => { cancelled = true; };
}, [selectedProfile?.firestoreId]);

// Live Storage Docs — selectedProfile மாறும்போது fetch
useEffect(() => {
  const folderId = selectedProfile?.applicationId || selectedProfile?.appId;
  if (folderId) {
    fetchStorageDocs(folderId);
  } else {
    setLiveStorageDocs([]);
  }
}, [selectedProfile]);

// Track Activity
useEffect(() => {
  if (!isLoggedIn) return;

  const resetTimer = () => setLastActivity(Date.now());

  window.addEventListener("mousemove", resetTimer);
  window.addEventListener("keypress", resetTimer);
  window.addEventListener("click", resetTimer);

  return () => {
    window.removeEventListener("mousemove", resetTimer);
    window.removeEventListener("keypress", resetTimer);
    window.removeEventListener("click", resetTimer);
  };
}, [isLoggedIn]);


  
  // Multi User Login

  // Login

  const uploadFileToStorage = async (file, folder, customerId) => {
  const storageRef = ref(storage, `${folder}/${customerId}/${Date.now()}_${file.name}`);
  await uploadBytes(storageRef, file, {
    contentDisposition: `attachment; filename="${file.name}"`
  });
  const url = await getDownloadURL(storageRef);
  return url;
};

const login = async () => {
  setIsLoggingIn(true); 
  const q = query(
    collection(db, "users"),
    where("username", "==", username)
  );
  const querySnapshot = await getDocs(q);

  if (!querySnapshot.empty) {
    const userDoc = querySnapshot.docs[0];
    const userData = userDoc.data();
    const passwordMatch = await bcrypt.compare(password, userData.password);

    if (passwordMatch) {

if (
userData.isDefaultPassword
) {

setTempUser({

...userData,

docId: userDoc.id

});

setForcePasswordChange(
true
);

return;

}

if (userData.role !== "Admin") {
  
        localStorage.setItem("role", userData.role);
        localStorage.setItem("loggedUser", userData.username);
        localStorage.setItem("isLoggedIn", "true");
        setIsLoggedIn(true);
        showToast("Login Successful!");
        return;
      }
      if (!userData.totpSecret) {
        const secret = new OTPAuth.Secret();
        const totp = new OTPAuth.TOTP({
          issuer: "SBM CRM",
          label: userData.username,
          algorithm: "SHA1",
          digits: 6,
          period: 30,
          secret: secret,
        });
        await updateDoc(doc(db, "users", userDoc.id), {
          totpSecret: secret.base32,
        });
        setQrUri(totp.toString());
        setShowQR(true);
        setTempUser({ ...userData, totpSecret: secret.base32, docId: userDoc.id });
        setOtpStep(true);
      } else {
        setTempUser({ ...userData, docId: userDoc.id });
        setShowQR(false);
        setOtpStep(true);
      }
    } else {
      showToast("Invalid Password", "error");
      setIsLoggingIn(false);
    }
  } else {
    showToast("User Not Found", "error");
    setIsLoggingIn(false);
  }
};

const verifyOTP = () => {
  const totp = new OTPAuth.TOTP({
    issuer: "SBM CRM",
    label: tempUser.username,
    algorithm: "SHA1",
    digits: 6,
    period: 30,
    secret: OTPAuth.Secret.fromBase32(tempUser.totpSecret),
  });
  const delta = totp.validate({ token: otpToken, window: 1 });
  if (delta !== null) {
    localStorage.setItem("role", tempUser.role);
    localStorage.setItem("loggedUser", tempUser.username);
    localStorage.setItem("isLoggedIn", "true");

    setIsLoggedIn(true);
    setOtpStep(false);
    setTempUser(null);
    setOtpToken("");
    showToast("Login Successful!");
  } else {
    showToast("Invalid OTP! Try again.", "error");
    setOtpToken("");
  }
};
  // Logout

const logout = () => {
  setIsLoggedIn(false);
  setIsLoggingIn(false);
  setUsername("");
  setPassword("");
  setOtpToken("");
  setOtpStep(false);
  setTempUser(null);
  setShowQR(false);
  setSelectedProfile(null);
  localStorage.removeItem("role");
  localStorage.removeItem("isLoggedIn");
  localStorage.removeItem("loggedUser");
};

function PaymentHistoryInline({ payments, loading, pendingAmount }) {

  const totalPaid = payments.reduce((t, p) => t + Number(p.amount || 0), 0);
  const originalAmount = totalPaid + Number(pendingAmount || 0);
  let runningBalance = originalAmount;
  const paymentsWithBalance = payments.map(p => {
    runningBalance -= Number(p.amount || 0);
    return { ...p, balance: Math.max(0, runningBalance) };
  });

  return (
    <div className="card shadow border-0 p-4 mb-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">💰 Payment History</h4>
        <div style={{ display: "flex", gap: "12px" }}>
          <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: "10px", padding: "8px 16px", textAlign: "center" }}>
            <div style={{ fontSize: "11px", color: "#16a34a" }}>Total Paid</div>
            <div style={{ fontSize: "18px", fontWeight: "800", color: "#16a34a" }}>₹{totalPaid}</div>
          </div>
          <div style={{ background: "#fef3c7", border: "1px solid #fde68a", borderRadius: "10px", padding: "8px 16px", textAlign: "center" }}>
            <div style={{ fontSize: "11px", color: "#d97706" }}>Pending</div>
            <div style={{ fontSize: "18px", fontWeight: "800", color: "#d97706" }}>₹{pendingAmount || 0}</div>
          </div>
        </div>
      </div>
      {loading ? (
        <p className="text-muted">Loading...</p>
      ) : paymentsWithBalance.length === 0 ? (
        <p className="text-muted">No payment records found</p>
      ) : (
        <table className="table table-bordered mt-2">
          <thead className="table-success">
            <tr>
              <th>#</th>
              <th>Date</th>
              <th>Amount Paid</th>
              <th>Balance</th>
              <th>Notes</th>
              <th>Added By</th>
            </tr>
          </thead>
          <tbody>
            {paymentsWithBalance.map((p, i) => (
              <tr key={p.id}>
                <td>{i + 1}</td>
                <td>{p.date}</td>
                <td style={{ color: "#16a34a", fontWeight: "700" }}>₹{p.amount}</td>
                <td>
                  {p.balance === 0 ? (
                    <span className="badge bg-success">₹0 ✅ PAID</span>
                  ) : (
                    <span style={{ color: "#d97706", fontWeight: "600" }}>₹{p.balance}</span>
                  )}
                </td>
                <td>{p.notes || "-"}</td>
                <td><span className="badge bg-secondary">{p.createdBy}</span></td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="table-success fw-bold">
              <td colSpan="2">Total</td>
              <td>₹{totalPaid}</td>
              <td>{Number(pendingAmount || 0) === 0 ? <span className="badge bg-success">FULLY PAID ✅</span> : `₹${pendingAmount} pending`}</td>
              <td colSpan="2"></td>
            </tr>
          </tfoot>
        </table>
      )}
    </div>
  );
}



// Activity Log
const logActivity = async (action, details) => {
  try {
    await addDoc(collection(db, "activityLogs"), {
      user: localStorage.getItem("loggedUser"),
      role: localStorage.getItem("role"),
      action,
      details,
      timestamp: new Date().toISOString(),
      date: getTodayStr(),
      time: new Date().toLocaleTimeString()
    });
  } catch (error) {
    console.error("Failed to log activity:", error);
  }
};

// Atomic Sequential ID Generator (prevents duplicate IDs on simultaneous submissions)
  const generateSequentialId = async (prefix, counterName, fallbackMax) => {
    const counterRef = doc(db, "counters", counterName);
    const nextNumber = await runTransaction(db, async (transaction) => {
      const counterSnap = await transaction.get(counterRef);
      const current = counterSnap.exists() ? (counterSnap.data().value || 0) : fallbackMax;
      const next = current + 1;
      transaction.set(counterRef, { value: next }, { merge: true });
      return next;
    });
    return prefix + String(nextNumber).padStart(4, "0");
  };

 // Date Helper
  const getTodayStr = () => {
    const d = new Date();
    return String(d.getDate()).padStart(2,"0") + "/" +
           String(d.getMonth()+1).padStart(2,"0") + "/" +
           d.getFullYear();
  };

  // Age Helper — dob in DD-MM-YYYY format
  const calculateAge = (dob) => {
    if (!dob) return null;
    const parts = dob.split("-");
    if (parts.length !== 3) return null;
    const birthDay = Number(parts[0]);
    const birthMonth = Number(parts[1]);
    const birthYear = Number(parts[2]);
    if (!birthYear || !birthMonth || !birthDay) return null;
    const today = new Date();
    return today.getFullYear() - birthYear -
      (today.getMonth() + 1 < birthMonth ||
      (today.getMonth() + 1 === birthMonth && today.getDate() < birthDay) ? 1 : 0);
  };

  // Edit Customer

  const editCustomer = (customer) => {

    setEditId(customer.firestoreId);

    setName(customer.name);
    setMobile(customer.mobile);
    setScheme(customer.scheme);
    setStatus(customer.status);
    setRemarks(customer.remarks);
    setCardNumber(customer.cardNumber);
    setApplyingFor(customer.applyingFor);
    setAmountReceived(customer.amountReceived);
    setPaymentType(customer.paymentType);
    setTotalAmount(customer.totalAmount || (Number(customer.amountReceived || 0) + Number(customer.pendingAmount || 0)));
    setPendingAmount(
    
  customer.pendingAmount || ""
);
    setGuardianName(customer.guardianName);
    setDob(customer.dob);
    setApplicationDate(customer.createdDate || "");
    setLocation(customer.location);
    setUploadedFiles([]);
    setUploadError("");
    setMembershipForm(null);
    setMembershipFormError("");
    setFileInputKey(prev => prev + 1);

    setActiveMenu("New Application");

  };

  // Add / Update Customer

const addService = async () => {

  if (
    !serviceType ||
    !serviceAmount
  ) {
    showToast("Fill mandatory fields", "error");
    return;
  }

  await addDoc(
    collection(db, "serviceEntries"),
    {
      serviceType,
      customerName:
        serviceCustomerName,
      mobile:
        serviceMobile,
      amount:
        Number(serviceAmount),
      remarks:
        serviceRemarks,
      createdDate:
        serviceDate || getTodayStr(),
      createdTime:
        new Date().toLocaleTimeString()
    }
  );

  setServiceType("");
  setServiceCustomerName("");
  setServiceMobile("");
  setServiceAmount("");
  setServiceRemarks("");
  setServiceDate("");

  fetchServices();

  await logActivity(
    "Service Added",
    `${serviceType} | ₹${serviceAmount}`
  );

  showToast("Service Saved");
};

  const validateFields = () => {
    const errors = {};
    if (!name) errors.name = true;
    if (!guardianName) errors.guardianName = true;
    if (!dob) errors.dob = true;
    if (!location) errors.location = true;
    if (!mobile) errors.mobile = true;
    if (editMode !== "customer" && !status) errors.status = true;
    if (editMode !== "customer" && status !== "Note Entry") {
      if (!remarks) errors.remarks = true;
      if (!applyingFor) errors.applyingFor = true;
      if (!amountReceived) errors.amountReceived = true;
       if (!applicationDate) errors.applicationDate = true;
      if (!paymentType) errors.paymentType = true;
      if (["Education", "Marriage"].includes(applyingFor) && !totalAmount) errors.totalAmount = true;
    }
    if (editMode !== "customer" && status === "Note Entry" && !applicationDate) errors.applicationDate = true;
    if (status === "Approved" && !/^[a-zA-Z0-9]{12}$/.test(cardNumber)) {
      errors.cardNumber = true;
    }
  
    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const addCustomer = async () => {
    if (isSaving) return;
    setIsSaving(true);

    if (editMode === "customer") {
      if (!name || !guardianName || !dob || !location || !mobile) {
        showToast("Please fill all mandatory fields", "error");
        setIsSaving(false);
        return;
      }
    } else if (status === "Note Entry") {
      if (!name || !guardianName || !dob || !location || !mobile || !applicationDate || !status) {
        showToast("Please fill all mandatory fields", "error");
        setIsSaving(false);
        return;
      }
    } else {
      if (!status || !name || !guardianName || !dob || !location || !mobile ||
        !remarks || !applyingFor || !amountReceived || !paymentType || !applicationDate) {
        showToast("Please fill all mandatory fields", "error");
        setIsSaving(false);
        return;
      }

      if (Number(amountReceived) > Number(totalAmount || 0) && Number(totalAmount || 0) > 0) {
  showToast("Amount Received cannot exceed Fixed Amount!", "error");
  setIsSaving(false);
  return;
}
    }

// MOBILE VALIDATION

if (
  !/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-[0-9]{4}$/.test(dob)
) {

  alert(
    "DOB format must be DD-MM-YYYY"
  );

  setIsSaving(false);
  return;

}

if (!/^[0-9]{10}$/.test(mobile)) {

  alert(
    "Mobile number must be 10 digits"
  );

  setIsSaving(false);
  return;

}


// CARD NUMBER VALIDATION

if (

status === "Approved"

&&

!/^[a-zA-Z0-9]{12}$/.test(
  cardNumber
)

) {

  alert(
    "Approved status requires valid card number"
  );

  setIsSaving(false);
  return;

}

// DUPLICATE CHECK

let existingCustomerForId = null;

if (editId === null && viewCustomer === null) {

  const duplicateMobile = customers.find(
    (c) => c.mobile === mobile
  );

  if (duplicateMobile) {
    const confirmDuplicate = window.confirm(
      `${duplicateMobile.name} already exists! Still want to add new application?`
    );
    if (!confirmDuplicate) { setIsSaving(false); return; }
    existingCustomerForId = duplicateMobile;
  }

  if (cardNumber !== "") {
    const duplicateCard = customers.find(
      (c) => c.cardNumber === cardNumber
    );

    if (duplicateCard) {
      showToast("This card number already exists!", "error");
      setIsSaving(false);
      return;
    }
  }

}

    // Duplicate mobile check when editing (mobile changed to a number already used by another customer)
    if (editId !== null) {
      const duplicateOnEdit = customers.find(
        (c) => c.mobile === mobile && c.firestoreId !== editId
      );
      if (duplicateOnEdit) {
        const confirmDuplicateEdit = window.confirm(
          `This mobile number already belongs to "${duplicateOnEdit.name}"! Continue anyway?`
        );
        if (!confirmDuplicateEdit) { setIsSaving(false); return; }
      }
    }

    // Update Existing Customer

    if (editId !== null) {

      const updatedCustomers = customers.map((customer) => {

        if (
  customer.firestoreId ===
  editId
) {

          return {
            ...customer,
            name,
            mobile,
            scheme,
            status,
            remarks,
            cardNumber,
            applyingFor,
  amountReceived,
  paymentType,
  pendingAmount,
  guardianName,
  dob,
  location,
  ...(applicationDate ? { createdDate: applicationDate } : {})
};

}

        return customer;

      });

      setCustomers(updatedCustomers);

      setEditId(null);

      setName("");
      setMobile("");
      setScheme("");
      setStatus("Pending");
      setRemarks("");
      setCardNumber("");
      setApplyingFor("");
      setAmountReceived("");
      setPaymentType("");
      setPendingAmount("");
      setGuardianName("");
      setDob("");
      setLocation("");

      const existingCustomerRecord = customers.find(c => c.firestoreId === editId);
      let updatedApplicationId = existingCustomerRecord?.applicationId || "";
      if (editMode === "application" && status === "Approved" && !updatedApplicationId) {
        const smbNums = customers.map(c =>
          c.applicationId?.startsWith("SBM")
            ? parseInt(c.applicationId.replace("SBM", "")) || 0 : 0
        );
        const fallbackMaxSmb = smbNums.length > 0 ? Math.max(...smbNums) : 0;
        updatedApplicationId = await generateSequentialId("SBM", "customerIdCounter", fallbackMaxSmb);
      }

      const updateData = editMode === "customer"
  ? { name, mobile, scheme, cardNumber, guardianName, dob, location, ...(applicationDate ? { createdDate: applicationDate } : {}) }
  : { name, mobile, scheme, status, remarks, cardNumber, applyingFor,
      amountReceived, paymentType, pendingAmount, totalAmount, guardianName, dob, location,
      ...(applicationDate ? { createdDate: applicationDate } : {}),
      ...(updatedApplicationId ? { applicationId: updatedApplicationId } : {}) };

await updateDoc(doc(db, "customers", editId), updateData);

showToast("Customer Updated Successfully");

const oldCustomer =
customers.find(
(c) => c.firestoreId === editId
);

let changes = [];

if (oldCustomer.name !== name) {
  changes.push(
`👤 Name:
${oldCustomer.name}
→
${name}`
  );
}

if (oldCustomer.mobile !== mobile) {
  changes.push(
`📱 Mobile:
${oldCustomer.mobile}
→
${mobile}`
  );
}

if (oldCustomer.status !== status) {
  changes.push(
`🔄 Status:
${oldCustomer.status}
→
${status}`
  );

  // ✅ AUTO-SEND WHATSAPP MESSAGE WHEN STATUS CHANGES (Update Customer page)
  const messageTypeMap = {
    "Submitted": "status_submitted",
    "Resubmitted": "status_resubmitted",
    "Approved": "status_approved",
    "Rejected": "status_rejected",
  };
  const messageType = messageTypeMap[status];

  if (messageType) {
    try {
      const { httpsCallable, getFunctions } = await import("firebase/functions");
      const cloudFunctions = getFunctions();
      const sendMessage = httpsCallable(cloudFunctions, "sendWhatsAppMessage");

      await sendMessage({
        phoneNumber: mobile,
        messageType: messageType,
        customerData: {
          name: name,
          appId: oldCustomer.applicationId,
          applyingFor: applyingFor,
          amount: amountReceived,
          cardNumber: cardNumber || "Processing",
        },
      });

      console.log(`✅ WhatsApp auto-sent: ${messageType} to ${mobile}`);
    } catch (whatsappError) {
      console.error("WhatsApp auto-send failed:", whatsappError);
    }
  }
}

if (
oldCustomer.applyingFor
!== applyingFor
) {
  changes.push(
`🎯 Applying For:
${oldCustomer.applyingFor}
→
${applyingFor}`
  );
}

if (oldCustomer.amountReceived !== amountReceived) {
  changes.push(`💰 Amount: ₹${oldCustomer.amountReceived} → ₹${amountReceived}`);
}

if (oldCustomer.guardianName !== guardianName) {
  changes.push(`👨 Guardian Name: ${oldCustomer.guardianName} → ${guardianName}`);
}

if (oldCustomer.cardNumber !== cardNumber) {
  changes.push(`🪪 Card Number: ${oldCustomer.cardNumber} → ${cardNumber}`);
}

if (oldCustomer.dob !== dob) {
  changes.push(`🎂 DOB: ${oldCustomer.dob} → ${dob}`);
}

if (oldCustomer.scheme !== scheme) {
  changes.push(`📂 Scheme: ${oldCustomer.scheme} → ${scheme}`);
}

if (oldCustomer.location !== location) {
  changes.push(`📍 Location: ${oldCustomer.location} → ${location}`);
}

if (oldCustomer.paymentType !== paymentType) {
  changes.push(`💳 Payment Type: ${oldCustomer.paymentType} → ${paymentType}`);
}

if (String(oldCustomer.pendingAmount || "0") !== String(pendingAmount || "0")) {
  changes.push(`💰 Pending Amount: ₹${oldCustomer.pendingAmount} → ₹${pendingAmount}`);

  const oldPending = Number(oldCustomer.pendingAmount || 0);
  const newPending = Number(pendingAmount || 0);
  const paidNow = oldPending - newPending;

  if (paidNow > 0) {
    await addDoc(collection(db, "payments"), {
      customerId: editId,
      applicationId: oldCustomer.applicationId,
      appId: oldCustomer.appId,
      customerName: name,
      mobile: mobile,
      amount: paidNow,
      date: getTodayStr(),
      notes: Number(pendingAmount) > 0 ? "Partial Payment" : "Full Payment",
      createdBy: localStorage.getItem("loggedUser"),
      createdAt: new Date().toISOString()
    });
  }
}

if (oldCustomer.remarks !== remarks) {
  changes.push(`📝 Remarks: ${oldCustomer.remarks} → ${remarks}`);
}

if (applicationDate && oldCustomer.createdDate !== applicationDate) {
  changes.push(`📅 Application Date: ${oldCustomer.createdDate || "-"} → ${applicationDate}`);
}

const cIdForLog = customers.find(c => c.firestoreId === editId)?.applicationId || "-";
await logActivity(
  "Customer Updated",
  `Customer ID: ${cIdForLog}\n\n${changes.join("\n\n")}`
);

// ✅ Upload new documents if selected during edit
if (uploadedFiles.length > 0 || membershipForm) {
  try {
    const docUpdateData = {};
    if (uploadedFiles.length > 0) {
      const newDocURLs = [];
      const newDocNames = [];
      for (const file of uploadedFiles) {
        const url = await uploadFileToStorage(file, "documents", cIdForLog);
        newDocURLs.push(url);
        newDocNames.push(file.name);
      }
      docUpdateData.documentURLs = newDocURLs;
      docUpdateData.documentNames = newDocNames;
      docUpdateData.documentURL = newDocURLs[0];
      docUpdateData.documentName = newDocNames[0];
    }
    if (membershipForm) {
      const mUrl = await uploadFileToStorage(membershipForm, "membership", cIdForLog);
      docUpdateData.membershipFormURL = mUrl;
      docUpdateData.membershipFormName = membershipForm.name;
    }
    if (Object.keys(docUpdateData).length > 0) {
      await updateDoc(doc(db, "customers", editId), docUpdateData);
      fetchCustomers();
    }
  } catch (err) {
    showToast("Document upload failed. Firebase Storage Rules check pannidu.");
    setIsSaving(false);
  }
}

// ✅ Clear upload states after edit
setUploadedFiles([]);
setUploadError("");
setMembershipForm(null);
setMembershipFormError("");
setFileInputKey(prev => prev + 1);
setIsSaving(false);

return;
    }

    // Add New Customer

// ✅ Step 1: customer data
const newCustomer = {
  name,
  guardianName,
  dob,
  age:
    new Date().getFullYear() -
    Number(dob.slice(6, 10)),
  location,
  mobile,
  scheme,
  status,
  remarks,
  applyingFor,
  amountReceived,
  paymentType,
  pendingAmount,
  totalAmount,
  createdDate: applicationDate || getTodayStr(),
  createdTime: new Date().toLocaleTimeString(),
  cardNumber
};

// ✅ Upload documents if any
let documentURLs = [];
let documentNames = [];
let membershipFormURL = "";
let membershipFormName = "";

// ✅ IDs-ஐ upload-க்கு முன்னாடியே generate பண்ணிடுவோம் (folder mismatch வராம இருக்க)
let applicationId = "";
if (viewCustomer && viewCustomer.applicationId) {
  applicationId = viewCustomer.applicationId;
} else if (existingCustomerForId && existingCustomerForId.applicationId) {
  applicationId = existingCustomerForId.applicationId;
} else if (status === "Approved") {
  const smbNums = customers.map(c =>
    c.applicationId?.startsWith("SBM")
      ? parseInt(c.applicationId.replace("SBM", "")) || 0 : 0
  );
  const fallbackMaxSmb = smbNums.length > 0 ? Math.max(...smbNums) : 0;
  applicationId = await generateSequentialId("SBM", "customerIdCounter", fallbackMaxSmb);
}

const appNums = customers.map(c =>
  c.appId?.startsWith("APP")
    ? parseInt(c.appId.replace("APP", "")) || 0 : 0
);
const fallbackMaxApp = appNums.length > 0 ? Math.max(...appNums) : 0;
const appId = await generateSequentialId("APP", "appIdCounter", fallbackMaxApp);

// Folder — applicationId இருந்தா அது, இல்லைன்னா appId
const uploadCustomerId = applicationId || appId;

setUploading(true);
try {

  for (const file of uploadedFiles) {
    const url = await uploadFileToStorage(file, "documents", uploadCustomerId);
    documentURLs.push(url);
    documentNames.push(file.name);
  }

  if (membershipForm) {
    membershipFormURL = await uploadFileToStorage(membershipForm, "membership", uploadCustomerId);
    membershipFormName = membershipForm.name;
  }
} catch (err) {
  showToast("Document upload failed. Please try again.");
  setUploading(false);
  return;
}
setUploading(false);

// ✅ Step 2: save to Firestore
const docRef = await addDoc(
  collection(db, "customers"),
  { ...newCustomer, documentURLs, documentNames, documentURL: documentURLs[0] || "", documentName: documentNames[0] || "", membershipFormURL, membershipFormName }
);
// ✅ Step 4: update both IDs (மேலயே generate ஆயிடுச்சு)
await updateDoc(docRef, { applicationId, appId });

if (Number(amountReceived) > 0) {
  await addDoc(collection(db, "payments"), {
    customerId: docRef.id,
    applicationId: applicationId,
    appId: appId,
    customerName: name,
    mobile: mobile,
    amount: Number(amountReceived),
    date: applicationDate || getTodayStr(),
    notes: Number(pendingAmount) > 0 ? "Partial Payment" : "Full Payment",
    createdBy: localStorage.getItem("loggedUser"),
    createdAt: new Date().toISOString()
  });
}


// ✅ Step 5: refresh
fetchCustomers();
   
    setName("");
    setMobile("");
    setScheme("");
    setStatus("Pending");
    setRemarks("");
    setCardNumber("");
    setApplyingFor("");
    setAmountReceived("");
    setPaymentType("");
    setPendingAmount("");
    setGuardianName("");
    setDob("");
    setLocation("");

setLockFields(false); setIsExistingCustomer(false);
    setViewCustomer(null);
    setUploadedFiles([]);
    setUploadError("");
    setMembershipForm(null);
    setMembershipFormError("");
    setFileInputKey(prev => prev + 1);


await logActivity(
  editId !== null ? "Customer Updated" : "Customer Added",
  `Customer ID: ${applicationId} | App ID: ${appId || "-"} | Name: ${name} | Mobile: ${mobile} | Status: ${status} | Applying For: ${applyingFor}`
);

    showToast("Customer Added Successfully");
    setIsSaving(false);

  };

  // Delete Customer

const deleteCustomer = async (id) => {

  const confirmed =
    window.confirm(
      "Are you sure you want to delete this customer?"
    );

  if (!confirmed) return;

  const customerToDelete =
    customers.find(
      (c) => c.firestoreId === id
    );

  await deleteDoc(
    doc(db, "customers", id)
  );

  // Delete related payments
  const paymentsQuery = query(
    collection(db, "payments"),
    where("customerId", "==", id)
  );
  const paymentsSnap = await getDocs(paymentsQuery);
  for (const payDoc of paymentsSnap.docs) {
    await deleteDoc(doc(db, "payments", payDoc.id));
  }

  // Delete related storage files (documents + membership form)
  if (customerToDelete?.applicationId) {
    for (const folder of ["documents", "membership"]) {
      try {
        const folderRef = ref(storage, `${folder}/${customerToDelete.applicationId}`);
        const listResult = await listAll(folderRef);
        for (const item of listResult.items) {
          await deleteObject(item).catch(() => {});
        }
      } catch (err) {
        console.error(`Failed to clear ${folder} storage:`, err);
      }
    }
  }

  const updatedCustomers =
    customers.filter(
      (customer) =>
        customer.firestoreId !== id
    );

  setCustomers(updatedCustomers);

  await logActivity(
    "Customer Deleted",
    `Customer ID: ${customerToDelete.applicationId} | Name: ${customerToDelete.name} | Mobile: ${customerToDelete.mobile}`
  );

  showToast("Customer Deleted");

};

const addPayment = async () => {
  if (!paymentAmount || !paymentDate) {
    showToast("Amount and Date are required!", "error");
    return;
  }
  if (Number(paymentAmount) <= 0) {
    showToast("Valid amount போடு!", "error");
    return;
  }
  if (Number(paymentAmount) > Number(paymentCustomer.pendingAmount || 0)) {
    showToast(`Payment amount cannot exceed Pending Amount (₹${paymentCustomer.pendingAmount || 0})!`, "error");
    return;
  }

  setPaymentSaving(true);
  try {
    const total = Number(paymentCustomer.totalAmount || (Number(paymentCustomer.amountReceived || 0) + Number(paymentCustomer.pendingAmount || 0)));
    const newPending = Math.max(0, Number(paymentCustomer.pendingAmount || 0) - Number(paymentAmount));
    const newReceived = Math.max(0, total - newPending);
    const isFullyPaid = newPending === 0;

    await addDoc(collection(db, "payments"), {
      customerId: paymentCustomer.firestoreId,
      applicationId: paymentCustomer.applicationId,
      appId: paymentCustomer.appId,
      customerName: paymentCustomer.name,
      mobile: paymentCustomer.mobile,
      amount: Number(paymentAmount),
      date: paymentDate,
      notes: paymentNotes,
      createdBy: localStorage.getItem("loggedUser"),
      createdAt: new Date().toISOString()
    });

    await updateDoc(doc(db, "customers", paymentCustomer.firestoreId), {
      pendingAmount: String(newPending),
      amountReceived: String(newReceived),
      paymentType: isFullyPaid ? "Full payment" : "Partial payment"
    });

    await logActivity(
      "Payment Added",
      `Customer: ${paymentCustomer.name} | App ID: ${paymentCustomer.appId} | Amount: ₹${paymentAmount} | Pending: ₹${newPending}`
    );

    fetchCustomers();
    setShowPaymentModal(false);
    setPaymentCustomer(null);
    setPaymentAmount("");
    setPaymentDate("");
    setPaymentNotes("");
    alert(`✅ Payment Saved! Pending: ₹${newPending}`);
  } catch (err) {
    showToast("Payment save failed: " + err.message, "error");
  }
  setPaymentSaving(false);
};

// Temporary Status Change

const updateTempStatus = async (
  id,
  value
) => {

  const customer =
    customers.find(
      (c) => c.firestoreId === id
    );

  setTempStatuses({
    ...tempStatuses,
    [id]: value
  });

  const updatedCustomers =
    customers.map((customer) => {

      if (
        customer.firestoreId === id
      ) {

        return {
          ...customer,
          status: value
        };

      }

      return customer;

    });

  setCustomers(updatedCustomers);

  await updateDoc(

    doc(db, "customers", id),

    {
      status: value
    }

  );

  // ✅ AUTO-SEND WHATSAPP MESSAGE WHEN STATUS CHANGES
  const messageTypeMap = {
    "Submitted": "status_submitted",
    "Resubmitted": "status_resubmitted",
    "Approved": "status_approved",
    "Rejected": "status_rejected",
  };

  const messageType = messageTypeMap[value];
  
  if (messageType && customer) {
    try {
      const { httpsCallable, getFunctions } = await import("firebase/functions");
      const cloudFunctions = getFunctions();
      const sendMessage = httpsCallable(cloudFunctions, "sendWhatsAppMessage");

      await sendMessage({
        phoneNumber: customer.mobile,
        messageType: messageType,
        customerData: {
          name: customer.name,
          appId: customer.applicationId,
          applyingFor: customer.applyingFor,
          amount: customer.amountReceived,
          cardNumber: customer.cardNumber || "Processing",
        },
      });

      console.log(`✅ WhatsApp auto-sent: ${messageType} to ${customer.mobile}`);
      await logActivity("WhatsApp Auto-Sent", `${messageType} | ${customer.name} | Status: ${customer.status} → ${value}`);
    } catch (whatsappError) {
      console.error("WhatsApp auto-send failed:", whatsappError);
      // Don't block status update if WhatsApp fails
      console.warn("⚠️ WhatsApp send failed, but status updated successfully");
    }
  }

  await logActivity(
    "Status Changed",
    `Customer ID: ${customer.applicationId} | Name: ${customer.name} | ${customer.status} → ${value}`
  );

};

const generateReceipt = async (customer) => {
  const receiptNo = customer.applicationId || "-";
  const today = customer.createdDate || getTodayStr();

  // Location, name, guardian are used as-entered (no runtime translation —
  // enter these in Tamil directly in the customer form if a Tamil receipt is needed)
  const tamilLocation = customer.location || "-";
  const tamilName = customer.name;
  const tamilGuardian = customer.guardianName;

  const receiptHTML = `
    <html>
    <head>
      <meta charset="UTF-8">
      <style>
        @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Tamil:wght@400;700&display=swap');
        body { font-family: 'Noto Sans Tamil', sans-serif; margin: 0; padding: 20px; }
        .container { max-width: 400px; margin: auto; border: 2px solid #000; padding: 20px; }
        .header { text-align: center; border-bottom: 2px solid #000; padding-bottom: 10px; margin-bottom: 10px; }
        .title { font-size: 18px; font-weight: bold; }
        .subtitle { font-size: 12px; }
        .receipt-title { text-align: center; font-size: 16px; font-weight: bold; margin: 10px 0; border: 1px solid #000; padding: 5px; }
        .row { display: flex; justify-content: space-between; margin: 6px 0; font-size: 13px; }
        .label { font-weight: bold; }
        .amount-box { border: 2px solid #000; padding: 10px; text-align: center; margin: 15px 0; font-size: 16px; font-weight: bold; }
        .footer { display: flex; justify-content: space-between; margin-top: 30px; font-size: 12px; }
        .note { text-align: center; font-size: 10px; margin-top: 15px; border-top: 1px solid #000; padding-top: 8px; }
        @media print { button { display: none; } }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <div class="title">SBM உதயம்</div>
          <div class="subtitle">கட்டுமானம் மற்றும் அமைப்புசாரா தொழிலாளர்கள் சங்கம்</div>
          <div class="subtitle">116/3, மேல முத்தாரம்மன் கோவில் தெரு, தென்காசி - 627811</div>
          <div class="subtitle">தொலைபேசி: +91 81234 54322</div>
        </div>

        <div class="receipt-title">சந்தா ரசீது</div>

        <div class="row">
          <span class="label">ரசீது எண்:</span>
          <span>${receiptNo}</span>
        </div>
        <div class="row">
          <span class="label">தேதி:</span>
          <span>${today}</span>
        </div>
       <div class="row">
          <span class="label">உறுப்பினர் பெயர்:</span>
          <span>${tamilName}</span>
        </div>
        <div class="row">
          <span class="label">பெற்றோர்/கணவர் பெயர்:</span>
          <span>${tamilGuardian}</span>
        </div>
        <div class="row">
          <span class="label">கைபேசி எண்:</span>
          <span>${customer.mobile || "-"}</span>
        </div>
        <div class="row">
          <span class="label">இடம்:</span>
          <span>${tamilLocation}</span>
        </div>
        <div class="row">
          <span class="label">பணம் செலுத்திய முறை:</span>
          <span>${customer.paymentType === "Full payment" ? "முழு தொகை" : "பகுதி தொகை"}</span>
        </div>
        ${Number(customer.pendingAmount || 0) > 0 ? `
        <div class="row">
          <span class="label">நிலுவை தொகை:</span>
          <span>₹${customer.pendingAmount}</span>
        </div>` : ""}

        <div class="amount-box">
          பெறப்பட்ட தொகை: ₹${customer.amountReceived || 0}
        </div>

        <div class="footer">
          <div>உறுப்பினர் கையொப்பம்</div>
          <div>அலுவலர் கையொப்பம்</div>
        </div>

        <div class="note">இது கணினி மூலம் உருவாக்கப்பட்ட ரசீது</div>
      </div>
      <br>
      <div style="text-align:center">
        <button onclick="window.print()" style="padding:10px 30px;font-size:14px;cursor:pointer;font-family:'Noto Sans Tamil',sans-serif;">🖨️ அச்சிடு</button>
      </div>
    </body>
    </html>
  `;

  const win = window.open("", "_blank", "width=500,height=700");
  win.document.write(receiptHTML);
  win.document.close();
};
  
  // Export Excel

  const exportToExcel = () => {

   const exportData =

customers.map((customer) => ({

  "Customer ID":
    customer.applicationId,

  "App ID":
    customer.appId || "",

  "Name":
    customer.name,

  "Guardian Name":
    customer.guardianName,

  "DOB":
    customer.dob,

  "Age": calculateAge(customer.dob) ?? "",
  "Location":
    customer.location,

  "Mobile":
    customer.mobile,

  "Card Number":
    customer.cardNumber,

  "Scheme":
    customer.scheme,

  "Applying For":
    customer.applyingFor,

  "Payment Type":
    customer.paymentType,

  "Amount Received":
    customer.amountReceived,

  "Pending Amount":
    customer.pendingAmount,

  "Status":
    customer.status,

  "Remarks":
    customer.remarks,

  "Created Date":
    customer.createdDate,

  "Created Time":
    customer.createdTime

}));

const worksheet =

XLSX.utils.json_to_sheet(
  exportData
);

    const workbook =
      XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Customers"
    );

    const excelBuffer =
      XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });

    const data = new Blob(
      [excelBuffer],
      {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
      }
    );

    saveAs(data, "customers.xlsx");

  };

  // Login Page

  if (forcePasswordChange) {

return (

<div
className="d-flex justify-content-center align-items-center"
style={{
height: "100vh",
background: "#f5f5f5"
}}
>

<div
className="card shadow p-5"
style={{ width: "400px" }}
>

<h3 className="mb-4 text-center">
Change Password
</h3>

<input

type="password"

className="form-control mb-3"

placeholder="Enter New Password"

value={newUserPassword}

onChange={(e) =>
setNewUserPassword(
e.target.value
)
}

/>

<input

type="password"

className="form-control mb-3"

placeholder="Confirm Password"

value={confirmPassword}

onChange={(e) =>
setConfirmPassword(
e.target.value
)
}

/>

<button

className="btn btn-success w-100"

onClick={async () => {

if (
newUserPassword === ""
||
confirmPassword === ""
) {

alert(
"Fill all fields"
);

return;

}

if (
newUserPassword !==
confirmPassword
) {

alert(
"Passwords do not match"
);

return;

}
const hashedPassword =
await bcrypt.hash(
newUserPassword,
10
);

await updateDoc(

doc(
db,
"users",
tempUser.docId
),

{
password:
hashedPassword,

isDefaultPassword:
false
}

);

alert(
"Password Changed Successfully"
);

setForcePasswordChange(
false
);

setNewUserPassword("");

}}

>

Update Password

</button>

</div>

</div>

);

}

if (showPublicSite && !isLoggedIn) {
  return (
    <PublicWebsite
      publicPage={publicPage}
      setPublicPage={setPublicPage}
      onStaffLogin={() => setShowPublicSite(false)}
    />
  );
}

if (!isLoggedIn) {
  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      fontFamily: "'Inter', 'Segoe UI', sans-serif",
      background: "#f0fdf4"
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');
        * { box-sizing: border-box; }

        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes float1 {
          0%,100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-18px) rotate(3deg); }
        }
        @keyframes float2 {
          0%,100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-12px) rotate(-2deg); }
        }
        @keyframes float3 {
          0%,100% { transform: translateY(0px); }
          50% { transform: translateY(-8px); }
        }
        @keyframes shimmer {
          0% { background-position: -200% center; }
          100% { background-position: 200% center; }
        }

        .crm-input {
          width: 100%;
          padding: 0 16px 0 44px;
          height: 48px;
          border: 1.5px solid #e5e7eb;
          border-radius: 10px;
          font-size: 14px;
          color: #1f2937;
          background: #f9fafb;
          outline: none;
          transition: all 0.2s;
          font-family: 'Inter', sans-serif;
        }
        .crm-input:focus {
          border-color: #16a34a;
          background: #fff;
          box-shadow: 0 0 0 4px rgba(22,163,74,0.1);
        }
        .crm-input::placeholder { color: #9ca3af; }

        .crm-login-btn {
          width: 100%;
          height: 50px;
          background: linear-gradient(135deg, #16a34a, #15803d);
          color: #fff;
          border: none;
          border-radius: 10px;
          font-size: 15px;
          font-weight: 700;
          cursor: pointer;
          font-family: 'Inter', sans-serif;
          letter-spacing: 0.3px;
          transition: all 0.2s;
          box-shadow: 0 4px 16px rgba(22,163,74,0.35);
        }
        .crm-login-btn:hover:not(:disabled) {
          transform: translateY(-1px);
          box-shadow: 0 8px 24px rgba(22,163,74,0.4);
          filter: brightness(1.05);
        }
        .crm-login-btn:disabled { background: #9ca3af; box-shadow: none; cursor: not-allowed; }

        .crm-otp-input {
          width: 100%;
          height: 58px;
          text-align: center;
          letter-spacing: 12px;
          font-size: 26px;
          font-weight: 700;
          border: 1.5px solid #e5e7eb;
          border-radius: 10px;
          background: #f9fafb;
          color: #1f2937;
          outline: none;
          transition: all 0.2s;
          font-family: 'Inter', sans-serif;
        }
        .crm-otp-input:focus {
          border-color: #16a34a;
          background: #fff;
          box-shadow: 0 0 0 4px rgba(22,163,74,0.1);
        }
      `}</style>

      {/* ── LEFT PANEL — Green Gradient ── */}
      <div style={{
        flex: "0 0 58%",
        background: "linear-gradient(145deg, #22c55e 0%, #16a34a 40%, #15803d 70%, #166534 100%)",
        position: "relative",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "60px 80px"
      }}>

        {/* Background hex pattern */}
        <svg style={{ position: "absolute", inset: 0, width: "100%", height: "100%", opacity: 0.06, pointerEvents: "none" }} xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="hex" x="0" y="0" width="60" height="52" patternUnits="userSpaceOnUse">
              <polygon points="30,2 58,16 58,36 30,50 2,36 2,16" fill="none" stroke="#fff" strokeWidth="1"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#hex)"/>
        </svg>

        {/* Glow orbs */}
        <div style={{ position: "absolute", top: "10%", right: "15%", width: "300px", height: "300px", background: "radial-gradient(circle, rgba(255,255,255,0.12) 0%, transparent 70%)", pointerEvents: "none" }}/>
        <div style={{ position: "absolute", bottom: "15%", left: "10%", width: "200px", height: "200px", background: "radial-gradient(circle, rgba(255,255,255,0.08) 0%, transparent 70%)", pointerEvents: "none" }}/>

        {/* Isometric CRM Illustration */}
        <div style={{ position: "relative", width: "420px", height: "320px", animation: "fadeUp 0.8s ease" }}>

          {/* Main platform base */}
          <svg width="420" height="320" viewBox="0 0 420 320" style={{ position: "absolute", top: 0, left: 0 }}>
            <defs>
              <linearGradient id="platTop" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#ffffff" stopOpacity="0.25"/>
                <stop offset="100%" stopColor="#ffffff" stopOpacity="0.08"/>
              </linearGradient>
              <linearGradient id="platSide" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#000" stopOpacity="0.15"/>
                <stop offset="100%" stopColor="#000" stopOpacity="0.08"/>
              </linearGradient>
              <linearGradient id="screenGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#ffffff" stopOpacity="0.9"/>
                <stop offset="100%" stopColor="#f0fdf4" stopOpacity="0.8"/>
              </linearGradient>
              <linearGradient id="cardGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#4ade80"/>
                <stop offset="100%" stopColor="#16a34a"/>
              </linearGradient>
            </defs>

            {/* Base platform — isometric */}
            <polygon points="210,200 340,135 340,165 210,230 80,165 80,135" fill="url(#platTop)" stroke="rgba(255,255,255,0.3)" strokeWidth="1"/>
            <polygon points="80,135 80,165 55,150 55,120" fill="url(#platSide)" stroke="rgba(255,255,255,0.1)" strokeWidth="1"/>
            <polygon points="340,135 340,165 365,150 365,120" fill="url(#platSide)" stroke="rgba(255,255,255,0.1)" strokeWidth="1"/>

            {/* Computer screen */}
            <polygon points="210,90 290,48 290,120 210,162" fill="url(#screenGrad)" stroke="rgba(255,255,255,0.5)" strokeWidth="1.5"/>
            <polygon points="130,48 210,90 210,162 130,120" fill="rgba(255,255,255,0.65)" stroke="rgba(255,255,255,0.4)" strokeWidth="1.5"/>
            <polygon points="130,48 210,6 290,48 210,90" fill="rgba(255,255,255,0.85)" stroke="rgba(255,255,255,0.5)" strokeWidth="1.5"/>

            {/* Screen content lines */}
            <line x1="148" y1="75" x2="190" y2="52" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" opacity="0.6"/>
            <line x1="148" y1="85" x2="185" y2="64" stroke="#16a34a" strokeWidth="1.5" strokeLinecap="round" opacity="0.4"/>
            <line x1="148" y1="94" x2="178" y2="76" stroke="#16a34a" strokeWidth="1.5" strokeLinecap="round" opacity="0.4"/>
            <rect x="148" y="100" width="20" height="6" rx="2" fill="#22c55e" opacity="0.6" transform="skewX(-15)"/>

            {/* Chart bars on right screen */}
            <rect x="230" y="115" width="8" height="28" rx="2" fill="#4ade80" opacity="0.7" transform="skewX(-25) skewY(15)"/>
            <rect x="245" y="107" width="8" height="36" rx="2" fill="#22c55e" opacity="0.8" transform="skewX(-25) skewY(15)"/>
            <rect x="260" y="112" width="8" height="31" rx="2" fill="#16a34a" opacity="0.9" transform="skewX(-25) skewY(15)"/>

            {/* Mobile device */}
            <polygon points="290,175 330,152 330,215 290,238" fill="rgba(255,255,255,0.8)" stroke="rgba(255,255,255,0.5)" strokeWidth="1.5"/>
            <polygon points="250,152 290,175 290,238 250,215" fill="rgba(255,255,255,0.6)" stroke="rgba(255,255,255,0.4)" strokeWidth="1.5"/>
            <polygon points="250,152 290,130 330,152 290,175" fill="rgba(255,255,255,0.9)" stroke="rgba(255,255,255,0.6)" strokeWidth="1.5"/>
            <line x1="262" y1="170" x2="280" y2="160" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" opacity="0.6"/>
            <line x1="262" y1="180" x2="278" y2="170" stroke="#16a34a" strokeWidth="1.5" strokeLinecap="round" opacity="0.4"/>

            {/* Floating card 1 — top right */}
            <g style={{ animation: "float1 4s ease-in-out infinite" }}>
              <rect x="310" y="40" width="80" height="52" rx="8" fill="url(#cardGrad)" opacity="0.9"/>
              <rect x="320" y="52" width="40" height="4" rx="2" fill="white" opacity="0.8"/>
              <rect x="320" y="60" width="28" height="3" rx="2" fill="white" opacity="0.5"/>
              <circle cx="354" cy="74" r="8" fill="rgba(255,255,255,0.3)"/>
              <text x="354" y="78" textAnchor="middle" fill="white" fontSize="10" fontWeight="bold">✓</text>
            </g>

            {/* Floating card 2 — left */}
            <g style={{ animation: "float2 5s ease-in-out infinite" }}>
              <rect x="20" y="100" width="70" height="44" rx="8" fill="rgba(255,255,255,0.2)" stroke="rgba(255,255,255,0.4)" strokeWidth="1"/>
              <rect x="30" y="110" width="35" height="3" rx="2" fill="white" opacity="0.8"/>
              <rect x="30" y="117" width="25" height="3" rx="2" fill="white" opacity="0.5"/>
              <rect x="30" y="126" width="40" height="8" rx="4" fill="#4ade80" opacity="0.8"/>
            </g>

            {/* Floating card 3 — bottom */}
            <g style={{ animation: "float3 3.5s ease-in-out infinite" }}>
              <rect x="130" y="240" width="90" height="50" rx="8" fill="rgba(255,255,255,0.18)" stroke="rgba(255,255,255,0.35)" strokeWidth="1"/>
              <circle cx="152" cy="260" r="10" fill="rgba(255,255,255,0.3)"/>
              <text x="152" y="265" textAnchor="middle" fill="white" fontSize="12">👤</text>
              <rect x="168" y="254" width="38" height="4" rx="2" fill="white" opacity="0.7"/>
              <rect x="168" y="262" width="26" height="3" rx="2" fill="white" opacity="0.4"/>
            </g>

            {/* CRM label on main device */}
            <text x="210" y="94" textAnchor="middle" fill="rgba(22,101,52,0.6)" fontSize="13" fontWeight="800" letterSpacing="2">CRM</text>

          </svg>
        </div>

        {/* Text below illustration */}
        <div style={{ textAlign: "center", position: "relative", zIndex: 2, marginTop: "8px", animation: "fadeUp 0.8s ease 0.2s both" }}>
          <h2 style={{ color: "#fff", fontSize: "26px", fontWeight: "800", margin: "0 0 10px", letterSpacing: "-0.5px" }}>
            SBM Udhayam CRM
          </h2>
          <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "14px", margin: 0, lineHeight: 1.6 }}>
            Construction & Unorganised Workers Union — Tenkasi
          </p>
        </div>


      </div>

      {/* ── RIGHT PANEL — White Login Card ── */}
      <div style={{
        flex: "0 0 42%",
        background: "#f0fdf4",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px 48px",
        position: "relative"
      }}>

        {/* Decorative corner lines like reference image */}
        <div style={{ position: "absolute", top: "24px", right: "24px", width: "28px", height: "28px", borderTop: "2.5px solid #16a34a", borderRight: "2.5px solid #16a34a", borderRadius: "0 4px 0 0" }}/>
        <div style={{ position: "absolute", bottom: "24px", left: "24px", width: "28px", height: "28px", borderBottom: "2.5px solid #16a34a", borderLeft: "2.5px solid #16a34a", borderRadius: "0 0 0 4px" }}/>

        <div style={{ width: "100%", maxWidth: "360px", animation: "fadeUp 0.6s ease" }}>

          {/* Logo */}
          <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "36px" }}>
            <div style={{ width: "44px", height: "44px", background: "linear-gradient(135deg, #22c55e, #15803d)", borderRadius: "12px", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 4px 14px rgba(22,163,74,0.4)", fontSize: "22px" }}>🏛️</div>
            <div>
              <div style={{ fontSize: "16px", fontWeight: "800", color: "#14532d", letterSpacing: "-0.3px" }}>SBM Udhayam</div>
              <div style={{ fontSize: "11px", color: "#6b7280", marginTop: "1px" }}>CRM System</div>
            </div>
          </div>

          {!otpStep ? (<>

            <div style={{ marginBottom: "28px" }}>
              <h2 style={{ fontSize: "24px", fontWeight: "800", color: "#111827", margin: "0 0 6px", letterSpacing: "-0.5px" }}>
                Sign in
              </h2>
              <p style={{ color: "#9ca3af", fontSize: "14px", margin: 0 }}>Enter your credentials to continue</p>
            </div>

            {/* Username */}
            <div style={{ marginBottom: "16px" }}>
              <label style={{ display: "block", fontSize: "12px", fontWeight: "600", color: "#374151", marginBottom: "8px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Username</label>
              <div style={{ position: "relative" }}>
                <span style={{ position: "absolute", left: "14px", top: "50%", transform: "translateY(-50%)", fontSize: "16px", color: "#9ca3af" }}>👤</span>
                <input
                  className="crm-input"
                  type="text"
                  placeholder="Enter your username"
                  value={username}
                  onChange={e => setUsername(e.target.value)}
                  onKeyDown={e => e.key === "Enter" && login()}
                />
              </div>
            </div>

            {/* Password */}
            <div style={{ marginBottom: "24px" }}>
              <label style={{ display: "block", fontSize: "12px", fontWeight: "600", color: "#374151", marginBottom: "8px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Password</label>
              <div style={{ position: "relative" }}>
                <span style={{ position: "absolute", left: "14px", top: "50%", transform: "translateY(-50%)", fontSize: "16px", color: "#9ca3af" }}>🔒</span>
                <input
                  className="crm-input"
                  type="password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  onKeyDown={e => e.key === "Enter" && login()}
                />
              </div>
            </div>

            <button className="crm-login-btn" onClick={login} disabled={isLoggingIn}>
              {isLoggingIn ? (
                <span style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                  <span style={{ width: "16px", height: "16px", border: "2px solid rgba(255,255,255,0.4)", borderTop: "2px solid #fff", borderRadius: "50%", display: "inline-block", animation: "spin 0.8s linear infinite" }}/>
                  Authenticating...
                </span>
              ) : "Sign In →"}
            </button>

          </>) : (<>

            <div style={{ marginBottom: "28px" }}>
              <div style={{ width: "48px", height: "48px", background: "#f0fdf4", border: "2px solid #16a34a", borderRadius: "14px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "22px", marginBottom: "16px" }}>🔐</div>
              <h2 style={{ fontSize: "22px", fontWeight: "800", color: "#111827", margin: "0 0 6px", letterSpacing: "-0.5px" }}>Two-Factor Auth</h2>
              <p style={{ color: "#9ca3af", fontSize: "14px", margin: 0 }}>Enter the 6-digit code from your authenticator app</p>
            </div>

            {showQR && (
              <div style={{ textAlign: "center", marginBottom: "20px", padding: "20px", background: "#fff", borderRadius: "12px", border: "1px solid #d1fae5" }}>
                <p style={{ color: "#ef4444", fontWeight: "600", fontSize: "12px", marginBottom: "8px" }}>🔐 First Time Setup — Scan QR</p>
                <div style={{ display: "inline-block", padding: "10px", background: "white", borderRadius: "8px" }}>
                  <QRCodeSVG value={qrUri} size={140} />
                </div>
              </div>
            )}

            <div style={{ marginBottom: "20px" }}>
              <label style={{ display: "block", fontSize: "12px", fontWeight: "600", color: "#374151", marginBottom: "8px", textTransform: "uppercase", letterSpacing: "0.5px" }}>OTP Code</label>
              <input
                className="crm-otp-input"
                type="text"
                placeholder="000000"
                maxLength={6}
                value={otpToken}
                onChange={e => setOtpToken(e.target.value.replace(/[^0-9]/g, ""))}
                onKeyDown={e => e.key === "Enter" && verifyOTP()}
              />
            </div>

            <button className="crm-login-btn" onClick={verifyOTP} style={{ marginBottom: "12px" }}>
              Verify OTP →
            </button>

            <button onClick={() => { setOtpStep(false); setOtpToken(""); setTempUser(null); setShowQR(false); setIsLoggingIn(false); }}
              style={{ width: "100%", padding: "13px", background: "transparent", color: "#6b7280", border: "1.5px solid #e5e7eb", borderRadius: "10px", fontSize: "14px", cursor: "pointer", fontFamily: "Inter, sans-serif" }}>
              ← Back
            </button>

          </>)}

          <div style={{ marginTop: "28px", textAlign: "center" }}>
            <p style={{ color: "#d1d5db", fontSize: "12px", margin: 0 }}>© 2026 SBM Udhayam · Tenkasi</p>
          </div>

        </div>
      </div>

      {/* Toast */}
      {toast && (
        <div style={{
          position: "fixed", top: "24px", right: "24px", zIndex: 9999,
          background: toast.type === "error" ? "#fef2f2" : "#f0fdf4",
          borderRadius: "12px", padding: "14px 20px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
          display: "flex", alignItems: "center", gap: "10px",
          borderLeft: toast.type === "error" ? "4px solid #ef4444" : "4px solid #16a34a",
        }}>
          <div style={{ width: "26px", height: "26px", borderRadius: "50%", background: toast.type === "error" ? "#ef4444" : "#16a34a", display: "flex", alignItems: "center", justifyContent: "center", color: "white", fontSize: "14px", fontWeight: "bold" }}>
            {toast.type === "error" ? "✕" : "✓"}
          </div>
          <span style={{ fontSize: "14px", fontWeight: "600", color: "#1f2937" }}>{toast.message}</span>
        </div>
      )}

    </div>
  );
}
  // Main CRM

  if (loading) {
    return (
      <div style={{ minHeight: "100vh", background: "#f8fafc", padding: "32px 60px" }}>
        <div className="skeleton-box" style={{ width: "220px", height: "28px", marginBottom: "28px" }} />
        <div className="row g-3 mb-4">
          {[1,2,3,4].map(i => (
            <div className="col-md-3" key={i}>
              <div className="skeleton-box" style={{ height: "110px" }} />
            </div>
          ))}
        </div>
        <div className="row g-3">
          <div className="col-md-6">
            <div className="skeleton-box" style={{ height: "260px" }} />
          </div>
          <div className="col-md-6">
            <div className="skeleton-box" style={{ height: "260px" }} />
          </div>
        </div>
      </div>
    );
  }

  const chartData = [

  {
    name: "Pending",
    value:
      customers.filter(
        (c) =>
          c.status === "Pending"
      ).length
  },

  {
    name: "Approved",
    value:
      customers.filter(
        (c) =>
          c.status === "Approved"
      ).length
  },

  {
    name: "Rejected",
    value:
      customers.filter(
        (c) =>
          c.status === "Rejected"
      ).length
  },

  {
    name: "Submitted",
    value:
      customers.filter(
        (c) =>
          c.status === "Submitted"
      ).length
  },

  {
    name: "Resubmitted",
    value:
      customers.filter(
        (c) =>
          c.status === "Resubmitted"
      ).length
  }

];

const COLORS = [
  "#facc15",
  "#22c55e",
  "#ef4444",
  "#3b82f6",
  "#a855f7"
];

  const rentalOnlyView = new URLSearchParams(window.location.search).get("view") === "Rental";
  if (rentalOnlyView) {
    return <RentalPage db={db} showToast={showToast} />;
  }

  return (
    <>
    {toast && (
      <div style={{
        position: "fixed", top: "24px", right: "24px", zIndex: 9999,
        background: toast.type === "error" ? "#fef2f2" : "#f0fdf4",
        borderRadius: "12px", padding: "16px 22px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
        display: "flex", alignItems: "center", gap: "12px",
        borderLeft: toast.type === "error" ? "4px solid #ef4444" : "4px solid #22c55e",
        animation: "toastSlideIn 0.3s ease"
      }}>
        <div style={{
          width: "28px", height: "28px", borderRadius: "50%",
          background: toast.type === "error" ? "#ef4444" : "#22c55e",
          display: "flex", alignItems: "center",
          justifyContent: "center", color: "white", fontSize: "16px", fontWeight: "bold"
        }}>{toast.type === "error" ? "✕" : "✓"}</div>
        <span style={{ fontSize: "14px", fontWeight: "600", color: "#1f2937" }}>{toast.message}</span>
        <style>{`
          @keyframes toastSlideIn {
            from { opacity: 0; transform: translateX(40px); }
            to { opacity: 1; transform: translateX(0); }
          }
        `}</style>
      </div>
    )}

    {showPaymentModal && paymentCustomer && (
      <div className="modal-overlay-fade" style={{
        position: "fixed", inset: 0, zIndex: 9998,
        background: "rgba(0,0,0,0.5)",
        display: "flex", alignItems: "center", justifyContent: "center"
      }}>
        <div className="modal-box-scale" style={{
          background: "white", borderRadius: "16px", padding: "28px",
          width: "420px", boxShadow: "0 20px 50px rgba(0,0,0,0.3)"
        }}>
          <h5 className="mb-3">💰 Add Payment — {paymentCustomer.name}</h5>
          <p className="text-muted mb-3" style={{ fontSize: "13px" }}>
            Pending Amount: <strong style={{ color: "#dc3545" }}>₹{paymentCustomer.pendingAmount || 0}</strong>
          </p>

          <label>Amount Paid <span className="text-danger">*</span></label>
          <input
            type="number"
            className="form-control mb-3"
            placeholder="Enter amount"
            value={paymentAmount}
            onChange={(e) => setPaymentAmount(e.target.value)}
          />

          <label>Payment Date <span className="text-danger">*</span></label>
          <div style={{ position: "relative" }} className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="DD/MM/YYYY"
              maxLength={10}
              value={paymentDate}
              onChange={(e) => {
                let v = e.target.value.replace(/[^0-9]/g, "");
                if (v.length > 2) v = v.slice(0,2) + "/" + v.slice(2);
                if (v.length > 5) v = v.slice(0,5) + "/" + v.slice(5);
                setPaymentDate(v.slice(0,10));
              }}
              style={{ paddingRight: "40px" }}
            />
            <input
              type="date"
              style={{ position: "absolute", top: 0, right: 0, width: "36px", height: "100%", opacity: 0, cursor: "pointer" }}
              onChange={(e) => {
                if (!e.target.value) return;
                const [y, m, d] = e.target.value.split("-");
                setPaymentDate(`${d}/${m}/${y}`);
              }}
            />
            <span style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}>📅</span>
          </div>

          <label>Notes</label>
          <input
            type="text"
            className="form-control mb-4"
            placeholder="Optional notes"
            value={paymentNotes}
            onChange={(e) => setPaymentNotes(e.target.value)}
          />

          <div className="d-flex gap-2">
            <button
              className="btn btn-success flex-grow-1"
              disabled={paymentSaving}
              onClick={addPayment}
            >
              {paymentSaving ? "Saving..." : "Save Payment"}
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => {
                setShowPaymentModal(false);
                setPaymentCustomer(null);
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    )}

    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

      * { font-family: 'Inter', 'Segoe UI', sans-serif; }

      /* Cards */
      .card {
        border-radius: 14px !important;
        border: 1px solid #eef0f3 !important;
        box-shadow: 0 1px 3px rgba(0,0,0,0.05) !important;
        transition: box-shadow 0.2s ease, transform 0.2s ease;
      }
      .card:hover {
        box-shadow: 0 6px 20px rgba(0,0,0,0.08) !important;
      }

      /* Buttons */
      .btn {
        border-radius: 9px !important;
        font-weight: 600 !important;
        letter-spacing: 0.2px;
        transition: all 0.15s ease !important;
      }
      .btn:hover { transform: translateY(-1px); }
      .btn:active { transform: translateY(0); }
      .btn-success { background: #16a34a !important; border-color: #16a34a !important; }
      .btn-primary { background: #2563eb !important; border-color: #2563eb !important; }

      /* Tables */
      .table { border-radius: 10px; overflow: hidden; }
      .table thead th {
        font-size: 11.5px !important;
        text-transform: uppercase;
        letter-spacing: 0.6px;
        color: #64748b !important;
        background: #f8fafc !important;
        border-bottom: 2px solid #e2e8f0 !important;
        font-weight: 700 !important;
      }
      .table tbody tr { transition: background 0.15s ease; }
      .table tbody tr:nth-child(even) { background: #fafbfc; }
      .table tbody tr:hover { background: #f1f5f9 !important; }
      .table td, .table th { vertical-align: middle !important; }

      /* Inputs */
      .form-control, .form-select {
        border-radius: 9px !important;
        border: 1.5px solid #e2e8f0 !important;
        transition: all 0.15s ease;
      }
      .form-control:focus, .form-select:focus {
        border-color: #2563eb !important;
        box-shadow: 0 0 0 3px rgba(37,99,235,0.12) !important;
      }

      /* Badges */
      .badge {
        border-radius: 20px !important;
        font-weight: 600 !important;
        padding: 5px 12px !important;
        letter-spacing: 0.3px;
      }

      /* Scrollbar polish */
      ::-webkit-scrollbar { width: 8px; height: 8px; }
      ::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
      ::-webkit-scrollbar-thumb:hover { background: #94a3b8; }

      /* Sidebar nav polish */
      .nav.flex-column > li > button {
        transition: all 0.18s ease !important;
      }
      .nav.flex-column > li > button:hover {
        background: rgba(96,165,250,0.10) !important;
        padding-left: 20px !important;
      }

      /* Sidebar logo area breathing shadow */
      .nav.flex-column {
        padding-top: 4px;
      }

      /* User dropdown polish */
      div[style*="position: fixed"][style*="inset: 0"] {
        backdrop-filter: blur(1px);
      }

      /* Skeleton loader shimmer */
      @keyframes shimmer {
        0% { background-position: -400px 0; }
        100% { background-position: 400px 0; }
      }
      .skeleton-box {
        background: linear-gradient(90deg, #eef1f4 25%, #f7f9fb 37%, #eef1f4 63%);
        background-size: 800px 100%;
        animation: shimmer 1.4s ease-in-out infinite;
        border-radius: 10px;
      }

      /* Modal animations */
      @keyframes modalOverlayFade {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes modalBoxScale {
        from { opacity: 0; transform: scale(0.92) translateY(10px); }
        to { opacity: 1; transform: scale(1) translateY(0); }
      }
      .modal-overlay-fade { animation: modalOverlayFade 0.2s ease; }
      .modal-box-scale { animation: modalBoxScale 0.25s cubic-bezier(0.16, 1, 0.3, 1); }
    `}</style>
    <div className="d-flex">
      {/* Sidebar */}

<div style={{
  width: "260px",
  minHeight: "100vh",
  background: "#1e293b",
borderRight: "1px solid #334155",
display: "flex",
flexDirection: "column",
position: "fixed",
top: 0,
left: 0,
height: "100vh",
overflowY: "auto",
boxShadow: "2px 0 8px rgba(0,0,0,0.2)"
}}>

  {/* Logo Area */}
  <div style={{ padding: "20px 20px 16px", borderBottom: "1px solid #334155" }}>
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <div style={{ width: "36px", height: "36px", background: "linear-gradient(135deg, #2563eb, #1d4ed8)", borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "18px" }}>🏛️</div>
      <div>
        <h5 style={{ margin: 0, color: "#fff", fontWeight: "800", fontSize: "14px" }}>SBM உதயம்</h5>
        <small style={{ color: "#94a3b8", fontSize: "10px" }}>CRM System</small>
      </div>
    </div>
  </div>

  {/* Nav Items */}
  <div style={{ padding: "12px 8px", flex: 1, overflowY: "auto" }}>
    <ul className="nav flex-column" style={{ gap: "2px" }}>

  <li className="nav-item mb-1">
    <button
      onClick={() => setActiveMenu("Dashboard")}
      style={{
        width: "100%", textAlign: "left", border: "none", borderRadius: "8px",
        padding: "10px 14px", fontSize: "17px", fontWeight: "600", cursor: "pointer",
        background: activeMenu === "Dashboard" ? "rgba(96,165,250,0.15)" : "transparent",
        color: activeMenu === "Dashboard" ? "#60a5fa" : "#94a3b8",
        borderLeft: activeMenu === "Dashboard" ? "3px solid #2563eb" : "3px solid transparent",
        transition: "all 0.15s"
      }}
    >
      <FaTachometerAlt size={15} className="nav-ic" /> Dashboard
    </button>
  </li>

  <li className="nav-item mb-1">
    <button
      onClick={() => {
        setActiveMenu("New Application");
        setLockFields(false); setIsExistingCustomer(false);
        setViewCustomer(null);
        setEditId(null);
        setEditMode("full");
        setName("");
        setMobile("");
        setScheme("");
        setStatus("");
        setRemarks("");
        setCardNumber("");
        setApplyingFor("");
        setAmountReceived("");
        setPaymentType("");
        setPendingAmount("");
        setGuardianName("");
        setDob("");
        setLocation("");
        setMobileDuplicateWarning("");
        setApplicationDate("");
      }}
      style={{
        width: "100%", textAlign: "left", border: "none", borderRadius: "8px",
        padding: "10px 14px", fontSize: "17px", fontWeight: "600", cursor: "pointer",
        background: activeMenu === "New Application" ? "#eff6ff" : "transparent",
        color: activeMenu === "New Application" ? "#2563eb" : "#64748b",
        borderLeft: activeMenu === "New Application" ? "3px solid #2563eb" : "3px solid transparent",
        transition: "all 0.15s"
      }}
    >
      <FaFileAlt size={15} className="nav-ic" /> New Application
    </button>
  </li>

  <li className="nav-item mb-1">
    <button
      onClick={() => setActiveMenu("Customer List")}
      style={{
        width: "100%", textAlign: "left", border: "none", borderRadius: "8px",
        padding: "10px 14px", fontSize: "17px", fontWeight: "600", cursor: "pointer",
        background: activeMenu === "Customer List" ? "#eff6ff" : "transparent",
        color: activeMenu === "Customer List" ? "#2563eb" : "#64748b",
        borderLeft: activeMenu === "Customer List" ? "3px solid #2563eb" : "3px solid transparent",
        transition: "all 0.15s"
      }}
    >
      <FaUsers size={15} className="nav-ic" /> Customer List
    </button>
  </li>

  <li className="nav-item mb-1">
    <button
      onClick={() => setActiveMenu("Application List")}
      style={{
        width: "100%", textAlign: "left", border: "none", borderRadius: "8px",
        padding: "10px 14px", fontSize: "17px", fontWeight: "600", cursor: "pointer",
        background: activeMenu === "Application List" ? "#eff6ff" : "transparent",
        color: activeMenu === "Application List" ? "#2563eb" : "#64748b",
        borderLeft: activeMenu === "Application List" ? "3px solid #2563eb" : "3px solid transparent",
        transition: "all 0.15s"
      }}
    >
      <FaClipboardList size={15} className="nav-ic" /> Application List
    </button>
  </li>

 {localStorage.getItem("role") === "Admin" && (
    <li className="nav-item mb-1">
      <button
        onClick={() => setActiveMenu("Financial")}
        style={{
          width: "100%", textAlign: "left", border: "none", borderRadius: "8px",
          padding: "10px 14px", fontSize: "17px", fontWeight: "600", cursor: "pointer",
          background: activeMenu === "Financial" ? "#eff6ff" : "transparent",
          color: activeMenu === "Financial" ? "#2563eb" : "#64748b",
          borderLeft: activeMenu === "Financial" ? "3px solid #2563eb" : "3px solid transparent",
          transition: "all 0.15s"
        }}
      >
        <FaWallet size={15} className="nav-ic" /> Financial
      </button>
    </li>
  )}

  {localStorage.getItem("role") === "Admin" && (
    <li className="nav-item mb-1">
      <button
        onClick={() => setActiveMenu("Loans")}
        style={{
          width: "100%", textAlign: "left", border: "none", borderRadius: "8px",
          padding: "10px 14px", fontSize: "17px", fontWeight: "600", cursor: "pointer",
          background: activeMenu === "Loans" ? "#eff6ff" : "transparent",
          color: activeMenu === "Loans" ? "#2563eb" : "#64748b",
          borderLeft: activeMenu === "Loans" ? "3px solid #2563eb" : "3px solid transparent",
          transition: "all 0.15s"
        }}
      >
        <FaHandHoldingUsd size={15} className="nav-ic" /> Loans
      </button>
    </li>
  )}

  {localStorage.getItem("role") === "Admin" && (
    <li className="nav-item mb-1">
      <button
        onClick={() => setActiveMenu("User Management")}
        style={{
          width: "100%", textAlign: "left", border: "none", borderRadius: "8px",
          padding: "10px 14px", fontSize: "17px", fontWeight: "600", cursor: "pointer",
          background: activeMenu === "User Management" ? "#eff6ff" : "transparent",
          color: activeMenu === "User Management" ? "#2563eb" : "#64748b",
          borderLeft: activeMenu === "User Management" ? "3px solid #2563eb" : "3px solid transparent",
          transition: "all 0.15s"
        }}
      >
        <FaUserCog size={15} className="nav-ic" /> User Management
      </button>
    </li>
  )}

  {localStorage.getItem("role") === "Admin" && (
    <li className="nav-item mb-1">
      <button
        onClick={() => setActiveMenu("Activity Log")}
        style={{
          width: "100%", textAlign: "left", border: "none", borderRadius: "8px",
          padding: "10px 14px", fontSize: "17px", fontWeight: "600", cursor: "pointer",
          background: activeMenu === "Activity Log" ? "#eff6ff" : "transparent",
          color: activeMenu === "Activity Log" ? "#2563eb" : "#64748b",
          borderLeft: activeMenu === "Activity Log" ? "3px solid #2563eb" : "3px solid transparent",
          transition: "all 0.15s"
        }}
      >
        <FaHistory size={15} className="nav-ic" /> Activity Log
      </button>
    </li>
  )}

<li className="nav-item mb-1">
    <button
      onClick={() => setShowSettings(p => !p)}
      style={{
        width: "100%", textAlign: "left", border: "none", borderRadius: "8px",
        padding: "11px 16px", fontSize: "15px", fontWeight: "600", cursor: "pointer",
        background: "transparent",
        color: "#94a3b8",
        borderLeft: "3px solid transparent",
        transition: "all 0.15s",
        display: "flex", justifyContent: "space-between", alignItems: "center"
      }}
    >
      <span><FaCog size={15} className="nav-ic" /> Settings</span>
      <span>{showSettings ? "▼" : "▶"}</span>
    </button>
  </li>

  {showSettings && (
    <>

    <li className="nav-item mb-1">
    <button
      onClick={() => setActiveMenu("Location Manager")}
      style={{
        width: "100%", textAlign: "left", border: "none", borderRadius: "8px",
        padding: "10px 14px", fontSize: "17px", fontWeight: "600", cursor: "pointer",
        background: activeMenu === "Location Manager" ? "#eff6ff" : "transparent",
        color: activeMenu === "Location Manager" ? "#2563eb" : "#64748b",
        borderLeft: activeMenu === "Location Manager" ? "3px solid #2563eb" : "3px solid transparent",
        transition: "all 0.15s"
      }}
    >
      <FaMapMarkerAlt size={15} className="nav-ic" /> Location Manager
    </button>
  </li>

  {localStorage.getItem("role") === "Admin" && (
    <li className="nav-item mb-1">
      <button
        onClick={() => setActiveMenu("Service Categories")}
        style={{
          width: "100%", textAlign: "left", border: "none", borderRadius: "8px",
          padding: "10px 14px", fontSize: "17px", fontWeight: "600", cursor: "pointer",
          background: activeMenu === "Service Categories" ? "#eff6ff" : "transparent",
          color: activeMenu === "Service Categories" ? "#2563eb" : "#64748b",
          borderLeft: activeMenu === "Service Categories" ? "3px solid #2563eb" : "3px solid transparent",
          transition: "all 0.15s"
        }}
      >
        <FaTools size={15} className="nav-ic" /> Service Categories
      </button>
    </li>
  )}

  {localStorage.getItem("role") === "Admin" && (
    <li className="nav-item mb-1">
      <button
        onClick={() => setActiveMenu("Amount Categories")}
        style={{
          width: "100%", textAlign: "left", border: "none", borderRadius: "8px",
          padding: "10px 14px", fontSize: "17px", fontWeight: "600", cursor: "pointer",
          background: activeMenu === "Amount Categories" ? "#eff6ff" : "transparent",
          color: activeMenu === "Amount Categories" ? "#2563eb" : "#64748b",
          borderLeft: activeMenu === "Amount Categories" ? "3px solid #2563eb" : "3px solid transparent",
          transition: "all 0.15s"
        }}
      >
        <FaRupeeSign size={15} className="nav-ic" /> Amount Categories
      </button>
    </li>
  )}

  {localStorage.getItem("role") === "Admin" && (
    <li className="nav-item mb-1">
      <button
        onClick={() => setActiveMenu("Expense Categories")}
        style={{
          width: "100%", textAlign: "left", border: "none", borderRadius: "8px",
          padding: "10px 14px", fontSize: "17px", fontWeight: "600", cursor: "pointer",
          background: activeMenu === "Expense Categories" ? "#eff6ff" : "transparent",
          color: activeMenu === "Expense Categories" ? "#2563eb" : "#64748b",
          borderLeft: activeMenu === "Expense Categories" ? "3px solid #2563eb" : "3px solid transparent",
          transition: "all 0.15s"
        }}
      >
        <FaTags size={15} className="nav-ic" /> Expense Categories
      </button>
    </li>
  )}

  </>
  )}

  {selectedProfile && (
    <li className="nav-item mb-1">
      <button
        onClick={() => setActiveMenu("Customer Profile")}
        style={{
          width: "100%", textAlign: "left", border: "none", borderRadius: "8px",
          padding: "10px 14px", fontSize: "17px", fontWeight: "600", cursor: "pointer",
          background: activeMenu === "Customer Profile" ? "#eff6ff" : "transparent",
          color: activeMenu === "Customer Profile" ? "#2563eb" : "#64748b",
          borderLeft: activeMenu === "Customer Profile" ? "3px solid #2563eb" : "3px solid transparent",
          transition: "all 0.15s"
        }}
      >
        <FaUserCircle size={15} className="nav-ic" /> {selectedProfile.name}
      </button>
    </li>
  )}

</ul>
</div>

</div> {/* Main */}

      <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", width: "calc(100% - 260px)", marginLeft: "260px", overflowX: "hidden" }}>
        {/* Top Bar */}
        <div style={{
          background: "white",
          borderBottom: "1px solid #e2e8f0",
          padding: "0 24px",
          height: "56px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
          position: "sticky",
          top: 0,
          zIndex: 100
        }}>
          {/* Left — Page Title */}
          <h5 style={{ margin: 0, color: "#1e293b", fontWeight: "700", fontSize: "15px" }}>{activeMenu}</h5>

          {/* Center — Global Search */}
          <div style={{ position: "relative", width: "320px" }}>
            <input
              type="text"
              placeholder="🔍 Search customer, mobile, app ID..."
              value={globalSearch}
              onChange={e => { setGlobalSearch(e.target.value); setShowGlobalResults(e.target.value.length > 0); }}
              onBlur={() => setTimeout(() => setShowGlobalResults(false), 300)}
              style={{
                width: "100%", padding: "8px 16px",
                border: "1.5px solid #e2e8f0", borderRadius: "20px",
                fontSize: "13px", outline: "none",
                background: "#f8fafc", color: "#1e293b",
                boxSizing: "border-box"
              }}
            />
            {showGlobalResults && globalSearch.length > 0 && (() => {
              const results = customers.filter(c =>
                c.name?.toLowerCase().includes(globalSearch.toLowerCase()) ||
                c.mobile?.includes(globalSearch) ||
                c.appId?.toLowerCase().includes(globalSearch.toLowerCase()) ||
                c.applicationId?.toLowerCase().includes(globalSearch.toLowerCase())
              ).slice(0, 6);
              return (
                <div style={{
                  position: "absolute", top: "110%", left: 0, right: 0,
                  background: "white", border: "1px solid #e2e8f0",
                  borderRadius: "12px", boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                  zIndex: 200, overflow: "hidden"
                }}>
                  {results.length === 0 ? (
                    <div style={{ padding: "12px 16px", color: "#94a3b8", fontSize: "13px" }}>No results found</div>
                  ) : results.map((c, i) => (
                    <div
                      key={i}
                      onClick={() => {
                        setSelectedProfile(c);
                        setActiveMenu("Customer Profile");
                        setGlobalSearch("");
                        setShowGlobalResults(false);
                      }}
                      style={{
                        padding: "10px 16px", cursor: "pointer",
                        borderBottom: i < results.length - 1 ? "1px solid #f1f5f9" : "none",
                        display: "flex", alignItems: "center", gap: "10px"
                      }}
                      onMouseEnter={e => e.currentTarget.style.background = "#f8fafc"}
                      onMouseLeave={e => e.currentTarget.style.background = "white"}
                    >
                      <div style={{
                        width: "32px", height: "32px", background: "#eff6ff",
                        borderRadius: "50%", display: "flex", alignItems: "center",
                        justifyContent: "center", fontSize: "13px", fontWeight: "700", color: "#2563eb"
                      }}>
                        {(c.name || "U")[0].toUpperCase()}
                      </div>
                      <div>
                        <div style={{ fontSize: "13px", fontWeight: "600", color: "#1e293b" }}>{c.name}</div>
                        <div style={{ fontSize: "11px", color: "#94a3b8" }}>{c.appId} • {c.mobile}</div>
                      </div>
                    </div>
                  ))}
                </div>
              );
            })()}
          </div>

          {/* Right — User Dropdown */}
          <div style={{ position: "relative" }}>
            <div
              onClick={() => setShowUserDropdown(!showUserDropdown)}
              style={{
                display: "flex", alignItems: "center", gap: "8px",
                cursor: "pointer", padding: "6px 12px",
                background: showUserDropdown ? "#f1f5f9" : "transparent",
                borderRadius: "10px", transition: "all 0.2s"
              }}
            >
              <div style={{
                width: "32px", height: "32px",
                background: "linear-gradient(135deg, #2563eb, #1d4ed8)",
                borderRadius: "50%", display: "flex", alignItems: "center",
                justifyContent: "center", fontSize: "13px", fontWeight: "800", color: "#fff"
              }}>
                {(localStorage.getItem("loggedUser") || "U")[0].toUpperCase()}
              </div>
              <div>
                <div style={{ fontSize: "13px", fontWeight: "700", color: "#1e293b" }}>
                  {localStorage.getItem("loggedUser")}
                </div>
                <div style={{ fontSize: "10px", color: "#94a3b8" }}>
                  {localStorage.getItem("role")}
                </div>
              </div>
              <span style={{ color: "#94a3b8", fontSize: "12px" }}>▼</span>
            </div>

            {showUserDropdown && (
              <>
                <div
                  style={{ position: "fixed", inset: 0, zIndex: 99 }}
                  onClick={() => setShowUserDropdown(false)}
                />
                <div style={{
                  position: "absolute", right: 0, top: "110%",
                  background: "white", border: "1px solid #e2e8f0",
                  borderRadius: "12px", padding: "8px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                  minWidth: "180px", zIndex: 100
                }}>
                  <div style={{ padding: "10px 12px", borderBottom: "1px solid #f1f5f9", marginBottom: "6px" }}>
                    <div style={{ fontSize: "13px", fontWeight: "700", color: "#1e293b" }}>
                      {localStorage.getItem("loggedUser")}
                    </div>
                    <div style={{ fontSize: "11px", color: "#94a3b8" }}>
                      {localStorage.getItem("role")}
                    </div>
                  </div>
                  <button
                    onClick={() => { setShowUserDropdown(false); window.open(window.location.origin + window.location.pathname + "?view=Rental", "_blank"); }}
                    style={{
                      width: "100%", padding: "9px 12px", border: "none",
                      borderRadius: "8px", background: "rgba(37,99,235,0.08)",
                      color: "#2563eb", fontSize: "13px", fontWeight: "600",
                      cursor: "pointer", textAlign: "left",
                      display: "flex", alignItems: "center", gap: "8px",
                      marginBottom: "6px"
                    }}
                  >
                    🏠 Rental
                  </button>
                  <button
                    onClick={() => { setShowUserDropdown(false); logout(); }}
                    style={{
                      width: "100%", padding: "9px 12px", border: "none",
                      borderRadius: "8px", background: "rgba(239,68,68,0.08)",
                      color: "#ef4444", fontSize: "13px", fontWeight: "600",
                      cursor: "pointer", textAlign: "left",
                      display: "flex", alignItems: "center", gap: "8px"
                    }}
                  >
                    <FaTimesCircle size={13} /> Logout
                  </button>
                </div>
              </>
            )}
          </div>
        </div>

        <div className="p-4">
        <h2>{activeMenu}</h2>

        {/* Dashboard */}

{activeMenu === "Dashboard" && (
<div style={{ padding: "8px 0" }}>

  {/* KPI Cards */}
  <div className="row g-3 mb-4">

    {/* Total Applications */}
    <div className="col-md-3">
      <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: "12px", padding: "20px 24px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", borderLeft: "4px solid #2563eb" }}>
        <div style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>Total Applications</div>
        <div style={{ fontSize: "32px", fontWeight: "800", color: "#1e293b" }}><AnimatedNumber value={customers.length} /></div>
        <div style={{ fontSize: "12px", color: "#94a3b8", marginTop: "4px" }}>👤 {new Set(customers.map(c => c.mobile)).size} unique customers</div>
      </div>
    </div>

    {/* Pending */}
    <div className="col-md-3">
      <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: "12px", padding: "20px 24px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", borderLeft: "4px solid #f59e0b" }}>
        <div style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>Pending</div>
        <div style={{ fontSize: "32px", fontWeight: "800", color: "#1e293b" }}><AnimatedNumber value={customers.filter(c => c.status === "Pending").length} /></div>
        <div style={{ fontSize: "12px", color: "#94a3b8", marginTop: "4px" }}>Awaiting review</div>
      </div>
    </div>

    {/* Approved */}
    <div className="col-md-3">
      <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: "12px", padding: "20px 24px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", borderLeft: "4px solid #22c55e" }}>
        <div style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>Approved</div>
        <div style={{ fontSize: "32px", fontWeight: "800", color: "#1e293b" }}><AnimatedNumber value={customers.filter(c => c.status === "Approved").length} /></div>
        <div style={{ fontSize: "12px", color: "#94a3b8", marginTop: "4px" }}>Successfully processed</div>
      </div>
    </div>

    {/* Rejected */}
    <div className="col-md-3">
      <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: "12px", padding: "20px 24px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", borderLeft: "4px solid #ef4444" }}>
        <div style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>Rejected</div>
        <div style={{ fontSize: "32px", fontWeight: "800", color: "#1e293b" }}><AnimatedNumber value={customers.filter(c => c.status === "Rejected").length} /></div>
        <div style={{ fontSize: "12px", color: "#94a3b8", marginTop: "4px" }}>Not approved</div>
      </div>
    </div>

    {/* Submitted */}
    <div className="col-md-3">
      <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: "12px", padding: "20px 24px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", borderLeft: "4px solid #3b82f6" }}>
        <div style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>Submitted</div>
        <div style={{ fontSize: "32px", fontWeight: "800", color: "#1e293b" }}><AnimatedNumber value={customers.filter(c => c.status === "Submitted").length} /></div>
        <div style={{ fontSize: "12px", color: "#94a3b8", marginTop: "4px" }}>Under process</div>
      </div>
    </div>

    {/* Resubmitted */}
    <div className="col-md-3">
      <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: "12px", padding: "20px 24px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", borderLeft: "4px solid #a855f7" }}>
        <div style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>Resubmitted</div>
        <div style={{ fontSize: "32px", fontWeight: "800", color: "#1e293b" }}><AnimatedNumber value={customers.filter(c => c.status === "Resubmitted").length} /></div>
        <div style={{ fontSize: "12px", color: "#94a3b8", marginTop: "4px" }}>Re-processing</div>
      </div>
    </div>

    {/* Full Payments */}
    <div className="col-md-3">
      <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: "12px", padding: "20px 24px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", borderLeft: "4px solid #10b981" }}>
        <div style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>Full Payments</div>
        <div style={{ fontSize: "32px", fontWeight: "800", color: "#1e293b" }}><AnimatedNumber value={customers.filter(c => c.paymentType === "Full payment").length} /></div>
        <div style={{ fontSize: "12px", color: "#94a3b8", marginTop: "4px" }}>Fully collected</div>
      </div>
    </div>

    {/* Partial Payments */}
    <div className="col-md-3">
      <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: "12px", padding: "20px 24px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", borderLeft: "4px solid #f59e0b" }}>
        <div style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>Partial Payments</div>
        <div style={{ fontSize: "32px", fontWeight: "800", color: "#1e293b" }}><AnimatedNumber value={customers.filter(c => c.paymentType === "Partial payment").length} /></div>
        <div style={{ fontSize: "12px", color: "#94a3b8", marginTop: "4px" }}>Balance pending</div>
      </div>
    </div>

  </div>

  {/* Chandha Renewal Reminders */}
  {(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Get first application per customer
    const uniqueCustomers = Object.values(
      customers.reduce((acc, c) => {
        if (!acc[c.mobile]) {
          acc[c.mobile] = c;
        } else {
          const existing = acc[c.mobile].createdDate?.split("/").reverse().join("-");
          const current = c.createdDate?.split("/").reverse().join("-");
          if (current < existing) acc[c.mobile] = c;
        }
        return acc;
      }, {})
    );

    const reminders = uniqueCustomers.filter(c => {
      if (!c.createdDate) return false;
      const parts = c.createdDate.split("/");
      if (parts.length !== 3) return false;
      const joinDate = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
      joinDate.setHours(0, 0, 0, 0);

      // Anniversary this year
      const anniversary = new Date(joinDate);
      anniversary.setFullYear(today.getFullYear());
      if (anniversary <= joinDate) anniversary.setFullYear(today.getFullYear() + 1);

      const diffDays = Math.ceil((anniversary - today) / (1000 * 60 * 60 * 24));
      if (diffDays < 0 || diffDays > 7) return false;

      // Check if payment already made during reminder period (anniversary - 7 days to anniversary)
      const reminderStart = new Date(anniversary);
      reminderStart.setDate(reminderStart.getDate() - 7);
      const reminderStartStr = reminderStart.toISOString().split("T")[0];
      const anniversaryStr = anniversary.toISOString().split("T")[0];

      const paid = allPaymentsData.some(p => {
        if (p.customerId !== c.firestoreId) return false;
        let payDate;
        if (p.date && p.date.includes("/")) {
          const pp = p.date.split("/");
          payDate = new Date(Number(pp[2]), Number(pp[1]) - 1, Number(pp[0]));
        } else {
          payDate = new Date(p.date);
        }
        if (isNaN(payDate.getTime())) return false;
        const payStr = payDate.toISOString().split("T")[0];
        return payStr >= reminderStartStr && payStr <= anniversaryStr;
      });

      return !paid;
    }).map(c => {
      const parts = c.createdDate.split("/");
      const joinDate = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
      const anniversary = new Date(joinDate);
      anniversary.setFullYear(today.getFullYear());
      if (anniversary <= joinDate) anniversary.setFullYear(today.getFullYear() + 1);
      const diffDays = Math.ceil((anniversary - today) / (1000 * 60 * 60 * 24));
      return { ...c, diffDays };
    }).sort((a, b) => a.diffDays - b.diffDays);

    if (reminders.length === 0) return null;

    return (
      <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: "12px", padding: "20px 24px", marginBottom: "16px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
        <div style={{ fontSize: "14px", fontWeight: "700", color: "#1e293b", marginBottom: "14px" }}>
          🔔 Chandha Renewal Reminders ({reminders.length})
        </div>
        <table className="table table-sm mb-0">
          <thead>
            <tr style={{ fontSize: "12px", color: "#64748b" }}>
              <th>Member Name</th>
              <th>Mobile</th>
              <th>Joined Date</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {reminders.map((c, i) => (
              <tr key={i} style={{ fontSize: "13px" }}>
                <td>
                  <span
                    style={{ color: "#2563eb", cursor: "pointer", fontWeight: "600" }}
                    onClick={() => { setSelectedProfile(c); setActiveMenu("Customer Profile"); }}
                  >
                    {c.name}
                  </span>
                </td>
                <td>{c.mobile}</td>
                <td>{c.createdDate}</td>
                <td>
                  {c.diffDays === 0 ? (
                    <span className="badge bg-success">Due Today! 🎉</span>
                  ) : (
                    <span className="badge bg-warning text-dark">Due in {c.diffDays} days</span>
                  )}
                </td>
                <td>
                  <a
                    href={`https://wa.me/91${c.mobile}?text=${encodeURIComponent(`Hello ${c.name},\n\nYour SBM Udhayam Chandha (membership fee) renewal is due. Please contact us or visit our office to renew.\n\nThank you.`)}`}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-sm btn-outline-success"
                  >
                    💬 Remind
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  })()}

  

  {/* Charts */}
  {localStorage.getItem("role") === "Admin" && (
    <div className="row g-3">
      <div className="col-md-6">
        <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: "12px", padding: "24px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
          <div style={{ fontSize: "14px", fontWeight: "700", color: "#1e293b", marginBottom: "16px" }}>Application Status Overview</div>
          <div style={{ width: "100%", height: "220px", overflow: "hidden" }}>
          <ResponsiveContainer width="100%" height="100%" minWidth={100} minHeight={100} debounce={1}>
            <PieChart>
              <Pie data={[
                { name: "Pending", value: customers.filter(c => c.status === "Pending").length, fill: "#f59e0b" },
                { name: "Approved", value: customers.filter(c => c.status === "Approved").length, fill: "#22c55e" },
                { name: "Rejected", value: customers.filter(c => c.status === "Rejected").length, fill: "#ef4444" },
                { name: "Submitted", value: customers.filter(c => c.status === "Submitted").length, fill: "#3b82f6" },
                { name: "Resubmitted", value: customers.filter(c => c.status === "Resubmitted").length, fill: "#a855f7" },
              ].filter(d => d.value > 0)} cx="50%" cy="50%" outerRadius={70} dataKey="value" label={({ name, value }) => `${name}: ${value}`} />
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
          </div>
        </div>
      </div>
      <div className="col-md-6">
        <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: "12px", padding: "24px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
          <div style={{ fontSize: "14px", fontWeight: "700", color: "#1e293b", marginBottom: "16px" }}>Payment Overview</div>
          <div style={{ width: "100%", height: "220px", overflow: "hidden" }}>
          <ResponsiveContainer width="100%" height="100%" minWidth={100} minHeight={100} debounce={1}>
            <BarChart data={[
              { name: "Full Payment", value: customers.filter(c => c.paymentType === "Full payment").length, fill: "#10b981" },
              { name: "Partial Payment", value: customers.filter(c => c.paymentType === "Partial payment").length, fill: "#f59e0b" },
            ]}>
              <XAxis dataKey="name" tick={{ fontSize: 12 }} />
              <YAxis tick={{ fontSize: 12 }} />
              <Tooltip />
              <Bar dataKey="value" radius={[6, 6, 0, 0]}>
                {[{ fill: "#10b981" }, { fill: "#f59e0b" }].map((entry, index) => (
                  <Cell key={index} fill={entry.fill} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  )}

</div>
)}

{activeMenu === "Customer List" && (
  <div className="mt-4">
    {loading ? (
      <div style={{
        display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center",
        height: "400px", gap: "16px"
      }}>
        <div style={{
          width: "50px", height: "50px",
          border: "4px solid rgba(212,175,55,0.2)",
          borderTop: "4px solid #d4af37",
          borderRadius: "50%",
          animation: "spin 0.8s linear infinite"
        }} />
        <p style={{ color: "#8899bb", fontSize: "14px" }}>Loading customers...</p>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    ) : (
    <div className="card shadow p-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>Customer List</h4>
        <div className="d-flex align-items-center gap-2">
          <span className="badge bg-success fs-6">{new Set(customers.map(c => c.mobile)).size} Customers</span>
          {localStorage.getItem("role") === "Admin" && (
            idsFixed ? (
              <button className="btn btn-outline-secondary btn-sm" disabled>
                ✅ IDs Fixed (Locked)
              </button>
            ) : (
              <button
                className="btn btn-outline-warning btn-sm"
                onClick={async () => {
                  if (!window.confirm("This is a ONE-TIME migration: Customer IDs will be cleared for customers who are not Approved. Approved customers will get a fresh sequential ID (SBM0001, SBM0002...). This can be run only ONCE. Continue?")) return;
                  showToast("Fixing Customer IDs...");
                  const parseCreatedDateTime = (c) => {
                    if (!c.createdDate) return new Date(0);
                    const parts = c.createdDate.split("/");
                    if (parts.length !== 3) return new Date(0);
                    const [d, m, y] = parts.map(Number);
                    if (!d || !m || !y) return new Date(0);
                    let hh = 0, mm2 = 0;
                    const t = (c.createdTime || "").match(/(\d+):(\d+):?\d*\s*(AM|PM)?/i);
                    if (t) {
                      hh = Number(t[1]) % 12;
                      mm2 = Number(t[2]);
                      if (t[3] && t[3].toUpperCase() === "PM") hh += 12;
                    }
                    return new Date(y, m - 1, d, hh, mm2);
                  };
                  const freshSnap = await getDocs(collection(db, "customers"));
                  const freshCustomers = [];
                  freshSnap.forEach((d) => freshCustomers.push({ firestoreId: d.id, ...d.data() }));

                  const isApprovedStatus = (c) => (c.status || "").toString().trim().toLowerCase() === "approved";
                  const approvedSorted = freshCustomers
                    .filter(isApprovedStatus)
                    .sort((a, b) => parseCreatedDateTime(a) - parseCreatedDateTime(b));
                  let counter = 1;
                  let failCount = 0;
                  const failedNames = [];
                  for (const c of approvedSorted) {
                    const newId = "SBM" + String(counter).padStart(4, "0");
                    counter++;
                    if (c.applicationId !== newId) {
                      try {
                        await updateDoc(doc(db, "customers", c.firestoreId), { applicationId: newId });
                      } catch (err) {
                        console.error("Failed to update", c.name, c.firestoreId, err);
                        failCount++;
                        failedNames.push(c.name);
                      }
                    }
                  }
                  for (const c of freshCustomers) {
                    if (!isApprovedStatus(c) && c.applicationId) {
                      try {
                        await updateDoc(doc(db, "customers", c.firestoreId), { applicationId: "" });
                      } catch (err) {
                        console.error("Failed to clear", c.name, c.firestoreId, err);
                        failCount++;
                        failedNames.push(c.name);
                      }
                    }
                  }
                  if (failCount > 0) {
                    console.error("Failed records:", failedNames);
                    showToast(`⚠️ ${failCount} record(s) update failed! Console பாருங்க. Names: ${failedNames.join(", ")}`, "error");
                  }
                  // ✅ Counter-ஐ சரியான இடத்துக்கு set பண்ணனும், இல்லைன்னா duplicate ID வரும்
                  try {
                    const { setDoc: setCounterDoc } = await import("firebase/firestore");
                    await setCounterDoc(doc(db, "counters", "customerIdCounter"), { value: counter - 1 }, { merge: true });
                  } catch (err) {
                    console.error("Counter sync failed:", err);
                    showToast("⚠️ Counter sync fail ஆயிடுச்சு! Admin-கிட்ட சொல்லுங்க", "error");
                  }
                  try {
                    await updateDoc(doc(db, "settings", "migrationFlags"), { customerIdsFixed: true });
                  } catch {
                    const { setDoc } = await import("firebase/firestore");
                    await setDoc(doc(db, "settings", "migrationFlags"), { customerIdsFixed: true });
                  }
                  setIdsFixed(true);
                  showToast("Customer IDs Fixed! This can't be run again.");
                  fetchCustomers();
                }}
              >
                🔧 Fix Customer IDs (One-time)
              </button>
            )
          )}
          {localStorage.getItem("role") === "Admin" && (
            <button
              className="btn btn-outline-danger btn-sm"
              onClick={async () => {
                if (!window.confirm("This will CLEAR the Customer ID (applicationId) for ALL customers. You will need to re-enter each one manually. This cannot be undone. Continue?")) return;
                const confirmAgain = window.confirm("Are you REALLY sure? This clears IDs for ALL " + customers.length + " customers.");
                if (!confirmAgain) return;

                showToast("Clearing all Customer IDs...");
                let clearedCount = 0;
                let failCount = 0;

                for (const c of customers) {
                  if (c.applicationId) {
                    try {
                      await updateDoc(doc(db, "customers", c.firestoreId), { applicationId: "" });
                      clearedCount++;
                    } catch (err) {
                      console.error("Failed to clear", c.name, c.firestoreId, err);
                      failCount++;
                    }
                  }
                }

                try {
                  const { setDoc: setCounterDoc } = await import("firebase/firestore");
                  await setCounterDoc(doc(db, "counters", "customerIdCounter"), { value: 0 }, { merge: true });
                } catch (err) {
                  console.error("Counter reset failed:", err);
                }

                await logActivity(
                  "All Customer IDs Cleared",
                  `${clearedCount} customer ID(s) cleared. ${failCount > 0 ? failCount + " failed." : ""}`
                );

                showToast(`Cleared ${clearedCount} Customer ID(s)!${failCount > 0 ? " " + failCount + " failed." : ""}`);
                fetchCustomers();
              }}
            >
              🗑️ Clear All Customer IDs (One-time)
            </button>
          )}
          {localStorage.getItem("role") === "Admin" && (
            <button
              className="btn btn-outline-danger btn-sm"
              onClick={async () => {
                if (!window.confirm("This will find duplicate Customer IDs (SBM...) and Application IDs (APP...), and assign a new unique ID to the duplicates only. No customer data will be deleted. Continue?")) return;
                showToast("Fixing duplicate IDs...");

                // Fix duplicate appId (APP...)
                const appIdSeen = new Set();
                let maxApp = Math.max(0, ...customers.map(c =>
                  c.appId?.startsWith("APP") ? parseInt(c.appId.replace("APP", "")) || 0 : 0
                ));
                for (const c of customers) {
                  if (c.appId) {
                    if (appIdSeen.has(c.appId)) {
                      maxApp++;
                      const newAppId = "APP" + String(maxApp).padStart(4, "0");
                      await updateDoc(doc(db, "customers", c.firestoreId), { appId: newAppId });
                      appIdSeen.add(newAppId);
                    } else {
                      appIdSeen.add(c.appId);
                    }
                  }
                }

                // Fix duplicate applicationId (SBM...)
                const smbSeen = new Set();
                let maxSmb = Math.max(0, ...customers.map(c =>
                  c.applicationId?.startsWith("SBM") ? parseInt(c.applicationId.replace("SBM", "")) || 0 : 0
                ));
                for (const c of customers) {
                  if (c.applicationId) {
                    if (smbSeen.has(c.applicationId)) {
                      maxSmb++;
                      const newSmbId = "SBM" + String(maxSmb).padStart(4, "0");
                      await updateDoc(doc(db, "customers", c.firestoreId), { applicationId: newSmbId });
                      smbSeen.add(newSmbId);
                    } else {
                      smbSeen.add(c.applicationId);
                    }
                  }
                }

                // ✅ counters doc-ஐயும் sync பண்ணனும், இல்லைன்னா அடுத்த புது application duplicate ID எடுக்கும்
                try {
                  const { setDoc: setCounterDoc } = await import("firebase/firestore");
                  await setCounterDoc(doc(db, "counters", "appIdCounter"), { value: maxApp }, { merge: true });
                  await setCounterDoc(doc(db, "counters", "customerIdCounter"), { value: maxSmb }, { merge: true });
                } catch (err) {
                  console.error("Counter sync failed:", err);
                }

                showToast("Duplicate IDs Fixed! No data was deleted.");
                fetchCustomers();
              }}
            >
              🔧 Fix Duplicate IDs (One-time)
            </button>
          )}
          {localStorage.getItem("role") === "Admin" && (
            <button
              className="btn btn-outline-warning btn-sm"
              onClick={async () => {
                const parseCreatedDateTime = (c) => {
                  if (!c.createdDate) return new Date(0);
                  const parts = c.createdDate.split("/");
                  if (parts.length !== 3) return new Date(0);
                  const [d, m, y] = parts.map(Number);
                  if (!d || !m || !y) return new Date(0);
                  let hh = 0, mm2 = 0;
                  const t = (c.createdTime || "").match(/(\d+):(\d+):?\d*\s*(AM|PM)?/i);
                  if (t) {
                    hh = Number(t[1]) % 12;
                    mm2 = Number(t[2]);
                    if (t[3] && t[3].toUpperCase() === "PM") hh += 12;
                  }
                  return new Date(y, m - 1, d, hh, mm2);
                };

                const byMobile = {};
                customers.forEach(c => {
                  if (!c.mobile) return;
                  if (!byMobile[c.mobile]) byMobile[c.mobile] = [];
                  byMobile[c.mobile].push(c);
                });

                const previewLines = [];
                const groupsToMerge = [];
                for (const mobile in byMobile) {
                  const group = byMobile[mobile].filter(c => c.applicationId);
                  if (group.length <= 1) continue;
                  group.sort((a, b) => parseCreatedDateTime(a) - parseCreatedDateTime(b));
                  groupsToMerge.push(group);
                  previewLines.push(`${group[0].name} (${mobile}): KEEP ${group[0].applicationId}, CLEAR ${group.slice(1).map(g => g.applicationId).join(", ")}`);
                }

                if (groupsToMerge.length === 0) {
                  showToast("No duplicate Customer IDs found!");
                  return;
                }

                if (!window.confirm(`The following ${groupsToMerge.length} customer(s) have duplicate IDs:\n\n${previewLines.join("\n")}\n\nContinue with merge?`)) return;
                showToast("Merging duplicate Customer IDs...");

                let mergedCount = 0;
                for (const group of groupsToMerge) {
                  for (let i = 1; i < group.length; i++) {
                    await updateDoc(doc(db, "customers", group[i].firestoreId), { applicationId: "" });
                    mergedCount++;
                  }
                }

                showToast(`Merge Done! ${mergedCount} duplicate ID(s) cleared. இப்போ "Fix Customer IDs" button run பண்ணி renumber பண்ணுங்க.`);
                fetchCustomers();
              }}
            >
              🔧 Merge Duplicate Customer IDs (Same Person)
            </button>
          )}
        </div>
      </div>
{/* ── FILTER SECTION ── */}
      <div className="mb-4" style={{ border: "1px solid #e5e7eb", borderRadius: "12px", overflow: "hidden" }}>

        {/* Total Row */}
        <div style={{ background: "#f8fafc", borderBottom: "1px solid #e5e7eb", padding: "10px 16px", display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
          <span style={{ fontSize: "12px", fontWeight: "700", color: "#6b7280", textTransform: "uppercase", letterSpacing: "1px", minWidth: "100px" }}>📊 Total</span>
          <button
            className={`btn btn-sm ${customerListFilter === "All" ? "btn-success" : "btn-outline-success"}`}
            onClick={() => { setCustomerListFilter("All"); setCustomerListLocation(""); setCustomerListScheme(""); }}
          >
            👥 All Customers ({new Set(customers.map(c => c.mobile)).size})
          </button>
        </div>

        {/* Location Row */}
        <div style={{ background: "#eff6ff", borderBottom: "1px solid #e5e7eb", padding: "10px 16px", display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
          <span style={{ fontSize: "12px", fontWeight: "700", color: "#1d4ed8", textTransform: "uppercase", letterSpacing: "1px", minWidth: "100px" }}>📍 Location</span>
          {Object.entries(
            customers.reduce((acc, c) => {
              const loc = c.location || "Unknown";
              if (!acc[loc]) acc[loc] = new Set();
              acc[loc].add(c.mobile);
              return acc;
            }, {})
          )
          .map(([loc, mobileSet]) => [loc, mobileSet.size])
          .sort((a, b) => b[1] - a[1])
          .map(([loc, count]) => (
            <button
              key={loc}
              className={`btn btn-sm ${customerListFilter === "Location" && customerListLocation === loc ? "btn-primary" : "btn-outline-primary"}`}
              onClick={() => { setCustomerListFilter("Location"); setCustomerListLocation(loc); setCustomerListScheme(""); }}
            >
              {loc} ({count})
            </button>
          ))}
        </div>

        {/* Age Row */}
        {(() => {
         
         const seenMobiles = new Set();
          const age58Mobiles = new Set();

          customers.forEach(c => {
            if (!c.mobile || !c.dob) return;
            if (seenMobiles.has(c.mobile)) return;
            seenMobiles.add(c.mobile);

            // Support both DD-MM-YYYY and DD/MM/YYYY formats
            const sep = c.dob.includes("-") ? "-" : "/";
            const parts = c.dob.split(sep);
            if (parts.length !== 3) return;
            const dd = Number(parts[0]);
            const mm = Number(parts[1]);
            const yyyy = Number(parts[2]);
            if (!dd || !mm || !yyyy || yyyy < 1900) return;

            const today = new Date();
            const age = today.getFullYear() - yyyy -
              (today.getMonth() + 1 < mm ||
              (today.getMonth() + 1 === mm && today.getDate() < dd) ? 1 : 0);

            if (age >= 58) age58Mobiles.add(c.mobile);
          });

          const pensionMobiles = new Set(
            customers
              .filter(c => c.applyingFor && c.applyingFor.trim() === "Pension"
                && (c.status === "Approved" || c.status === "Submitted"))
              .map(c => c.mobile)
          );

          const age58Count = [...age58Mobiles].filter(m => !pensionMobiles.has(m)).length;

          return (
            <div style={{ background: "#f8fafc", borderBottom: "1px solid #e5e7eb", padding: "10px 16px", display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
              <span style={{ fontSize: "12px", fontWeight: "700", color: "#6b7280", textTransform: "uppercase", letterSpacing: "1px", minWidth: "100px" }}>👴 Age</span>
              <button
                className={`btn btn-sm ${customerListFilter === "Age58" ? "btn-secondary" : "btn-outline-secondary"}`}
                onClick={() => { setCustomerListFilter("Age58"); setCustomerListLocation(""); setCustomerListScheme(""); }}
              >
                58+ Pension Eligible
                {age58Count > 0 ? (
                  <span
                    className="ms-2 badge"
                    style={{
                      background: "#22c55e",
                      color: "white",
                      animation: "pulse 1.5s infinite",
                      boxShadow: "0 0 8px rgba(34,197,94,0.6)"
                    }}
                  >
                    {age58Count} ●
                  </span>
                ) : (
                  <span className="ms-2 badge bg-secondary">0</span>
                )}
              </button>
              <style>{`
                @keyframes pulse {
                  0% { box-shadow: 0 0 0 0 rgba(34,197,94,0.6); }
                  70% { box-shadow: 0 0 0 6px rgba(34,197,94,0); }
                  100% { box-shadow: 0 0 0 0 rgba(34,197,94,0); }
                }
              `}</style>
            </div>
          );
        })()}

        {/* Scheme Row */}
        <div style={{ background: "#fffbeb", padding: "10px 16px", display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
          <span style={{ fontSize: "12px", fontWeight: "700", color: "#b45309", textTransform: "uppercase", letterSpacing: "1px", minWidth: "100px" }}>📂 Scheme</span>
          {["Construction Welfare", "Driver Welfare", "Manual Welfare"].map(scheme => (
            <button
              key={scheme}
              className={`btn btn-sm ${customerListFilter === "Scheme" && customerListScheme === scheme ? "btn-warning" : "btn-outline-warning"}`}
              onClick={() => { setCustomerListFilter("Scheme"); setCustomerListScheme(scheme); setCustomerListLocation(""); }}
            >
              {scheme === "Construction Welfare" ? "🏗️" : scheme === "Driver Welfare" ? "🚗" : "⚒️"} {scheme} ({new Set(customers.filter(c => c.scheme === scheme).map(c => c.mobile)).size})
            </button>
          ))}
        </div>

      </div>

      {customerListFilter !== "All" && (
        <div className="alert alert-info py-2 d-flex justify-content-between align-items-center mb-3">
          <span>
            {customerListFilter === "Location" && `📍 Location: ${customerListLocation}`}
            {customerListFilter === "Age58" && `👴 Age 58+ Customers (Pension Eligible)`}
            {customerListFilter === "Scheme" && `📂 Scheme: ${customerListScheme}`}
          </span>
          <button className="btn btn-sm btn-outline-secondary" onClick={() => { setCustomerListFilter("All"); setCustomerListLocation(""); setCustomerListScheme(""); }}>
            ✕ Clear
          </button>
        </div>
      )}

      <div className="d-flex gap-2 mb-2">
        <input
          type="text"
          className="form-control"
          placeholder="Search by Name / Mobile / Card Number"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button
          className="btn btn-outline-secondary"
          onClick={() => setShowAdvFilter(p => !p)}
        >
          🔽 Filter
        </button>
        {(clFilterStatus || clFilterPayment || clFilterLocation || clFromDate || clToDate) && (
          <button
            className="btn btn-outline-danger"
            onClick={() => {
              setClFilterStatus("");
              setClFilterPayment("");
              setClFilterLocation("");
              setClFromDate("");
              setClToDate("");
            }}
          >
            ✕ Clear
          </button>
        )}
      </div>

      {showAdvFilter && (
        <div className="card p-3 mb-3 border-0 shadow-sm">
          <div className="row g-2">
            <div className="col-md-3">
              <label style={{ fontSize: "12px", fontWeight: "600" }}>Location</label>
              <select className="form-control form-control-sm" value={clFilterLocation} onChange={(e) => setClFilterLocation(e.target.value)}>
                <option value="">All Locations</option>
                {locations.map(l => <option key={l.id} value={l.name}>{l.name}</option>)}
              </select>
            </div>
            <div className="col-md-2">
              <label style={{ fontSize: "12px", fontWeight: "600" }}>Payment Type</label>
              <select className="form-control form-control-sm" value={clFilterPayment} onChange={(e) => setClFilterPayment(e.target.value)}>
                <option value="">All</option>
                <option value="Full payment">Full Payment</option>
                <option value="Partial payment">Partial Payment</option>
              </select>
            </div>
            <div className="col-md-3">
              <label style={{ fontSize: "12px", fontWeight: "600" }}>From Date</label>
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="DD/MM/YYYY"
                  maxLength={10}
                  value={clFromDate}
                  onChange={(e) => {
                    let v = e.target.value.replace(/[^0-9]/g, "");
                    if (v.length > 2) v = v.slice(0,2) + "/" + v.slice(2);
                    if (v.length > 5) v = v.slice(0,5) + "/" + v.slice(5);
                    setClFromDate(v.slice(0,10));
                  }}
                  style={{ paddingRight: "32px" }}
                />
                <input
                  type="date"
                  style={{ position: "absolute", top: 0, right: 0, width: "28px", height: "100%", opacity: 0, cursor: "pointer" }}
                  onChange={(e) => {
                    if (!e.target.value) return;
                    const [y, m, d] = e.target.value.split("-");
                    setClFromDate(`${d}/${m}/${y}`);
                  }}
                />
              </div>
            </div>
            <div className="col-md-3">
              <label style={{ fontSize: "12px", fontWeight: "600" }}>To Date</label>
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="DD/MM/YYYY"
                  maxLength={10}
                  value={clToDate}
                  onChange={(e) => {
                    let v = e.target.value.replace(/[^0-9]/g, "");
                    if (v.length > 2) v = v.slice(0,2) + "/" + v.slice(2);
                    if (v.length > 5) v = v.slice(0,5) + "/" + v.slice(5);
                    setClToDate(v.slice(0,10));
                  }}
                  style={{ paddingRight: "32px" }}
                />
                <input
                  type="date"
                  style={{ position: "absolute", top: 0, right: 0, width: "28px", height: "100%", opacity: 0, cursor: "pointer" }}
                  onChange={(e) => {
                    if (!e.target.value) return;
                    const [y, m, d] = e.target.value.split("-");
                    setClToDate(`${d}/${m}/${y}`);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      <table className="table table-bordered">
        <thead className="table-success" style={{ position: "sticky", top: 0 }}>
          <tr>
            {[
              { key: "applicationId", label: "Customer ID" },
              { key: "location", label: "Location" },
              { key: "name", label: "Name" },
              { key: "guardianName", label: "Guardian Name" },
              { key: "dob", label: "DOB" },
            ].map((col) => (
              <th
                key={col.key}
                onClick={() => {
                  if (clSortField === col.key) {
                    setClSortDir(clSortDir === "asc" ? "desc" : "asc");
                  } else {
                    setClSortField(col.key);
                    setClSortDir("asc");
                  }
                }}
                style={{ cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" }}
              >
               {col.label}{" "}
                {clSortField === col.key ? (clSortDir === "asc" ? "▲" : "▼") : "⇅"}
              </th>
            ))}
            <th>Age</th>
            <th>Scheme</th>
            {[
              { key: "cardNumber", label: "Card Number" },
              { key: "mobile", label: "Mobile Number" },
            ].map((col) => (
              <th
                key={col.key}
                onClick={() => {
                  if (clSortField === col.key) {
                    setClSortDir(clSortDir === "asc" ? "desc" : "asc");
                  } else {
                    setClSortField(col.key);
                    setClSortDir("asc");
                  }
                }}
                style={{ cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" }}
              >
                {col.label}{" "}
                {clSortField === col.key ? (clSortDir === "asc" ? "▲" : "▼") : "⇅"}
              </th>
            ))}
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {(() => {
            const seen = new Set();
            return [...customers]
              .sort((a, b) => {
                const aHas = a.applicationId ? 1 : 0;
                const bHas = b.applicationId ? 1 : 0;
                return bHas - aHas; // applicationId இருக்குறது முதலில் வரும்
              })
.filter((c) => {
                const matchesSearch =
                  (c.name || "").toLowerCase().includes(search.toLowerCase()) ||
                  (c.mobile || "").includes(search) ||
                  (c.cardNumber || "").toLowerCase().includes(search.toLowerCase()) ||
                  (c.applicationId || "").toLowerCase().includes(search.toLowerCase());
                if (!matchesSearch) return false;
                if (!matchesSearch) return false;

                // Advanced filters
                if (clFilterLocation && c.location !== clFilterLocation) return false;
                if (clFilterPayment && c.paymentType !== clFilterPayment) return false;
                if (clFromDate) {
                  const created = c.createdDate ? c.createdDate.split("/").reverse().join("-") : "";
                  const fp = clFromDate.split("/");
                  const fromISO = fp.length === 3 ? `${fp[2]}-${fp[1]}-${fp[0]}` : "";
                  if (fromISO && created < fromISO) return false;
                }
                if (clToDate) {
                  const created = c.createdDate ? c.createdDate.split("/").reverse().join("-") : "";
                  const tp = clToDate.split("/");
                  const toISOStr = tp.length === 3 ? `${tp[2]}-${tp[1]}-${tp[0]}` : "";
                  if (toISOStr && created > toISOStr) return false;
                }

                if (customerListFilter === "Location") return c.location === customerListLocation;
if (customerListFilter === "Age58") {
                  const age = calculateAge(c.dob);
                  return age !== null && age >= 58;
                }
                if (customerListFilter === "Scheme") return c.scheme === customerListScheme;
                return true;
              })
              .filter((c) => {
                if (seen.has(c.mobile)) return false;
                seen.add(c.mobile);
                return true;
              })
              .sort((a, b) => {
                if (!clSortField) {
                  const numA = a.applicationId?.startsWith("SBM") ? parseInt(a.applicationId.replace("SBM", "")) : null;
                  const numB = b.applicationId?.startsWith("SBM") ? parseInt(b.applicationId.replace("SBM", "")) : null;
                  if (numA !== null && numB !== null) return numA - numB;
                  if (numA !== null && numB === null) return -1;
                  if (numA === null && numB !== null) return 1;
                  return 0;
                }
                let valA, valB;
                if (clSortField === "dob") {
                  const toDate = (d) => {
                    if (!d) return new Date(0);
                    const p = d.split("-");
                    return p.length === 3 ? new Date(p[2], p[1] - 1, p[0]) : new Date(0);
                  };
                  valA = toDate(a.dob); valB = toDate(b.dob);
                } else {
                  valA = (a[clSortField] || "").toString().toLowerCase();
                  valB = (b[clSortField] || "").toString().toLowerCase();
                }
                if (valA < valB) return clSortDir === "asc" ? -1 : 1;
                if (valA > valB) return clSortDir === "asc" ? 1 : -1;
                return 0;
              })
              .map((customer, index) => {
                const age = calculateAge(customer.dob);
                return (
                <tr
                  key={customer.firestoreId}
style={{
                    transition: "0.2s",
                    background: customerListFilter === "Age58" && age >= 60 ? "#fff5f5" : "white"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.background = "#f8fafc"}
                  onMouseLeave={(e) => e.currentTarget.style.background =
                    customerListFilter === "Age58" && age >= 60 ? "#fff5f5" : "white"
                  }
                >
                  <td>
  <input
    key={`appid-${customer.firestoreId}-${customer.applicationId || "empty"}`}
    type="text"
    className="form-control form-control-sm"
    placeholder="Enter ID"
    defaultValue={customer.applicationId || ""}
    style={{ fontWeight: "600", color: "#198754", minWidth: "110px" }}
    onBlur={async (e) => {
      const trimmed = e.target.value.trim().toUpperCase();
      if (trimmed === (customer.applicationId || "")) return; // no change, skip

      if (trimmed !== "" && !/^SBM\d{4}$/.test(trimmed)) {
        showToast("Invalid format! Must be like SBM0000, or leave blank", "error");
        e.target.value = customer.applicationId || "";
        return;
      }

      if (trimmed !== "") {
        const duplicate = customers.find(
          c => c.applicationId === trimmed && c.firestoreId !== customer.firestoreId
        );
        if (duplicate) {
          showToast(`"${trimmed}" already exists for "${duplicate.name}"!`, "error");
          e.target.value = customer.applicationId || "";
          return;
        }
      }

      try {
        await updateDoc(doc(db, "customers", customer.firestoreId), { applicationId: trimmed });
        await logActivity(
          "Customer ID Manually Edited",
          `Name: ${customer.name} | Mobile: ${customer.mobile} | ID: ${customer.applicationId || "-"} → ${trimmed || "-"}`
        );
        showToast("Customer ID Saved!");
        fetchCustomers();
      } catch (err) {
        showToast("Update failed: " + err.message, "error");
      }
    }}
    onKeyDown={(e) => { if (e.key === "Enter") e.target.blur(); }}
  />
</td>
                  <td>{customer.location}</td>
                  <td
                    style={{ cursor: "pointer", color: "#0066cc", textDecoration: "underline" }}
                    onClick={() => {
                      setSelectedProfile(customer);
                      setActiveMenu("Customer Profile");
                    }}
                  >
                    {customer.name}
                  </td>
                  <td>{customer.guardianName}</td>
                  <td>{customer.dob}</td>
                  <td>{age !== null ? `${age} yrs` : "-"}</td>
                  <td>{customer.scheme}</td>
                  <td>{customer.cardNumber || "-"}</td>
                  <td>{customer.mobile}</td>
                  <td>
                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-outline-warning btn-sm"
                        onClick={() => { editCustomer(customer); setEditMode("customer"); }}
                      >
                        Edit
                      </button>

                      {localStorage.getItem("role") === "Admin" && (
                        <button
                          className="btn btn-outline-danger btn-sm"
                          onClick={() => deleteCustomer(customer.firestoreId)}
                        >
                          Delete
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
);
              });
          })()}
        </tbody>
      </table>
      {new Set(customers.map(c => c.mobile)).size === 0 && (
        <div style={{ textAlign: "center", padding: "48px 20px", color: "#94a3b8" }}>
          <div style={{ fontSize: "40px", marginBottom: "10px" }}>👥</div>
          <p style={{ fontSize: "14px", margin: 0 }}>இன்னும் customers யாரும் இல்ல. "New Application" மூலம் முதல் entry சேருங்க.</p>
        </div>
      )}
    </div>
    )}
  </div>
)}

{activeMenu === "Rental" && (
  <RentalPage db={db} showToast={showToast} />
)}

{activeMenu === "Application List" && (
  <>
    <div className="card mt-5 p-4 shadow">
      <h4>Application List - {filterStatus}</h4>
      <div className="row mt-3">
        {[
          { label: "Total", value: customers.length, status: "All", color: "#2563eb" },
          { label: "Pending", value: customers.filter(c=>c.status==="Pending").length, status: "Pending", color: "#f59e0b" },
          { label: "Submitted", value: customers.filter(c=>c.status==="Submitted").length, status: "Submitted", color: "#3b82f6" },
          { label: "Approved", value: customers.filter(c=>c.status==="Approved").length, status: "Approved", color: "#22c55e" },
          { label: "Rejected", value: customers.filter(c=>c.status==="Rejected").length, status: "Rejected", color: "#ef4444" },
          { label: "Resubmitted", value: customers.filter(c=>c.status==="Resubmitted").length, status: "Resubmitted", color: "#a855f7" },
          { label: "Chandha", value: customers.filter(c=>c.applyingFor==="Chandha").length, status: "Chandha", color: "#0d9488" },
          { label: "Note Entry", value: customers.filter(c=>c.status==="Note Entry" || c.applyingFor==="Note Entry").length, status: "Note Entry", color: "#f97316" },
        ].map((item, i) => (
          <div key={i} className="col">
            <div
              className="card shadow p-2 text-center"
              onClick={() => setFilterStatus(item.status)}
              style={{
                cursor: "pointer",
                borderLeft: filterStatus === item.status ? `4px solid ${item.color}` : "4px solid transparent",
                background: filterStatus === item.status ? "#f8fafc" : "white",
                transition: "all 0.2s"
              }}
            >
              <h6 style={{ color: filterStatus === item.status ? item.color : "#64748b" }}>{item.label}</h6>
              <h4 style={{ color: filterStatus === item.status ? item.color : "#1e293b" }}>{item.value}</h4>
            </div>
          </div>
        ))}
      </div>

      <div className="d-flex gap-2 mt-3">
        <input
          type="text"
          className="form-control"
          placeholder="🔍 Search by Name / Mobile / Application ID / Card No"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ borderColor: search ? "#198754" : "", boxShadow: search ? "0 0 0 0.2rem rgba(25,135,84,0.15)" : "" }}
        />
        <button
          className="btn btn-outline-secondary"
          onClick={() => setShowAppListFilter(p => !p)}
        >
          🔽 Filter
        </button>
        {(alFilterLocation || alFilterApplyingFor || alFilterPayment || clFromDate || clToDate || clFilterMonth || clFilterYear) && (
          <button
            className="btn btn-outline-danger"
            onClick={() => { setAlFilterLocation(""); setAlFilterApplyingFor(""); setAlFilterPayment(""); setClFromDate(""); setClToDate(""); setClFilterMonth(""); setClFilterYear(""); }}
          >
            ✕ Clear
          </button>
        )}
      </div>

      {showAppListFilter && localStorage.getItem("role") === "Admin" && (
        <div className="card shadow p-3 mt-2">
          <div className="row g-3 align-items-end mb-2">
            <div className="col-md-3">
              <label>Location</label>
              <select className="form-control" value={alFilterLocation} onChange={(e) => setAlFilterLocation(e.target.value)}>
                <option value="">All Locations</option>
                {locations.map(l => <option key={l.id} value={l.name}>{l.name}</option>)}
              </select>
            </div>
            <div className="col-md-3">
              <label>Applying For</label>
              <select className="form-control" value={alFilterApplyingFor} onChange={(e) => setAlFilterApplyingFor(e.target.value)}>
                <option value="">All Types</option>
                {amountCategories.map(cat => <option key={cat.firestoreId} value={cat.name}>{cat.name}</option>)}
              </select>
            </div>
            <div className="col-md-3">
              <label>Payment Type</label>
              <select className="form-control" value={alFilterPayment} onChange={(e) => setAlFilterPayment(e.target.value)}>
                <option value="">All</option>
                <option value="Full payment">Full Payment</option>
                <option value="Partial payment">Partial Payment</option>
              </select>
            </div>
            <div className="col-md-3">
              <button className="btn btn-outline-danger w-100" onClick={() => { setAlFilterLocation(""); setAlFilterApplyingFor(""); setAlFilterPayment(""); }}>✕ Clear Location/Type Filter</button>
            </div>
          </div>
          <div className="row g-3 align-items-end">
            <div className="col-md-2">
              <label>Month</label>
              <select className="form-control" value={clFilterMonth} onChange={(e) => { setClFilterMonth(e.target.value); setClFromDate(""); setClToDate(""); }}>
                <option value="">All Months</option>
                {["01","02","03","04","05","06","07","08","09","10","11","12"].map((m,i)=>(
                  <option key={m} value={m}>{["January","February","March","April","May","June","July","August","September","October","November","December"][i]}</option>
                ))}
              </select>
            </div>
            <div className="col-md-2">
              <label>Year</label>
              <select className="form-control" value={clFilterYear} onChange={(e) => { setClFilterYear(e.target.value); setClFromDate(""); setClToDate(""); }}>
                <option value="">All Years</option>
                {["2026","2027","2028","2029","2030"].map(y=><option key={y} value={y}>{y}</option>)}
              </select>
            </div>
            <div className="col-md-3">
              <label>From Date</label>
              <div className="d-flex gap-1">
                <select className="form-control" value={clFromDate.split("/")[0]||""} onChange={(e)=>{const p=clFromDate.split("/");setClFromDate(e.target.value+"/"+(p[1]||"")+"/"+(p[2]||""));setClFilterMonth("");setClFilterYear("");}}>
                  <option value="">DD</option>
                  {Array.from({length:31},(_,i)=>String(i+1).padStart(2,"0")).map(d=><option key={d} value={d}>{d}</option>)}
                </select>
                <select className="form-control" value={clFromDate.split("/")[1]||""} onChange={(e)=>{const p=clFromDate.split("/");setClFromDate((p[0]||"")+"/"+e.target.value+"/"+(p[2]||""));setClFilterMonth("");setClFilterYear("");}}>
                  <option value="">MM</option>
                  {["01","02","03","04","05","06","07","08","09","10","11","12"].map(m=><option key={m} value={m}>{m}</option>)}
                </select>
                <select className="form-control" value={clFromDate.split("/")[2]||""} onChange={(e)=>{const p=clFromDate.split("/");setClFromDate((p[0]||"")+"/"+(p[1]||"")+"/"+e.target.value);setClFilterMonth("");setClFilterYear("");}}>
                  <option value="">YYYY</option>
                  {["2026","2027","2028","2029","2030"].map(y=><option key={y} value={y}>{y}</option>)}
                </select>
              </div>
            </div>
            <div className="col-md-3">
              <label>To Date</label>
              <div className="d-flex gap-1">
                <select className="form-control" value={clToDate.split("/")[0]||""} onChange={(e)=>{const p=clToDate.split("/");setClToDate(e.target.value+"/"+(p[1]||"")+"/"+(p[2]||""));setClFilterMonth("");setClFilterYear("");}}>
                  <option value="">DD</option>
                  {Array.from({length:31},(_,i)=>String(i+1).padStart(2,"0")).map(d=><option key={d} value={d}>{d}</option>)}
                </select>
                <select className="form-control" value={clToDate.split("/")[1]||""} onChange={(e)=>{const p=clToDate.split("/");setClToDate((p[0]||"")+"/"+e.target.value+"/"+(p[2]||""));setClFilterMonth("");setClFilterYear("");}}>
                  <option value="">MM</option>
                  {["01","02","03","04","05","06","07","08","09","10","11","12"].map(m=><option key={m} value={m}>{m}</option>)}
                </select>
                <select className="form-control" value={clToDate.split("/")[2]||""} onChange={(e)=>{const p=clToDate.split("/");setClToDate((p[0]||"")+"/"+(p[1]||"")+"/"+e.target.value);setClFilterMonth("");setClFilterYear("");}}>
                  <option value="">YYYY</option>
                  {["2026","2027","2028","2029","2030"].map(y=><option key={y} value={y}>{y}</option>)}
                </select>
              </div>
            </div>
            <div className="col-md-2">
              <button className="btn btn-secondary w-100" onClick={() => { setClFromDate(""); setClToDate(""); setClFilterMonth(""); setClFilterYear(""); }}>Clear Filter</button>
            </div>
          </div>
        </div>
      )}
    </div>

    <div className="card mt-5 p-4 shadow">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>Application List</h4>
        {localStorage.getItem("role") === "Admin" && (
          <button className="btn btn-success" onClick={exportToExcel}>Export Excel</button>
        )}
      </div>

      <div style={{ overflowX: "auto" }}>
      <table className="table table-bordered">
        <thead className="table-success" style={{ position: "sticky", top: 0 }}>
          <tr>
            {[
              { key: "appId", label: "App ID" },
              { key: "name", label: "Name" },
              { key: "mobile", label: "Mobile" },
              { key: "applyingFor", label: "Applying For" },
              { key: "cardNumber", label: "Card Number" },
              { key: "location", label: "Location" },
              { key: "remarks", label: "Remarks" },
              { key: "amountReceived", label: "Amount" },
              { key: "pendingAmount", label: "Pending" },
              { key: "paymentType", label: "Payment Type" },
              { key: "createdDateSort", label: "Date" },
              { key: "createdTime", label: "Time" },
              { key: "status", label: "Status" },
            ].map((col) => (
              <th
                key={col.key}
                onClick={() => {
                  if (appListSortField === col.key) {
                    setAppListSortDir(appListSortDir === "asc" ? "desc" : "asc");
                  } else {
                    setAppListSortField(col.key);
                    setAppListSortDir("asc");
                  }
                }}
                style={{ cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" }}
              >
                {col.label}{" "}
                {appListSortField === col.key ? (appListSortDir === "asc" ? "▲" : "▼") : "⇅"}
              </th>
            ))}
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {customers
            .filter((customer) => {
              const matchesSearch =
                (customer.cardNumber || "").toLowerCase().includes(search.toLowerCase()) ||
                (customer.mobile || "").includes(search) ||
                (customer.applicationId || "").toLowerCase().includes(search.toLowerCase()) ||
                (customer.name || "").toLowerCase().includes(search.toLowerCase());

              const matchesStatus = filterStatus === "All" || (filterStatus === "Chandha" ? customer.applyingFor === "Chandha" : filterStatus === "Note Entry" ? (customer.status === "Note Entry" || customer.applyingFor === "Note Entry") : customer.status === filterStatus);
              const matchesLocation = !alFilterLocation || customer.location === alFilterLocation;
              const matchesApplyingFor = !alFilterApplyingFor || customer.applyingFor === alFilterApplyingFor;
              const matchesPayment = !alFilterPayment || customer.paymentType === alFilterPayment;

              const parseDate = (dateStr) => {
                if (!dateStr) return null;
                const parts = dateStr.split("/");
                if (parts.length === 3) return new Date(parts[2], parts[1] - 1, parts[0]);
                return new Date(dateStr);
              };

              const recordDate = parseDate(customer.createdDate);
              const clFromParts = clFromDate.split("/");
              const clToParts = clToDate.split("/");
              const clFromReady = clFromParts[0] && clFromParts[1] && clFromParts[2];
              const clToReady = clToParts[0] && clToParts[1] && clToParts[2];
              let matchesDate = true;

              if (clFromReady && clToReady) {
                const from = new Date(clFromParts[2], clFromParts[1] - 1, clFromParts[0]);
                const to = new Date(clToParts[2], clToParts[1] - 1, clToParts[0]);
                to.setHours(23, 59, 59);
                if (!recordDate || recordDate < from || recordDate > to) matchesDate = false;
              }

              if (clFilterMonth || clFilterYear) {
                if (!recordDate) { matchesDate = false; }
                else {
                  const month = String(recordDate.getMonth() + 1).padStart(2, "0");
                  const year = String(recordDate.getFullYear());
                  if (clFilterMonth && month !== clFilterMonth) matchesDate = false;
                  if (clFilterYear && year !== clFilterYear) matchesDate = false;
                }
              }

              return matchesSearch && matchesStatus && matchesDate && matchesLocation && matchesApplyingFor && matchesPayment;
            })
            .sort((a, b) => {
              if (!appListSortField) return 0;
              const parseSortDate = (s) => {
                if (!s) return new Date(0);
                const p = s.split("/");
                if (p.length === 3) return new Date(p[2], p[1] - 1, p[0]);
                return new Date(0);
              };
              let valA, valB;
              if (appListSortField === "createdDateSort") {
                valA = parseSortDate(a.createdDate);
                valB = parseSortDate(b.createdDate);
              } else if (["amountReceived", "pendingAmount"].includes(appListSortField)) {
                valA = Number(a[appListSortField] || 0);
                valB = Number(b[appListSortField] || 0);
              } else if (appListSortField === "appId") {
                valA = a.appId || "";
                valB = b.appId || "";
              } else {
                valA = (a[appListSortField] || "").toString().toLowerCase();
                valB = (b[appListSortField] || "").toString().toLowerCase();
              }
              if (valA < valB) return appListSortDir === "asc" ? -1 : 1;
              if (valA > valB) return appListSortDir === "asc" ? 1 : -1;
              return 0;
            })
            .map((customer, index) => (
              <tr key={customer.firestoreId} style={{ transition: "0.2s" }}
                onMouseEnter={(e) => e.currentTarget.style.background = "#f8fafc"}
                onMouseLeave={(e) => e.currentTarget.style.background = "white"}
              >
                <td>{customer.appId || `APP${String(index + 1).padStart(4, "0")}`}</td>
                <td>{customer.name}</td>
                <td>{customer.mobile}</td>
                <td>{customer.applyingFor}</td>
                <td>{customer.cardNumber}</td>
                <td>{customer.location || "-"}</td>
                <td>{customer.remarks}</td>
                <td>₹{customer.amountReceived}</td>
                <td>₹{customer.pendingAmount || 0}</td>
                <td>
                  <span className={customer.paymentType === "Full payment" ? "badge bg-success" : "badge bg-warning text-dark"}>
                    {customer.paymentType}
                  </span>
                </td>
                <td>{customer.createdDate}</td>
                <td>{customer.createdTime}</td>
                <td>
                  <span
                    className={
                      customer.status === "Pending"
                        ? "badge border border-warning text-warning px-2 py-1"
                        : customer.status === "Submitted"
                        ? "badge border border-primary text-primary px-2 py-1"
                        : customer.status === "Approved"
                        ? "badge border border-success text-success px-2 py-1"
                        : customer.status === "Resubmitted"
                        ? "badge border border-info text-info px-2 py-1"
                        : (customer.status === "Chandha" || customer.status === "Note Entry")
                        ? "badge text-white px-2 py-1"
                        : "badge border border-danger text-danger px-2 py-1"
                    }
                    style={{ fontWeight: "600", background: customer.status === "Chandha" ? "#0d9488" : customer.status === "Note Entry" ? "#f97316" : undefined }}
                  >
                    {customer.status}
                  </span>
                </td>
                <td>
                  <div className="d-flex gap-2">
                    <button className="btn btn-outline-success btn-sm" onClick={() => {
                      setName(customer.name); setMobile(customer.mobile); setGuardianName(customer.guardianName);
                      setDob(customer.dob); setLocation(customer.location); setCardNumber(customer.cardNumber);
                      setScheme(customer.scheme); setStatus(""); setApplyingFor(""); setAmountReceived("");
                      setPaymentType(""); setPendingAmount(""); setRemarks(""); setEditId(null);
                      setApplicationDate(""); setTotalAmount("");
                      setViewCustomer(customer); setActiveMenu("New Application"); setLockFields(true); setIsExistingCustomer(true);
                    }}>New</button>
                    <button className="btn btn-outline-primary btn-sm" onClick={() => { editCustomer(customer); setEditMode("application"); }}>Edit</button>
                    
                      {customer.applyingFor === "Chandha" && (
                      <button className="btn btn-outline-success btn-sm" onClick={() => generateReceipt(customer)}>🧾 Receipt</button>
                    )}
                    {localStorage.getItem("role") === "Admin" && (
                      <button className="btn btn-outline-danger btn-sm" onClick={() => deleteCustomer(customer.firestoreId)}>Delete</button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      </div>
    </div>
  </>
)}

{activeMenu === "Financial" && (
  <FinancialPage db={db} customers={customers} showToast={showToast} expenseCategories={expenseCategories} />
)}

{activeMenu === "Loans" && (
  <LoanManager db={db} showToast={showToast} />
)}

{activeMenu === "Customer Profile" && selectedProfile && (
  <div className="mt-4">
    {/* Profile Header */}
    <div className="card shadow border-0 p-4 mb-4">
      <div className="row">
        <div className="col-md-6">
          <h2>{selectedProfile.name}</h2>
          <p className="text-muted mb-2">
            📱 {selectedProfile.mobile}
          </p>
          <p className="text-muted">
            👨‍👩‍👧 Guardian: {selectedProfile.guardianName}
          </p>
        </div>
        <div className="col-md-6 text-end">
          <div className="card bg-light p-3 mb-2">
            <small className="text-muted">Application ID</small>
            <h4 style={{ color: "#198754" }}>{selectedProfile.applicationId}</h4>
          </div>
          <div className="card bg-light p-3">
            <small className="text-muted">Member Since</small>
            <h5>{selectedProfile.createdDate}</h5>
          </div>
        </div>
      </div>
    </div>

    {/* Personal Details */}
    <div className="card shadow border-0 p-4 mb-4">
      <h4 className="mb-3">📋 Personal Details</h4>
      <div className="row">
        <div className="col-md-4 mb-3">
          <small className="text-muted d-block">Date of Birth</small>
          <h6>{selectedProfile.dob}</h6>
        </div>
        <div className="col-md-4 mb-3">
          <small className="text-muted d-block">Age</small>
          <h6>
            {calculateAge(selectedProfile.dob) ?? "N/A"} years
          </h6>
        </div>
        <div className="col-md-4 mb-3">
          <small className="text-muted d-block">Location</small>
          <h6>{selectedProfile.location}</h6>
        </div>
      </div>
    </div>

    {/* Scheme & Card Details */}
    <div className="card shadow border-0 p-4 mb-4">
      <h4 className="mb-3">🎫 Scheme & Card Information</h4>
      <div className="row">
        <div className="col-md-4 mb-3">
          <small className="text-muted d-block">Scheme</small>
          <h6>{selectedProfile.scheme}</h6>
        </div>
        <div className="col-md-4 mb-3">
          <small className="text-muted d-block">Card Number</small>
          <h6>{selectedProfile.cardNumber || "Not Issued"}</h6>
        </div>
        <div className="col-md-4 mb-3">
          <small className="text-muted d-block">Current Status</small>
          <span
            className={
              selectedProfile.status === "Pending"
                ? "badge border border-warning text-warning px-3 py-2"
                : selectedProfile.status === "Submitted"
                ? "badge border border-primary text-primary px-3 py-2"
                : selectedProfile.status === "Approved"
                ? "badge border border-success text-success px-3 py-2"
                : selectedProfile.status === "Resubmitted"
                ? "badge border border-info text-info px-3 py-2"
                : "badge border border-danger text-danger px-3 py-2"
            }
            style={{ fontSize: "13px", borderRadius: "30px" }}
          >
            {selectedProfile.status}
          </span>
        </div>
      </div>
    </div>

    {/* Financial Details */}
    <div className="card shadow border-0 p-4 mb-4">
      <h4 className="mb-3">💰 Financial Details</h4>
      {(() => {
        const customerApps = customers.filter(c => c.mobile === selectedProfile.mobile);
        const totalReceived = customerApps.reduce((t, c) => t + Number(c.amountReceived || 0), 0);
        const totalPending = customerApps.reduce((t, c) => t + Number(c.pendingAmount || 0), 0);
        const hasPartial = customerApps.some(c => c.paymentType === "Partial payment");
        return (
          <div className="row">
            <div className="col-md-3 mb-3">
              <div className="card bg-light p-3">
                <small className="text-muted d-block">Total Applications</small>
                <h5 style={{ color: "#2563eb" }}>{customerApps.length}</h5>
              </div>
            </div>
            <div className="col-md-3 mb-3">
              <div className="card bg-light p-3">
                <small className="text-muted d-block">Amount Received</small>
                <h5 style={{ color: "#22c55e" }}>₹{totalReceived}</h5>
              </div>
            </div>
            <div className="col-md-3 mb-3">
              <div className="card bg-light p-3">
                <small className="text-muted d-block">Pending Amount</small>
                <h5 style={{ color: "#ef4444" }}>₹{totalPending}</h5>
              </div>
            </div>
            <div className="col-md-3 mb-3">
              <div className="card bg-light p-3">
                <small className="text-muted d-block">Payment Type</small>
                <span className={hasPartial ? "badge bg-warning text-dark" : "badge bg-success"}>
                  {hasPartial ? "Partial Payment" : "Full Payment"}
                </span>
              </div>
            </div>
          </div>
        );
      })()}
    </div>

{Number(selectedProfile.pendingAmount || 0) > 0 && (
  <div className="d-flex justify-content-end mb-4">
    <button
      className="btn btn-success"
      onClick={() => {
        setPaymentCustomer(selectedProfile);
        setPaymentAmount("");
        setPaymentDate(getTodayStr());
        setPaymentNotes("");
        setShowPaymentModal(true);
      }}
    >
      💰 Add Payment
    </button>
  </div>
)}

{/* Documents */}
    <div className="card shadow border-0 p-4 mb-4">
      <h4 className="mb-3">📎 Documents</h4>
      {(() => {
        const allDocs = [];

        // Multiple documents
        if (selectedProfile.documentURLs && selectedProfile.documentURLs.length > 0) {
          selectedProfile.documentURLs.forEach((url, i) => {
            allDocs.push({ url, name: selectedProfile.documentNames?.[i] || `Document ${i + 1}`, type: "document" });
          });
        } else if (selectedProfile.documentURL) {
          allDocs.push({ url: selectedProfile.documentURL, name: selectedProfile.documentName || "Document", type: "document" });
        }

        // Membership form
        if (selectedProfile.membershipFormURL) {
          allDocs.push({ url: selectedProfile.membershipFormURL, name: selectedProfile.membershipFormName || "Membership Form", type: "membership" });
        }

        if (allDocs.length === 0) {
          return <p className="text-muted">No documents uploaded</p>;
        }

return (
          <div className="row g-3">
            {allDocs.map((doc, i) => (
              <div className="col-md-4" key={i}>
                <div className="card border p-3">
                  <div className="d-flex align-items-start gap-2 mb-2">
                    <span style={{ fontSize: "20px" }}>{doc.type === "membership" ? "📋" : "📄"}</span>
                    <div>
                      <div style={{ fontSize: "13px", fontWeight: "600", wordBreak: "break-word" }}>{doc.name}</div>
                      <small className="text-muted">{doc.type === "membership" ? "Membership Form" : "Document"}</small>
                    </div>
                  </div>
                  <div className="d-flex gap-2 flex-wrap">
                    <a href={doc.url} target="_blank" rel="noreferrer" className="btn btn-outline-primary btn-sm flex-grow-1">👁️ View</a>
                    <a href={doc.url} download={doc.name} className="btn btn-outline-success btn-sm flex-grow-1">⬇️ Download</a>
                    {localStorage.getItem("role") === "Admin" && (
                      <button className="btn btn-outline-danger btn-sm" title="Delete from Firebase Storage" onClick={async () => {
                        if (!window.confirm(`"${doc.name}" delete பண்ணலாமா?`)) return;
                        try {
                          const decodedPath = decodeURIComponent(doc.url.split("/o/")[1].split("?")[0]);
                          try {
                            await deleteObject(ref(storage, decodedPath));
                          } catch (storageErr) {
                            if (storageErr.code !== "storage/object-not-found") throw storageErr;
                            // file already storage-ல இல்ல — stale Firestore reference-ஐ matum clean பண்ணுவோம்
                          }

                          const { doc: docRef } = await import("firebase/firestore");
                          let fsUpdate = {};
                          if (doc.type === "membership") {
                            fsUpdate = { membershipFormURL: "", membershipFormName: "" };
                          } else {
                            const idx = (selectedProfile.documentURLs || []).indexOf(doc.url);
                            const newURLs = (selectedProfile.documentURLs || []).filter((_, i2) => i2 !== idx);
                            const newNames = (selectedProfile.documentNames || []).filter((_, i2) => i2 !== idx);
                            fsUpdate = {
                              documentURLs: newURLs,
                              documentNames: newNames,
                              documentURL: newURLs[0] || "",
                              documentName: newNames[0] || ""
                            };
                          }

                          await updateDoc(docRef(db, "customers", selectedProfile.firestoreId), fsUpdate);
                          setSelectedProfile(prev => ({ ...prev, ...fsUpdate }));
                          fetchCustomers();
                          showToast("Document deleted!");
                        } catch (err) {
                          showToast("Delete failed: " + err.message, "error");
                        }
                      }}>🗑️</button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        );
      })()}
    </div>

{/* Payment History */}
<PaymentHistoryInline
  payments={profilePayments}
  loading={profilePaymentsLoading}
  pendingAmount={selectedProfile.pendingAmount}
/>

    {/* Remarks */}
    <div className="card shadow border-0 p-4 mb-4">
      <h4 className="mb-3">📝 Remarks</h4>
      <p style={{ whiteSpace: "pre-wrap", lineHeight: "1.6" }}>
        {selectedProfile.remarks || "No remarks"}
      </p>
    </div>

    {/* Application History */}
    <div className="card shadow border-0 p-4">
      <h4 className="mb-3">📜 Application History</h4>
      <table className="table table-bordered">
        <thead className="table-light">
          <tr>
            <th>Date</th>
            <th>Time</th>
            <th>Applying For</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Payment Type</th>
          </tr>
        </thead>
        <tbody>
          {customers
            .filter((c) => c.mobile === selectedProfile.mobile)
            .sort(
              (a, b) =>
                new Date(
                  b.createdDate.split("/").reverse().join("-")
                ) -
                new Date(a.createdDate.split("/").reverse().join("-"))
            )
            .map((record, idx) => (
              <tr key={idx}>
                <td>{record.createdDate}</td>
                <td>{record.createdTime}</td>
                <td>{record.applyingFor}</td>
                <td>₹{record.amountReceived}</td>
                <td>
                  <span
                    className={
                      record.status === "Pending"
                        ? "badge border border-warning text-warning"
                        : record.status === "Submitted"
                        ? "badge border border-primary text-primary"
                        : record.status === "Approved"
                        ? "badge border border-success text-success"
                        : record.status === "Resubmitted"
                        ? "badge border border-info text-info"
                        : "badge border border-danger text-danger"
                    }
                  >
                    {record.status}
                  </span>
                </td>
                <td>
                  <span
                    className={
                      record.paymentType === "Full payment"
                        ? "badge bg-success"
                        : "badge bg-warning text-dark"
                    }
                  >
                    {record.paymentType}
                  </span>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {customers.filter((c) => c.mobile === selectedProfile.mobile).length ===
        0 && (
        <p className="text-muted text-center mt-3">No application history</p>
      )}
    </div>

    {/* Action Buttons */}
    <div className="d-flex gap-2 mt-4">
      <button
        className="btn btn-outline-primary"
        onClick={() => {
          editCustomer(selectedProfile);
          setEditMode("customer");
const rawDate = selectedProfile.createdDate || "";
// Format: if no slashes, add them (DDMMYYYY → DD/MM/YYYY)
let formattedDate = rawDate;
if (rawDate.length === 8 && !rawDate.includes("/") && !rawDate.includes("-")) {
  formattedDate = `${rawDate.slice(0,2)}/${rawDate.slice(2,4)}/${rawDate.slice(4)}`;
}
setApplicationDate(formattedDate);
setActiveMenu("New Application");
        }}
      >
        ✏️ Edit Customer
      </button>

      {localStorage.getItem("role") === "Admin" && (
        <button
          className="btn btn-outline-danger"
          onClick={() => {
            const confirmed = window.confirm(
              "Are you sure you want to delete this customer?"
            );
            if (confirmed) {
              deleteCustomer(selectedProfile.firestoreId);
              setSelectedProfile(null);
              setActiveMenu("Customer List");
            }
          }}
        >
          🗑️ Delete Customer
        </button>
      )}

      <button
        className="btn btn-outline-secondary ms-auto"
        onClick={() => {
          setSelectedProfile(null);
          setActiveMenu("Customer List");
        }}
      >
        ← Back to List
      </button>
    </div>

  </div>
)}

{activeMenu === "User Management" && (
  <UserManagement db={db} showToast={showToast} />
)}

{activeMenu === "Location Manager" && (
  <LocationManager
              showToast={showToast}
    db={db}
    onLocationsUpdated={() => { fetchLocations(); fetchCustomers(); }}
  />
)}

{activeMenu === "Service Categories" && (
  <ServiceCategoryManager
              showToast={showToast}
    db={db}
    onUpdated={fetchServiceCategories}
  />
)}

{activeMenu === "Service Register" && (
  <div className="card mt-4 p-4 shadow">
    <h4 className="mb-3">🧾 Service Register</h4>
    <div className="row">
      <div className="col-md-6 mb-3">
        <label>Date <small className="text-muted">(Optional — leave blank for today)</small></label>
        <div style={{ position: "relative" }}>
          <input
            type="text"
            className="form-control"
            placeholder="DD/MM/YYYY"
            maxLength={10}
            value={serviceDate}
            onChange={(e) => {
              let v = e.target.value.replace(/[^0-9]/g, "");
              if (v.length > 2) v = v.slice(0,2) + "/" + v.slice(2);
              if (v.length > 5) v = v.slice(0,5) + "/" + v.slice(5);
              setServiceDate(v.slice(0,10));
            }}
            style={{ paddingRight: "40px" }}
          />
          <input
            type="date"
            style={{ position: "absolute", top: 0, right: 0, width: "36px", height: "100%", opacity: 0, cursor: "pointer" }}
            onChange={(e) => {
              if (!e.target.value) return;
              const [y, m, d] = e.target.value.split("-");
              setServiceDate(`${d}/${m}/${y}`);
            }}
          />
          <span style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}>📅</span>
        </div>
      </div>
      <div className="col-md-6 mb-3">
        <label>Service Type <span className="text-danger">*</span></label>
        <select className="form-control" value={serviceType} onChange={(e) => setServiceType(e.target.value)}>
          <option value="">Select</option>
          {serviceCategories.map((cat) => (
            <option key={cat.firestoreId} value={cat.name}>{cat.name}</option>
          ))}
        </select>
      </div>
      <div className="col-md-6 mb-3">
        <label>Customer Name</label>
        <input type="text" className="form-control" value={serviceCustomerName} onChange={(e) => setServiceCustomerName(e.target.value)} />
      </div>
      <div className="col-md-6 mb-3">
        <label>Mobile</label>
        <input type="text" className="form-control" value={serviceMobile} onChange={(e) => setServiceMobile(e.target.value.replace(/[^0-9]/g, ""))} maxLength={10} />
      </div>
      <div className="col-md-6 mb-3">
        <label>Amount <span className="text-danger">*</span></label>
        <input type="text" className="form-control" value={serviceAmount} onChange={(e) => setServiceAmount(e.target.value.replace(/[^0-9]/g, ""))} />
      </div>
      <div className="col-md-12 mb-3">
        <label>Remarks</label>
        <textarea className="form-control" rows="2" value={serviceRemarks} onChange={(e) => setServiceRemarks(e.target.value)}></textarea>
      </div>
    </div>
    <button className="btn btn-success" onClick={addService}>Save Service</button>

    <hr className="my-4" />
    <h5>Recent Service Entries</h5>
    <div style={{ overflowX: "auto" }}>
    <table className="table table-bordered mt-2">
      <thead className="table-success">
        <tr>
          <th>Date</th><th>Time</th><th>Service Type</th><th>Customer Name</th><th>Mobile</th><th>Amount</th><th>Remarks</th>
        </tr>
      </thead>
      <tbody>
        {serviceEntries.slice().reverse().map((s, i) => (
          <tr key={i}>
            <td>{s.createdDate}</td>
            <td>{s.createdTime}</td>
            <td>{s.serviceType}</td>
            <td>{s.customerName}</td>
            <td>{s.mobile}</td>
            <td>₹{s.amount}</td>
            <td>{s.remarks}</td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
  </div>
)}

{activeMenu === "Amount Categories" && (
  <AmountCategoryManager
              showToast={showToast}
    db={db}
    onUpdated={fetchAmountCategories}
  />
)}

{activeMenu === "Expense Categories" && (
  <ExpenseCategoryManager
              showToast={showToast}
    db={db}
    onUpdated={fetchExpenseCategories}
  />
)}

{activeMenu === "Activity Log" && (
  <ActivityLog db={db} />
)}

{/* New Application */}

        {activeMenu === "New Application" && (

          <div className="card mt-4 p-4 shadow">

           <div className="d-flex justify-content-between align-items-center mb-2">
  <h4 className="mb-0">
    {editId !== null
      ? editMode === "customer"
        ? "✏️ Edit Customer Details"
        : editMode === "application"
        ? "✏️ Edit Application"
        : "Edit"
      : "New Application"}
  </h4>
  <button
    className="btn btn-outline-info btn-sm"
    onClick={() => setActiveMenu("Service Register")}
  >
    🧾 Service Register →
  </button>
</div>

            <div className="row mt-3">

              <div className="col-md-6 mb-3">
  <label>Application Date <span style={{ color: "red" }}>*</span></label>
  <div style={{ position: "relative" }}>
    <input
      type="text"
      className={`form-control ${fieldErrors.applicationDate ? "border-danger" : ""}`}
      placeholder="DD/MM/YYYY"
      maxLength={10}
      value={applicationDate}
      onChange={(e) => {
        let val = e.target.value.replace(/[^0-9]/g, ""); if (val.length > 2) val = val.slice(0,2) + "/" + val.slice(2); if (val.length > 5) val = val.slice(0,5) + "/" + val.slice(5); val = val.slice(0,10);
        setApplicationDate(val);
      }}
      style={{ paddingRight: "40px" }}
    />
    <input
      type="date"
      style={{ position: "absolute", top: 0, right: 0, width: "36px", height: "100%", opacity: 0, cursor: "pointer" }}
      onChange={(e) => {
        if (!e.target.value) return;
        const [y, m, d] = e.target.value.split("-");
        setApplicationDate(`${d}/${m}/${y}`);
      }}
    />
    <span style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}>📅</span>
  </div>
</div>

              <div className="col-md-6 mb-3">

<label>Customer Name <span className="text-danger">*</span></label>

<input
  type="text"

  className={
    fieldErrors.name
    ? "form-control border-danger"
    : viewCustomer || editMode === "application"
    ? "form-control bg-secondary-subtle"
    : "form-control"
  }

  disabled={
    viewCustomer || editMode === "application"
  }

  placeholder="Enter customer name"
  value={name}

  onChange={(e) =>
    setName(e.target.value)
  }
/>

              </div>

<div className="col-md-6 mb-3">

  <label>Guardian Name <span className="text-danger">*</span></label>

<input
  type="text"

  className={
    fieldErrors.guardianName
    ? "form-control border-danger"
    : viewCustomer || editMode === "application"
    ? "form-control bg-secondary-subtle"
    : "form-control"
  }

  disabled={
    viewCustomer || editMode === "application"
  }

  placeholder="Enter guardian name"

  value={guardianName}

  onChange={(e) =>
    setGuardianName(e.target.value)
  }
/>

</div>


<div className="col-md-6 mb-3">

 <label>Date of Birth <span className="text-danger">*</span></label>

<input
  type="text"

  className={
    fieldErrors.dob
    ? "form-control border-danger"
    : viewCustomer || editMode === "application"
    ? "form-control bg-secondary-subtle"
    : "form-control"
  }

  disabled={
    viewCustomer || editMode === "application"
  }

  placeholder="DD-MM-YYYY"

  value={dob}

  maxLength={10}

  onChange={(e) => {

    let value =
      e.target.value.replace(
        /[^0-9]/g,
        ""
      );

    if (value.length > 2) {

      value =
        value.slice(0, 2) +
        "-" +
        value.slice(2);

    }

    if (value.length > 5) {

      value =
        value.slice(0, 5) +
        "-" +
        value.slice(5);

    }

    setDob(value.slice(0, 10));

  }}
/>

</div>

{dob.length === 10 && calculateAge(dob) !== null && (
  <p className="text-success mt-2">
    Age : {calculateAge(dob)} years
  </p>
)}

<div className="col-md-6 mb-3">
  <label>Location <span className="text-danger">*</span></label>
  <Select
    options={locations.map(l => ({ value: l.name, label: l.name }))}
    value={location ? { value: location, label: location } : null}
    onChange={(selected) => setLocation(selected ? selected.value : "")}
    isDisabled={
      viewCustomer || editMode === "application"
    }
    placeholder="Search location..."
    isClearable
    styles={{
      control: (base) => ({
        ...base,
        borderColor: fieldErrors.location ? "#dc3545" : "#ced4da",
        backgroundColor: (viewCustomer || editMode === "application") ? "#e9ecef" : "#fff",
        minHeight: "38px"
      })
    }}
  />
</div>

<div className="col-md-6 mb-3">

                <label>Mobile Number <span className="text-danger">*</span></label>

<input
type="text"

className={`form-control ${
fieldErrors.mobile ? "border-danger" :
lockFields || editMode === "application"
? "bg-secondary-subtle"
: ""
}`}

readOnly={
  lockFields ||
  editMode === "application"
}

placeholder="Enter mobile number"

value={mobile}

maxLength={10}

onChange={(e) => {

  const value =
    e.target.value.replace(
      /[^0-9]/g,
      ""
    );

  setMobile(value);

  if (viewCustomer === null && value.length === 10) {
    const duplicate = customers.find((c) => c.mobile === value);
    if (duplicate) {
      setMobileDuplicateWarning("⚠️ Mobile number already exists! (Customer: " + duplicate.name + ")");
    } else {
      setMobileDuplicateWarning("");
    }
  } else {
    setMobileDuplicateWarning("");
  }

}}
/>

{mobileDuplicateWarning && (
  <small className="text-danger">{mobileDuplicateWarning}</small>
)}

              </div>

              <div className="col-md-6 mb-3">

                <label>Scheme <span className="text-danger">*</span></label>

                <select
  className={`form-control ${
lockFields || editMode === "application"
? "bg-secondary-subtle"
: ""
}`}
disabled={
  lockFields ||
  editMode === "application"
}
                  value={scheme}
                  onChange={(e) =>
                    setScheme(e.target.value)
                  }
                >
                  <option value="">
                    Select Scheme
                  </option>

                  <option>
                    Construction Welfare
                  </option>

                  <option>
                    Driver Welfare
                  </option>

                  <option>
                    Manual Welfare
                  </option>

                </select>

              </div>

              {editMode !== "customer" && <div className="col-md-6 mb-3">
                <label>Status <span className="text-danger">*</span></label>
                <select className={`form-control ${fieldErrors.status ? "border-danger" : ""}`} value={status} onChange={(e) => setStatus(e.target.value)}>
                  <option value="">Select</option>
                  <option>Pending</option>
                  <option>Submitted</option>
                  <option>Resubmitted</option>
                  <option>Approved</option>
                  <option>Rejected</option>
                  <option>Chandha</option>
                  <option>Note Entry</option>
                </select>
              </div>}

              {/* Card Number */}

              <div className="col-md-6 mb-3">

                <label>Card Number {status === "Approved" && <span className="text-danger">*</span>}</label>

               <input
  type="text"

className={`form-control ${
fieldErrors.cardNumber ? "border-danger" :
(lockFields && cardNumber) || localStorage.getItem("role") !== "Admin"
? "bg-secondary-subtle"
: ""
}`}

  readOnly={
    (lockFields && cardNumber) || localStorage.getItem("role") !== "Admin"
  }

  placeholder="Enter card number"

  value={cardNumber}

  maxLength={12}

  onChange={(e) => {

    const value =
      e.target.value.replace(
        /[^a-zA-Z0-9]/g,
        ""
      );

    setCardNumber(value);

  }}

/>
              </div>

              {editMode !== "customer" && <div className="col-md-6 mb-3">
                <label>Applying For <span className="text-danger">*</span></label>
                <select
                  className={`form-control ${fieldErrors.applyingFor ? "border-danger" : ""}`}
                  value={applyingFor}
                  disabled={editMode === "application" && localStorage.getItem("role") !== "Admin"}
                  onChange={(e) => {
                    const selected = e.target.value;
                    setApplyingFor(selected);
                    const freeTypeCategories = ["Education", "Marriage"];
                    const matchedCat = amountCategories.find(c => c.name === selected);
                    const newTotal = (!freeTypeCategories.includes(selected) && matchedCat) ? String(matchedCat.amount) : "";
                    setTotalAmount(newTotal);
                    setAmountReceived("");
                    setPendingAmount("");
                    setPaymentType("");
                  }}
                >
                                    <option value="">Select</option>
                  {amountCategories.map((cat) => (
                    <option key={cat.firestoreId} value={cat.name}>{cat.name} (₹{cat.amount})</option>
                  ))}
                </select>
              </div>}

{editMode !== "customer" && <div className="col-md-6 mb-3">
  <label>Fixed Amount (Total)
    {["Education", "Marriage"].includes(applyingFor) && (
      <span className="text-danger"> *</span>
    )}
    {["Education", "Marriage"].includes(applyingFor)
      ? <small className="text-muted ms-1">(Enter manually)</small>
      : <small className="text-muted ms-1">(Auto-set from category)</small>
    }
  </label>
  <input
    type="text"
    className={`form-control ${fieldErrors.totalAmount && ["Education", "Marriage"].includes(applyingFor) ? "border-danger" : ""}`}
    placeholder="Enter total fixed amount"
    value={totalAmount}
    readOnly={!["Education", "Marriage"].includes(applyingFor)}
    onChange={(e) => {
      const val = e.target.value.replace(/[^0-9]/g, "");
      setTotalAmount(val);
      const received = Number(amountReceived || 0);
      const total = Number(val || 0);
      const pending = Math.max(0, total - received);
      setPendingAmount(String(pending));
      setPaymentType(pending === 0 && total > 0 ? "Full payment" : "Partial payment");
    }}
  />
</div>}

{editMode !== "customer" && <div className="col-md-6 mb-3">
  <label>Amount Received <span className="text-danger">*</span></label>
  <input
    type="text"
    className={`form-control ${fieldErrors.amountReceived ? "border-danger" : ""}`}
    placeholder="Enter amount received now"
    value={amountReceived}
    onChange={(e) => {
      const val = e.target.value.replace(/[^0-9]/g, "");
      setAmountReceived(val);
      const total = Number(totalAmount || 0);
      const received = Number(val || 0);
      if (received > Number(totalAmount || 0) && Number(totalAmount || 0) > 0) {
  showToast("Amount Received cannot exceed Fixed Amount!", "error");
  return;
}
      const pending = Math.max(0, total - received);
      setPendingAmount(String(pending));
      setPaymentType(pending === 0 && total > 0 ? "Full payment" : "Partial payment");
    }}
  />
</div>}

{editMode !== "customer" && <div className="col-md-6 mb-3">
  <label>Pending Amount <small className="text-muted">(Auto-calculated)</small></label>
  <input
    type="text"
    className="form-control bg-light"
    value={pendingAmount}
    readOnly
  />
</div>}

{editMode !== "customer" && <div className="col-md-6 mb-3">
  <label>Payment Type <small className="text-muted">(Auto-calculated)</small></label>
  <input
    type="text"
    className="form-control bg-light"
    value={paymentType}
    readOnly
  />
</div>}

             {/* Pay Button - Only show when editing Application */}
{editMode === "application" && Number(editId) > 0 && Number(customers.find(c => c.firestoreId === editId)?.pendingAmount || 0) > 0 && (
  <div className="col-md-12 mb-3">
    <div className="card bg-light p-3 border border-success" style={{ borderWidth: "2px" }}>
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <h6 className="mb-1" style={{ color: "#6b7280" }}>💰 Pending Amount</h6>
          <h3 style={{ color: "#ef4444", margin: 0, fontSize: "28px" }}>
            ₹{customers.find(c => c.firestoreId === editId)?.pendingAmount || 0}
          </h3>
        </div>
        <button
          className="btn btn-success btn-lg"
          onClick={() => {
            const customer = customers.find(c => c.firestoreId === editId);
            setPaymentCustomer(customer);
            setPaymentAmount("");
            setPaymentDate(getTodayStr());
            setPaymentNotes("");
            setShowPaymentModal(true);
          }}
          style={{ minWidth: "160px", fontWeight: "700", fontSize: "15px" }}
        >
          💳 Add Payment
        </button>
      </div>
    </div>
  </div>
)}
 
{/* Remarks */}
 
              {editMode !== "customer" && <div className="col-md-12 mb-3">
                <label>Remarks</label>
                <textarea
                  className={`form-control ${fieldErrors.remarks ? "border-danger" : ""}`}
                  rows="3"
                  placeholder="Enter remarks"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                ></textarea>
              </div>}

              
{(editMode === "full" || editMode === "customer") && !isExistingCustomer && (
<div className="col-md-12 mb-3">
  <label>
    Upload Documents
    <small className="text-muted ms-2">(PDF / Image — max 500KB each)</small>
  </label>
  <input
    key={`doc-${fileInputKey}`}
    type="file"
    className="form-control"
    accept=".pdf,image/*"
    multiple
    onChange={(e) => {
      setUploadError("");
      const files = Array.from(e.target.files);
      const errors = [];
      const valid = [];

      for (const file of files) {
        const isPDF = file.type === "application/pdf";
        const isImage = file.type.startsWith("image/");
        if (!isPDF && !isImage) { errors.push(`${file.name}: Only PDF or Image allowed`); continue; }
        if (file.size > 500 * 1024) {
          errors.push(`${file.name}: Must be under 500KB (${(file.size/1024).toFixed(1)}KB)`);
          continue;
        }
        valid.push(file);
      }

      if (errors.length > 0) { setUploadError(errors.join(" | ")); e.target.value = ""; return; }
      setUploadedFiles(prev => [...prev, ...valid]);
      e.target.value = "";
    }}
  />
  {uploadError && <small className="text-danger d-block mt-1">{uploadError}</small>}
  {uploadedFiles.length > 0 && (
    <div className="mt-2">
      {uploadedFiles.map((f, i) => (
        <div key={i} className="d-flex align-items-center gap-2 mb-1">
          <small className="text-success">✅ {f.name} ({(f.size/1024).toFixed(1)}KB)</small>
          <button type="button" className="btn btn-outline-danger btn-sm py-0 px-1" style={{fontSize:"11px"}}
            onClick={() => setUploadedFiles(prev => prev.filter((_,idx) => idx !== i))}>✕</button>
        </div>
      ))}
      <small className="text-muted">{uploadedFiles.length} file(s) selected</small>
    </div>
  )}
</div>
)}

{(editMode === "full" || editMode === "customer") && !isExistingCustomer && (
<div className="col-md-12 mb-3">
  <label>
    Membership Form {editId === null && <span className="text-danger">*</span>}
    <small className="text-muted ms-2">{editId === null ? "(Compulsory — PDF / Image max 500KB)" : "(Optional — PDF / Image max 500KB)"}</small>
  </label>
  <input
    key={`mem-${fileInputKey}`}
    type="file"
    className={`form-control ${!membershipForm && editId === null && editMode !== "customer" ? "border-danger" : ""}`}
    accept=".pdf,image/*"
    onChange={(e) => {
      const file = e.target.files[0];
      setMembershipFormError("");
      if (!file) { setMembershipForm(null); return; }
      const isPDF = file.type === "application/pdf";
      const isImage = file.type.startsWith("image/");
      if (!isPDF && !isImage) { setMembershipFormError("Only PDF or Image allowed."); e.target.value = ""; return; }
      if (file.size > 500 * 1024) { setMembershipFormError(`Must be under 500KB (${(file.size/1024).toFixed(1)}KB)`); e.target.value = ""; return; }
      setMembershipForm(file);
    }}
  />
  {membershipFormError && <small className="text-danger d-block mt-1">❌ {membershipFormError}</small>}
  {membershipForm && <small className="text-success d-block mt-1">✅ {membershipForm.name} ({(membershipForm.size/1024).toFixed(1)}KB)</small>}
  {!membershipForm && editId === null && editMode !== "customer" && <small className="text-danger d-block mt-1">⚠️ Membership Form is required</small>}
</div>
)}

{/* Save Button */}

              <div className="col-md-12 d-flex gap-3">

    <button
  className="btn btn-success"
  disabled={isSaving}
  onClick={() => {
if (!validateFields()) {
      showToast("Please fill the fields highlighted in red!", "error");
      return;
    }
if (mobileDuplicateWarning !== "") {
      showToast("Duplicate mobile number exists! Cannot save.", "error");
      return;
    }
    if (uploadError !== "") {
      showToast("Please fix document upload error first.", "error");
      return;
    }
    if (editId === null && !isExistingCustomer && !membershipForm) {
      showToast("Membership Form is required! Please upload it.", "error");
      return;
    }
    const confirmed = window.confirm("Are you sure you want to save this application?");
    if (!confirmed) return;
    addCustomer();
  }}
>

                  {editId !== null
                    ? "Update Customer"
                    : "Save Application"}
                </button>

                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    const confirmed = window.confirm("Are you sure you want to cancel?");
                    if (!confirmed) return;
                    setEditId(null);
                    setName("");
                    setMobile("");
                    setScheme("");
                    setStatus("Pending");
                    setRemarks("");
                    setCardNumber("");
                    setApplyingFor("");
                    setAmountReceived("");
                    setPaymentType("");
                    setPendingAmount("");
                    setGuardianName("");
                    setDob("");
                    setLocation("");
                    setLockFields(false); setIsExistingCustomer(false);
                    setViewCustomer(null);
                    setMobileDuplicateWarning("");
                    setEditMode("full");
                    setApplicationDate("");
                    setActiveMenu(
                      viewCustomer ? "Customer List" : "Dashboard"
                    );
                  }}
                >
                  Cancel
                </button>

              </div>

            </div>

          </div>

        )}

      </div>
      </div>

    </div>
    </>
  );
}

const getYearsList = () => {
  const current = new Date().getFullYear();
  return Array.from({ length: 6 }, (_, i) => String(current - 1 + i));
};

const DateFilter = ({ from, setFrom, to, setTo, month, setMonth, year, setYear, onClear, months, years }) => (
  <div className="card shadow p-3 mt-3">
    <div className="row g-3 align-items-end">
      <div className="col-md-2">
        <label>Month</label>
        <select className="form-control" value={month} onChange={(e) => { setMonth(e.target.value); onClear("range"); }}>
          <option value="">All Months</option>
          {months.map(m => <option key={m.v} value={m.v}>{m.l}</option>)}
        </select>
      </div>
      <div className="col-md-2">
        <label>Year</label>
        <select className="form-control" value={year} onChange={(e) => { setYear(e.target.value); onClear("range"); }}>
          <option value="">All Years</option>
          {years.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>
      <div className="col-md-3">
        <label>From Date</label>
        <div style={{ position: "relative" }}>
          <input
            type="text"
            className="form-control"
            placeholder="DD/MM/YYYY"
            maxLength={10}
            value={from}
            onChange={(e) => {
              let v = e.target.value.replace(/[^0-9]/g, "");
              if (v.length > 2) v = v.slice(0,2) + "/" + v.slice(2);
              if (v.length > 5) v = v.slice(0,5) + "/" + v.slice(5);
              setFrom(v.slice(0,10)); setMonth(""); setYear("");
            }}
            style={{ paddingRight: "36px" }}
          />
          <input
            type="date"
            style={{ position: "absolute", top: 0, right: 0, width: "32px", height: "100%", opacity: 0, cursor: "pointer" }}
            onChange={(e) => {
              if (!e.target.value) return;
              const [y, m, d] = e.target.value.split("-");
              setFrom(`${d}/${m}/${y}`); setMonth(""); setYear("");
            }}
          />
          <span style={{ position: "absolute", right: "8px", top: "50%", transform: "translateY(-50%)", pointerEvents: "none", fontSize: "13px" }}>📅</span>
        </div>
      </div>
      <div className="col-md-3">
        <label>To Date</label>
        <div style={{ position: "relative" }}>
          <input
            type="text"
            className="form-control"
            placeholder="DD/MM/YYYY"
            maxLength={10}
            value={to}
            onChange={(e) => {
              let v = e.target.value.replace(/[^0-9]/g, "");
              if (v.length > 2) v = v.slice(0,2) + "/" + v.slice(2);
              if (v.length > 5) v = v.slice(0,5) + "/" + v.slice(5);
              setTo(v.slice(0,10)); setMonth(""); setYear("");
            }}
            style={{ paddingRight: "36px" }}
          />
          <input
            type="date"
            style={{ position: "absolute", top: 0, right: 0, width: "32px", height: "100%", opacity: 0, cursor: "pointer" }}
            onChange={(e) => {
              if (!e.target.value) return;
              const [y, m, d] = e.target.value.split("-");
              setTo(`${d}/${m}/${y}`); setMonth(""); setYear("");
            }}
          />
          <span style={{ position: "absolute", right: "8px", top: "50%", transform: "translateY(-50%)", pointerEvents: "none", fontSize: "13px" }}>📅</span>
        </div>
      </div>
      <div className="col-md-2">
        <button className="btn btn-secondary w-100" onClick={() => onClear("all")}>Clear</button>
      </div>
    </div>
  </div>
);

function FinancialPage({ db, customers, showToast, expenseCategories }) {
  const [activeTab, setActiveTab] = useState("overview");
  const [expenses, setExpenses] = useState([]);
  const [expCategory, setExpCategory] = useState("");
  const [expAmount, setExpAmount] = useState("");
  const [expDate, setExpDate] = useState("");
  const [expNotes, setExpNotes] = useState("");
  const [customCategory, setCustomCategory] = useState("");
  const [financialFilter, setFinancialFilter] = useState("All");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filterMonth, setFilterMonth] = useState("");
  const [filterYear, setFilterYear] = useState("");
  const [expFromDate, setExpFromDate] = useState("");
  const [expFilterCategory, setExpFilterCategory] = useState("");
  const [expToDate, setExpToDate] = useState("");
  const [expFilterMonth, setExpFilterMonth] = useState("");
  const [expFilterYear, setExpFilterYear] = useState("");
  const [profFromDate, setProfFromDate] = useState("");
  const [profToDate, setProfToDate] = useState("");
  const [profFilterMonth, setProfFilterMonth] = useState("");
  const [profFilterYear, setProfFilterYear] = useState("");
  const [loadingExp, setLoadingExp] = useState(true);

  const [serviceEntries, setServiceEntries] = useState([]);

  const [allPayments, setAllPayments] = useState([]);
const [payFromDate, setPayFromDate] = useState("");
const [payToDate, setPayToDate] = useState("");
const [payFilterMonth, setPayFilterMonth] = useState("");
const [payFilterYear, setPayFilterYear] = useState("");
const [editPaymentId, setEditPaymentId] = useState(null);
const [editPaymentDate, setEditPaymentDate] = useState("");

useEffect(() => { fetchExpenses(); fetchServiceEntries(); fetchAllPayments(); }, []);
const parsePaymentDate = (dateStr) => {
  if (!dateStr) return new Date(0);
  if (dateStr.includes("/")) {
    const p = dateStr.split("/");
    if (p.length === 3) return new Date(Number(p[2]), Number(p[1]) - 1, Number(p[0]));
  }
  const d = new Date(dateStr);
  return isNaN(d.getTime()) ? new Date(0) : d;
};

const fetchAllPayments = async () => {
  const snap = await getDocs(collection(db, "payments"));
  const data = [];
  snap.forEach(d => data.push({ id: d.id, ...d.data() }));
  data.sort((a, b) => parsePaymentDate(b.date) - parsePaymentDate(a.date));
  setAllPayments(data);
};

const updatePaymentDate = async (id) => {
  if (!/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/[0-9]{4}$/.test(editPaymentDate)) {
    showToast("Date format DD/MM/YYYY ஆக இருக்கணும்", "error");
    return;
  }
  try {
    const oldRecord = allPayments.find(p => p.id === id);
    const oldDate = oldRecord?.date || "-";
    await updateDoc(doc(db, "payments", id), { date: editPaymentDate });
    setAllPayments(prev => prev.map(p => p.id === id ? { ...p, date: editPaymentDate } : p));
    setEditPaymentId(null);
    setEditPaymentDate("");
    showToast("Payment Date Updated!");
    try {
      await addDoc(collection(db, "activityLogs"), {
        user: localStorage.getItem("loggedUser"),
        role: localStorage.getItem("role"),
        action: "Payment Date Edited",
        details: `Payment ID: ${id} | Customer: ${oldRecord?.customerName || "-"} | Date: ${oldDate} → ${editPaymentDate}`,
        timestamp: new Date().toISOString(),
        date: new Date().toLocaleDateString(),
        time: new Date().toLocaleTimeString()
      });
    } catch (logErr) {
      console.error("Log failed:", logErr);
    }
  } catch (err) {
    showToast("Update failed: " + err.message, "error");
  }
};

  const fetchServiceEntries = async () => {
    const querySnapshot = await getDocs(collection(db, "serviceEntries"));
    const data = [];
    querySnapshot.forEach((doc) => { data.push({ firestoreId: doc.id, ...doc.data() }); });
    setServiceEntries(data);
  };

  const fetchExpenses = async () => {
    setLoadingExp(true);
    const querySnapshot = await getDocs(collection(db, "expenses"));
    const data = [];
    querySnapshot.forEach((doc) => { data.push({ firestoreId: doc.id, ...doc.data() }); });
    const parseSortDate = (s) => {
      if (!s) return new Date(0);
      const p = s.split("/");
      if (p.length === 3) return new Date(Number(p[2]), Number(p[1])-1, Number(p[0]));
      return new Date(s);
    };
    data.sort((a, b) => parseSortDate(b.date) - parseSortDate(a.date));
    setExpenses(data);
    setLoadingExp(false);
  };

  const addExpense = async () => {
    const finalCategory = expCategory === "Custom" ? customCategory : expCategory;
    if (!finalCategory || !expAmount || !expDate) {
      showToast("Please fill Category, Amount and Date", "error");
      return;
    }
    if (!/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/[0-9]{4}$/.test(expDate)) {
      showToast("Date format: DD/MM/YYYY ஆக போடு (e.g. 18/06/2026)");
      return;
    }
    await addDoc(collection(db, "expenses"), {
      category: finalCategory,
      amount: Number(expAmount),
      date: expDate,
      notes: expNotes,
      createdAt: new Date().toISOString()
    });
    showToast("Expense Added!");
    setExpCategory(""); setExpAmount(""); setExpDate(""); setExpNotes(""); setCustomCategory("");
    fetchExpenses();
  };

  const deleteExpense = async (id) => {
    if (!window.confirm("Delete this expense?")) return;
    await deleteDoc(doc(db, "expenses", id));
    fetchExpenses();
  };

  const parseCustomerDate = (dateStr) => {
    if (!dateStr) return null;
    const parts = dateStr.split("/");
    if (parts.length === 3) return new Date(parts[2], parts[1] - 1, parts[0]);
    return new Date(dateStr);
  };

  const parseExpenseDate = (dateStr) => {
    if (!dateStr) return null;
    const parts = dateStr.split("/");
    if (parts.length === 3) {
      const d = new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
      return isNaN(d.getTime()) ? null : d;
    }
    const d = new Date(dateStr);
    return isNaN(d.getTime()) ? null : d;
  };

  const parseFilterBoundary = (dateStr) => {
    if (!dateStr) return null;
    const parts = dateStr.split("/");
    if (parts.length !== 3) return null;
    const [d, m, y] = parts.map(Number);
    if (!d || !m || !y) return null;
    return new Date(y, m - 1, d);
  };

  const applyFilter = (date, from, to, month, year) => {
    if (!date || isNaN(date.getTime())) return false;
    if (from) {
      const f = parseFilterBoundary(from);
      if (f && date < f) return false;
    }
    if (to) {
      const t = parseFilterBoundary(to);
      if (t) { t.setHours(23, 59, 59, 999); if (date > t) return false; }
    }
    if (month) {
      if (String(date.getMonth() + 1).padStart(2, "0") !== month) return false;
    }
    if (year) {
      if (String(date.getFullYear()) !== year) return false;
    }
    return true;
  };

  const hasIncomeFilter = fromDate || toDate || filterMonth || filterYear;
  const hasExpenseFilter = expFromDate || expToDate || expFilterMonth || expFilterYear;
  const hasProfFilter = profFromDate || profToDate || profFilterMonth || profFilterYear;

  // Date filtered only (for top summary cards — not affected by payment type filter)
  const dateFilteredIncome = customers.filter((c) => {
    if (!hasIncomeFilter) return true;
    const d = parseCustomerDate(c.createdDate);
    return applyFilter(d, fromDate, toDate, filterMonth, filterYear);
  });

  // Date + payment type filtered (for table and bottom cards)
  const filteredIncome = customers.filter((c) => {
    if (financialFilter !== "All" && c.paymentType !== financialFilter) return false;
    if (!hasIncomeFilter) return true;
    const d = parseCustomerDate(c.createdDate);
    return applyFilter(d, fromDate, toDate, filterMonth, filterYear);
  });

  const filteredServiceEntries = serviceEntries.filter((s) => {
    if (!hasIncomeFilter) return true;
    const d = parseCustomerDate(s.createdDate);
    return applyFilter(d, fromDate, toDate, filterMonth, filterYear);
  });

  const filteredExpenses = expenses.filter((e) => {
    if (expFilterCategory && e.category !== expFilterCategory) return false;
    if (!hasExpenseFilter) return true;
    const d = parseExpenseDate(e.date);
    return applyFilter(d, expFromDate, expToDate, expFilterMonth, expFilterYear);
  });

  const profitIncomeFiltered = customers.filter((c) => {
    if (!hasProfFilter) return true;
    const d = parseCustomerDate(c.createdDate);
    return applyFilter(d, profFromDate, profToDate, profFilterMonth, profFilterYear);
  });

  const profitServiceFiltered = serviceEntries.filter((s) => {
    if (!hasProfFilter) return true;
    const d = parseCustomerDate(s.createdDate);
    return applyFilter(d, profFromDate, profToDate, profFilterMonth, profFilterYear);
  });

  const profitExpenseFiltered = expenses.filter((e) => {
    if (!hasProfFilter) return true;
    const d = parseExpenseDate(e.date);
    return applyFilter(d, profFromDate, profToDate, profFilterMonth, profFilterYear);
  });
  const totalServiceIncome = serviceEntries.reduce((t, s) => t + Number(s.amount || 0), 0);
  const totalIncome = customers.reduce((t, c) => t + Number(c.amountReceived || 0), 0) + totalServiceIncome;
  const totalExpense = expenses.reduce((t, e) => t + Number(e.amount || 0), 0);
  const filteredServiceIncome = filteredServiceEntries.reduce((t, s) => t + Number(s.amount || 0), 0);

  // ✅ Income tab = accrual view: total value of applications created in this
  // period, regardless of when the cash actually came in.
  const filteredTotalIncome = dateFilteredIncome.reduce((t, c) => t + Number(c.amountReceived || 0), 0) + filteredServiceIncome;
  const filteredTotalExpense = filteredExpenses.reduce((t, e) => t + Number(e.amount || 0), 0);
  const netProfit = filteredTotalIncome - filteredTotalExpense;

  // ✅ Payments tab = cash view: independent filter, tracks actual money
  // received by transaction date. Intentionally separate from Income —
  // a payment can land in a different month than its application.
  const hasPayFilter = payFromDate || payToDate || payFilterMonth || payFilterYear;
  const incomeFilteredPayments = allPayments.filter(p => {
    if (!hasPayFilter) return true;
    const d = parsePaymentDate(p.date);
    if (isNaN(d.getTime())) return false;
    if (payFilterMonth && String(d.getMonth() + 1).padStart(2, "0") !== payFilterMonth) return false;
    if (payFilterYear && String(d.getFullYear()) !== payFilterYear) return false;
    if (payFromDate) { const from = parsePaymentDate(payFromDate); if (d < from) return false; }
    if (payToDate) { const to = parsePaymentDate(payToDate); to.setHours(23, 59, 59); if (d > to) return false; }
    return true;
  });
  const filteredPaymentsSum = incomeFilteredPayments.reduce((t, p) => t + Number(p.amount || 0), 0);

  const profitServiceIncome = profitServiceFiltered.reduce((t, s) => t + Number(s.amount || 0), 0);
  const profitIncome = profitIncomeFiltered.reduce((t, c) => t + Number(c.amountReceived || 0), 0) + profitServiceIncome;
  const profitExpense = profitExpenseFiltered.reduce((t, e) => t + Number(e.amount || 0), 0);
  const profitNet = profitIncome - profitExpense;

  const years = getYearsList();
  const months = [
    {v:"01",l:"January"},{v:"02",l:"February"},{v:"03",l:"March"},{v:"04",l:"April"},
    {v:"05",l:"May"},{v:"06",l:"June"},{v:"07",l:"July"},{v:"08",l:"August"},
    {v:"09",l:"September"},{v:"10",l:"October"},{v:"11",l:"November"},{v:"12",l:"December"}
  ];

  if (loadingExp) return (
    <div style={{
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      height: "400px", gap: "16px"
    }}>
      <div style={{
        width: "50px", height: "50px",
        border: "4px solid rgba(212,175,55,0.2)",
        borderTop: "4px solid #d4af37",
        borderRadius: "50%",
        animation: "spin 0.8s linear infinite"
      }} />
      <p style={{ color: "#8899bb", fontSize: "14px" }}>Loading financial data...</p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );

  return (
    <div className="mt-4">

      {/* Tab Buttons */}
<div className="d-flex gap-2 mb-4 flex-wrap">
  {[
    { key: "income", label: "💰 Income" },
    { key: "payments", label: "💳 Payments" },
    { key: "expense", label: "🔴 Expense" },
    { key: "profit", label: "🟢 Profit" },
  ].map(tab => (
    <button
      key={tab.key}
      className={`btn ${activeTab === tab.key ? "btn-dark" : "btn-outline-dark"}`}
      onClick={() => setActiveTab(tab.key)}
    >
      {tab.label}
    </button>
  ))}
</div>

      {/* 3 Summary Cards */}
      <div className="row g-3 mb-4">
        <div className="col-md-4">
          <div className="card shadow p-4 text-center" style={{ cursor: "pointer", border: activeTab === "income" ? "2px solid #198754" : "" }} onClick={() => setActiveTab("income")}>
            <h6 className="text-muted">💰 Total Income {(fromDate || toDate || filterMonth || filterYear) && "(Filtered)"}</h6>
            <h2 className="text-success">₹{filteredTotalIncome.toLocaleString()}</h2>
            <small className="text-muted">Click to view</small>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card shadow p-4 text-center" style={{ cursor: "pointer", border: activeTab === "expense" ? "2px solid #dc3545" : "" }} onClick={() => setActiveTab("expense")}>
            <h6 className="text-muted">🔴 Total Expense {(expFromDate || expToDate || expFilterMonth || expFilterYear) && "(Filtered)"}</h6>
            <h2 className="text-danger">₹{filteredTotalExpense.toLocaleString()}</h2>
            <small className="text-muted">Click to view</small>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card shadow p-4 text-center" style={{ cursor: "pointer", border: activeTab === "profit" ? "2px solid #0d6efd" : "" }} onClick={() => setActiveTab("profit")}>
            <h6 className="text-muted">🟢 Net Profit {(profFromDate || profToDate || profFilterMonth || profFilterYear) && "(Filtered)"}</h6>
            <h2 className={netProfit >= 0 ? "text-success" : "text-danger"}>₹{netProfit.toLocaleString()}</h2>
            <small className="text-muted">Click to view</small>
          </div>
        </div>
      </div>

      {/* INCOME TAB */}
      {activeTab === "income" && (
        <div>
          <div className="row g-3">
            {[
              { label: "Total Collection", value: `₹${dateFilteredIncome.reduce((t,c) => t+Number(c.amountReceived||0),0)}`, sub: `${dateFilteredIncome.length} applications`, filter: "All", color: "#2563eb" },
              { label: "Full Payments", value: dateFilteredIncome.filter(c=>c.paymentType==="Full payment").length, sub: `₹${dateFilteredIncome.filter(c=>c.paymentType==="Full payment").reduce((t,c)=>t+Number(c.amountReceived||0),0)}`, filter: "Full payment", color: "#22c55e" },
              { label: "Partial Payments", value: dateFilteredIncome.filter(c=>c.paymentType==="Partial payment").length, sub: `₹${dateFilteredIncome.filter(c=>c.paymentType==="Partial payment").reduce((t,c)=>t+Number(c.amountReceived||0),0)}`, filter: "Partial payment", color: "#f59e0b" },
            ].map((item, i) => (
              <div key={i} className="col-md-4">
                <div
                  className="card shadow p-3"
                  onClick={() => setFinancialFilter(item.filter)}
                  style={{
                    cursor: "pointer",
                    borderLeft: financialFilter === item.filter ? `4px solid ${item.color}` : "4px solid transparent",
                    background: financialFilter === item.filter ? "#f8fafc" : "white",
                    transition: "all 0.2s"
                  }}
                >
                  <h5 style={{ color: financialFilter === item.filter ? item.color : "#64748b" }}>{item.label}</h5>
                  <h2 style={{ color: financialFilter === item.filter ? item.color : "#1e293b" }}>{item.value}</h2>
                  <p className="text-muted mb-0">{item.sub}</p>
                </div>
              </div>
            ))}
          </div>

          <DateFilter
            from={fromDate} setFrom={setFromDate}
            to={toDate} setTo={setToDate}
            month={filterMonth} setMonth={setFilterMonth}
            year={filterYear} setYear={setFilterYear}
            months={months} years={years}
            onClear={(type) => {
              if (type==="range") { setFromDate(""); setToDate(""); }
              if (type==="all") { setFromDate(""); setToDate(""); setFilterMonth(""); setFilterYear(""); }
            }}
          />

          <div className="card shadow p-4 mt-3">
            <div className="d-flex justify-content-between align-items-center">
              <h4>Income Records</h4>
              <button
                className="btn btn-outline-success btn-sm"
                onClick={() => {
                  const exportData = filteredIncome.map(c => ({
                    "Name": c.name, "Mobile": c.mobile, "Location": c.location,
                    "Applying For": c.applyingFor, "Amount Received": c.amountReceived,
                    "Pending Amount": c.pendingAmount || 0, "Payment Type": c.paymentType, "Date": c.createdDate
                  }));
                  const ws = XLSX.utils.json_to_sheet(exportData);
                  const wb = XLSX.utils.book_new();
                  XLSX.utils.book_append_sheet(wb, ws, "Income");
                  const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                  saveAs(new Blob([buf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" }), "income_records.xlsx");
                }}
              >
                📥 Export Excel
              </button>
            </div>
            <table className="table table-bordered mt-3">
              <thead className="table-success">
                <tr>
                  <th>Name</th><th>Mobile</th><th>Location</th><th>Applying For</th>
                  <th>Amount Received</th><th>Pending Amount</th><th>Payment Type</th><th>Date</th>
                </tr>
              </thead>
              <tbody>
                {filteredIncome.map((c,i) => (
                  <tr key={i}>
                    <td>{c.name}</td><td>{c.mobile}</td><td>{c.location}</td><td>{c.applyingFor}</td>
                    <td>₹{c.amountReceived}</td><td>₹{c.pendingAmount||0}</td>
                    <td><span className={c.paymentType==="Full payment"?"badge bg-success":"badge bg-warning text-dark"}>{c.paymentType}</span></td>
                    <td>{c.createdDate}</td>
                  </tr>
                ))}
              </tbody>
             <tfoot>
                <tr className="table-success fw-bold">
                  <td colSpan="4">Total</td>
                  <td>₹{filteredIncome.reduce((t,c)=>t+Number(c.amountReceived||0),0)}</td>
                  <td>₹{filteredIncome.reduce((t,c)=>t+Number(c.pendingAmount||0),0)}</td>
                  <td colSpan="2"></td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div className="card shadow p-4 mt-3">
            <h4>🧾 Service Income</h4>
            <h2 className="text-success">₹{filteredServiceIncome.toLocaleString()}</h2>
            <p className="text-muted">{filteredServiceEntries.length} service records</p>
            <table className="table table-bordered mt-3">
              <thead className="table-success">
                <tr>
                  <th>Date</th><th>Service Type</th><th>Customer Name</th><th>Mobile</th><th>Amount</th><th>Remarks</th>
                </tr>
              </thead>
              <tbody>
                {filteredServiceEntries.map((s, i) => (
                  <tr key={i}>
                    <td>{s.createdDate}</td>
                    <td>{s.serviceType}</td>
                    <td>{s.customerName}</td>
                    <td>{s.mobile}</td>
                    <td>₹{s.amount}</td>
                    <td>{s.remarks}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="table-success fw-bold">
                  <td colSpan="4">Total</td>
                  <td>₹{filteredServiceIncome.toLocaleString()}</td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      )}

      {/* PAYMENTS TAB */}
{activeTab === "payments" && (() => {
  // ✅ Reuses the exact same filtered array + total as the Income tab
  // (incomeFilteredPayments / filteredPaymentsSum) — Income and Payments
  // totals can never drift apart again, since it's the same calculation.
  const filteredPayments = incomeFilteredPayments;
  const totalFiltered = filteredPaymentsSum;

  return (
    <div>
      {/* Summary Card */}
      <div className="row g-3 mb-4">
        <div className="col-md-4">
          <div className="card shadow p-4 text-center">
            <h6 className="text-muted">💳 Total Payments</h6>
            <h2 className="text-success">₹{totalFiltered.toLocaleString()}</h2>
            <p className="text-muted">{filteredPayments.length} records</p>
          </div>
        </div>
      </div>

      {/* Filter — independent from Income tab (this is cash by transaction date) */}
      <div className="card shadow p-3 mb-3">
        <div className="row g-3 align-items-end">
          <div className="col-md-2">
            <label>Month</label>
            <select className="form-control" value={payFilterMonth} onChange={(e) => { setPayFilterMonth(e.target.value); setPayFromDate(""); setPayToDate(""); }}>
              <option value="">All Months</option>
              {months.map(m => <option key={m.v} value={m.v}>{m.l}</option>)}
            </select>
          </div>
          <div className="col-md-2">
            <label>Year</label>
            <select className="form-control" value={payFilterYear} onChange={(e) => { setPayFilterYear(e.target.value); setPayFromDate(""); setPayToDate(""); }}>
              <option value="">All Years</option>
              {years.map(y => <option key={y} value={y}>{y}</option>)}
            </select>
          </div>
          <div className="col-md-3">
            <label>From Date</label>
            <div style={{ position: "relative" }}>
              <input
                type="text"
                className="form-control"
                placeholder="DD/MM/YYYY"
                maxLength={10}
                value={payFromDate}
                onChange={(e) => {
                  let v = e.target.value.replace(/[^0-9]/g, "");
                  if (v.length > 2) v = v.slice(0,2) + "/" + v.slice(2);
                  if (v.length > 5) v = v.slice(0,5) + "/" + v.slice(5);
                  setPayFromDate(v.slice(0,10)); setPayFilterMonth(""); setPayFilterYear("");
                }}
                style={{ paddingRight: "36px" }}
              />
              <input
                type="date"
                style={{ position: "absolute", top: 0, right: 0, width: "32px", height: "100%", opacity: 0, cursor: "pointer" }}
                onChange={(e) => {
                  if (!e.target.value) return;
                  const [y, m, d] = e.target.value.split("-");
                  setPayFromDate(`${d}/${m}/${y}`); setPayFilterMonth(""); setPayFilterYear("");
                }}
              />
              <span style={{ position: "absolute", right: "8px", top: "50%", transform: "translateY(-50%)", pointerEvents: "none", fontSize: "13px" }}>📅</span>
            </div>
          </div>
          <div className="col-md-3">
            <label>To Date</label>
            <div style={{ position: "relative" }}>
              <input
                type="text"
                className="form-control"
                placeholder="DD/MM/YYYY"
                maxLength={10}
                value={payToDate}
                onChange={(e) => {
                  let v = e.target.value.replace(/[^0-9]/g, "");
                  if (v.length > 2) v = v.slice(0,2) + "/" + v.slice(2);
                  if (v.length > 5) v = v.slice(0,5) + "/" + v.slice(5);
                  setPayToDate(v.slice(0,10)); setPayFilterMonth(""); setPayFilterYear("");
                }}
                style={{ paddingRight: "36px" }}
              />
              <input
                type="date"
                style={{ position: "absolute", top: 0, right: 0, width: "32px", height: "100%", opacity: 0, cursor: "pointer" }}
                onChange={(e) => {
                  if (!e.target.value) return;
                  const [y, m, d] = e.target.value.split("-");
                  setPayToDate(`${d}/${m}/${y}`); setPayFilterMonth(""); setPayFilterYear("");
                }}
              />
              <span style={{ position: "absolute", right: "8px", top: "50%", transform: "translateY(-50%)", pointerEvents: "none", fontSize: "13px" }}>📅</span>
            </div>
          </div>
          <div className="col-md-2">
            <button className="btn btn-secondary w-100" onClick={() => { setPayFromDate(""); setPayToDate(""); setPayFilterMonth(""); setPayFilterYear(""); }}>
              Clear
            </button>
          </div>
        </div>
      </div>

      {/* Payments Table */}
      <div className="card shadow p-4">
        <h5>Payment Records</h5>
        <table className="table table-bordered mt-3">
          <thead className="table-success">
            <tr>
              <th>#</th>
              <th>Date</th>
              <th>Customer Name</th>
              <th>App ID</th>
              <th>Mobile</th>
              <th>Amount Paid</th>
              <th>Notes</th>
              <th>Added By</th>
              {localStorage.getItem("role") === "Admin" && <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {filteredPayments.length === 0 ? (
              <tr><td colSpan="8" className="text-center text-muted">No payment records found</td></tr>
            ) : (
              filteredPayments.map((p, i) => (
                <tr key={p.id}>
                  <td>{i + 1}</td>
                  <td>
                    {editPaymentId === p.id ? (
                      <div style={{ position: "relative", minWidth: "130px" }}>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="DD/MM/YYYY"
                          maxLength={10}
                          value={editPaymentDate}
                          autoFocus
                          onChange={(e) => {
                            let v = e.target.value.replace(/[^0-9]/g, "");
                            if (v.length > 2) v = v.slice(0,2) + "/" + v.slice(2);
                            if (v.length > 5) v = v.slice(0,5) + "/" + v.slice(5);
                            setEditPaymentDate(v.slice(0,10));
                          }}
                          onKeyDown={(e) => e.key === "Enter" && updatePaymentDate(p.id)}
                          style={{ paddingRight: "28px" }}
                        />
                        <input
                          type="date"
                          style={{ position: "absolute", top: 0, right: 0, width: "26px", height: "100%", opacity: 0, cursor: "pointer" }}
                          onChange={(e) => {
                            if (!e.target.value) return;
                            const [y, m, d] = e.target.value.split("-");
                            setEditPaymentDate(`${d}/${m}/${y}`);
                          }}
                        />
                      </div>
                    ) : (
                      p.date
                    )}
                  </td>
                  <td style={{ fontWeight: "600" }}>{p.customerName}</td>
                  <td><span className="badge bg-success">{p.appId || p.applicationId}</span></td>
                  <td>{p.mobile}</td>
                  <td style={{ color: "#16a34a", fontWeight: "700" }}>₹{p.amount}</td>
                  <td>{p.notes || "-"}</td>
                  <td><span className="badge bg-secondary">{p.createdBy}</span></td>
                  {localStorage.getItem("role") === "Admin" && (
                    <td>
                      <div className="d-flex gap-2">
                        {editPaymentId === p.id ? (
                          <>
                            <button className="btn btn-success btn-sm" onClick={() => updatePaymentDate(p.id)}>Save</button>
                            <button className="btn btn-secondary btn-sm" onClick={() => { setEditPaymentId(null); setEditPaymentDate(""); }}>Cancel</button>
                          </>
                        ) : (
                          <>
                            <button
                              className="btn btn-outline-primary btn-sm"
                              onClick={() => { setEditPaymentId(p.id); setEditPaymentDate(p.date || ""); }}
                            >
                              ✏️
                            </button>
                            <button
                              className="btn btn-outline-danger btn-sm"
                              onClick={async () => {
                                if (!window.confirm("Delete this payment record?")) return;
                                await deleteDoc(doc(db, "payments", p.id));
                                setAllPayments(prev => prev.filter(x => x.id !== p.id));
                              }}
                            >
                              🗑️
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                  )}
                </tr>
              ))
              )}
          </tbody>
          <tfoot>
            <tr className="table-success fw-bold">
              <td colSpan="5">Total</td>
              <td>₹{totalFiltered.toLocaleString()}</td>
              <td colSpan="2"></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
})()}

      {/* EXPENSE TAB */}
      {activeTab === "expense" && (
        <div>
          <div className="card shadow p-4 mb-4">
            <h5>Add Expense</h5>
            <div className="row mt-3">
              <div className="col-md-3 mb-3">
                <label>Category</label>
                <select className="form-control" value={expCategory} onChange={(e) => setExpCategory(e.target.value)}>
                  <option value="">Select Category</option>
                  {expenseCategories.map((cat) => (
                    <option key={cat.firestoreId} value={cat.name}>{cat.name}</option>
                  ))}
                  <option>Custom</option>
                </select>
              </div>
              {expCategory === "Custom" && (
                <div className="col-md-3 mb-3">
                  <label>Custom Category</label>
                  <input type="text" className="form-control" placeholder="Enter category" value={customCategory} onChange={(e) => setCustomCategory(e.target.value)} />
                </div>
              )}
              <div className="col-md-3 mb-3">
                <label>Amount (₹)</label>
                <input type="number" className="form-control" placeholder="Enter amount" value={expAmount} onChange={(e) => setExpAmount(e.target.value)} />
              </div>
              <div className="col-md-3 mb-3">
                <label>Date</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="DD/MM/YYYY"
                  value={expDate}
                  maxLength={10}
                  onChange={(e) => {
                    let v = e.target.value.replace(/[^0-9]/g, "");
                    if (v.length > 2) v = v.slice(0,2) + "/" + v.slice(2);
                    if (v.length > 5) v = v.slice(0,5) + "/" + v.slice(5);
                    setExpDate(v.slice(0,10));
                  }}
                />
              </div>
              <div className="col-md-3 mb-3">
                <label>Notes</label>
                <input type="text" className="form-control" placeholder="Optional notes" value={expNotes} onChange={(e) => setExpNotes(e.target.value)} />
              </div>
              <div className="col-md-12">
                <button className="btn btn-danger" onClick={addExpense}>Add Expense</button>
              </div>
            </div>
          </div>

          {/* Category Filter */}
          <div className="card shadow p-3 mb-3">
            <div className="row g-2 align-items-end">
              <div className="col-md-4">
                <label style={{ fontSize: "12px", fontWeight: "600" }}>Filter by Category</label>
                <select
                  className="form-control"
                  value={expFilterCategory}
                  onChange={(e) => setExpFilterCategory(e.target.value)}
                >
                  <option value="">All Categories</option>
                  {[...new Set(expenses.map(e => e.category).filter(Boolean))].sort().map(cat => (
                    <option key={cat} value={cat}>{cat}</option>
                  ))}
                </select>
              </div>
              {expFilterCategory && (
                <div className="col-md-2">
                  <button className="btn btn-outline-secondary w-100" onClick={() => setExpFilterCategory("")}>Clear</button>
                </div>
              )}
            </div>
          </div>

          <DateFilter
            from={expFromDate} setFrom={setExpFromDate}
            to={expToDate} setTo={setExpToDate}
            month={expFilterMonth} setMonth={setExpFilterMonth}
            year={expFilterYear} setYear={setExpFilterYear}
            months={months} years={years}
            onClear={(type) => {
              if (type==="range") { setExpFromDate(""); setExpToDate(""); }
              if (type==="all") { setExpFromDate(""); setExpToDate(""); setExpFilterMonth(""); setExpFilterYear(""); }
            }}
          />

          <div className="card shadow p-4 mt-3">
            <h4>Expense Records</h4>
            <table className="table table-bordered mt-3">
              <thead className="table-danger">
                <tr><th>Date</th><th>Category</th><th>Amount</th><th>Notes</th><th>Action</th></tr>
              </thead>
              <tbody>
                {filteredExpenses.map((e) => (
                  <tr key={e.firestoreId}>
                    <td>{e.date}</td>
                    <td><span className="badge bg-secondary">{e.category}</span></td>
                    <td>₹{e.amount}</td>
                    <td>{e.notes}</td>
                    <td><button className="btn btn-outline-danger btn-sm" onClick={() => deleteExpense(e.firestoreId)}>Delete</button></td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="table-danger fw-bold">
                  <td colSpan="2">Total</td>
                  <td>₹{filteredExpenses.reduce((t,e)=>t+Number(e.amount||0),0)}</td>
                  <td colSpan="2"></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      )}

      {/* PROFIT TAB */}
      {activeTab === "profit" && (
        <div>
          <DateFilter
            from={profFromDate} setFrom={setProfFromDate}
            to={profToDate} setTo={setProfToDate}
            month={profFilterMonth} setMonth={setProfFilterMonth}
            year={profFilterYear} setYear={setProfFilterYear}
            months={months} years={years}
            onClear={(type) => {
              if (type==="range") { setProfFromDate(""); setProfToDate(""); }
              if (type==="all") { setProfFromDate(""); setProfToDate(""); setProfFilterMonth(""); setProfFilterYear(""); }
            }}
          />

          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <div className="card shadow p-4 text-center">
                <h6 className="text-muted">💰 Income</h6>
                <h2 className="text-success">₹{profitIncome.toLocaleString()}</h2>
                <p className="text-muted">{profitIncomeFiltered.length} records</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card shadow p-4 text-center">
                <h6 className="text-muted">🔴 Expense</h6>
                <h2 className="text-danger">₹{profitExpense.toLocaleString()}</h2>
                <p className="text-muted">{profitExpenseFiltered.length} records</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card shadow p-4 text-center">
                <h6 className="text-muted">🟢 Net Profit</h6>
                <h2 className={netProfit >= 0 ? "text-success" : "text-danger"}>₹{netProfit.toLocaleString()}</h2>
                <p className="text-muted">{profitNet >= 0 ? "Profit ✅" : "Loss ❌"}</p>
              </div>
            </div>
          </div>

          <div className="card shadow p-4 mt-4">
            <h5>Profit Breakdown</h5>
            <table className="table table-bordered mt-3">
              <thead className="table-primary">
                <tr><th>Type</th><th>Records</th><th>Amount</th></tr>
              </thead>
              <tbody>
                <tr>
                  <td>💰 Total Income</td>
                  <td>{profitIncomeFiltered.length}</td>
                  <td className="text-success fw-bold">₹{profitIncome.toLocaleString()}</td>
                </tr>
                <tr>
                  <td>🔴 Total Expense</td>
                  <td>{profitExpenseFiltered.length}</td>
                  <td className="text-danger fw-bold">₹{profitExpense.toLocaleString()}</td>
                </tr>
                <tr className="table-primary fw-bold">
                  <td>🟢 Net Profit</td>
                  <td>—</td>
                  <td className={profitNet >= 0 ? "text-success fw-bold" : "text-danger fw-bold"}>₹{profitNet.toLocaleString()}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}

    </div>
  );
}

function UserManagement({ db, showToast }) {

  const [users, setUsers] = useState([]);
  const [newUsername, setNewUsername] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newRole, setNewRole] = useState("Staff");
  const [editUserId, setEditUserId] = useState(null);
  const [editPassword, setEditPassword] = useState("");
  const [deleteUserId, setDeleteUserId] = useState(null);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    const querySnapshot = await getDocs(collection(db, "users"));
    const userData = [];
    querySnapshot.forEach((doc) => {
      userData.push({ firestoreId: doc.id, ...doc.data() });
    });
    setUsers(userData);
  };

  const addUser = async () => {
    if (newUsername === "" || newPassword === "") {
      showToast("Please fill all fields", "error");
      return;
    }
  const hashedPassword = await bcrypt.hash(newPassword, 10);

await addDoc(collection(db, "users"), {
  username: newUsername,
  password: hashedPassword,
  role: newRole,
    isDefaultPassword: true
});
    showToast("User Added Successfully");
    setNewUsername("");
    setNewPassword("");
    setNewRole("Staff");
    fetchUsers();
  };

const deleteUser = async (id) => {

  const confirmed =
    window.confirm(
      "Are you sure you want to delete this user?"
    );

  if (!confirmed) return;

  try {

    await deleteDoc(
      doc(db, "users", id)
    );

    showToast("User Deleted");

    fetchUsers();

  } catch (error) {

    console.log(error);

    showToast("Delete Failed");

  }

};

  const updatePassword = async (id) => {
    if (editPassword === "") {
      showToast("Enter new password", "error");
      return;
    }
    const hashedPassword = await bcrypt.hash(editPassword, 10);
    await updateDoc(doc(db, "users", id), {
      password: hashedPassword,
      isDefaultPassword: false,
    });
    showToast("Password Updated");
    setEditUserId(null);
    setEditPassword("");
    fetchUsers();
  };

  return (
    <div className="mt-4">

      {/* Add User */}
      <div className="card shadow p-4 mb-4">
        <h5>Add New User</h5>
        <div className="row mt-3">

          <div className="col-md-4 mb-3">
            <label>Username</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter username"
              value={newUsername}
              onChange={(e) => setNewUsername(e.target.value)}
            />
          </div>

          <div className="col-md-4 mb-3">
            <label>Password</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>

          <div className="col-md-4 mb-3">
            <label>Role</label>
            <select
              className="form-control"
              value={newRole}
              onChange={(e) => setNewRole(e.target.value)}
            >
              <option>Staff</option>
              <option>Admin</option>
            </select>
          </div>

          <div className="col-md-12">
            <button className="btn btn-success" onClick={addUser}>
              Add User
            </button>
          </div>

        </div>
      </div>

      {/* User List */}
      <div className="card shadow p-4">
        <h5>User List</h5>
        <table className="table table-bordered mt-3">
          <thead className="table-success">
            <tr>
              <th>Username</th>
              <th>Role</th>
              <th>Password</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.firestoreId}>

                <td>{user.username}</td>
                <td>
                  <span className={
                    user.role === "Admin"
                      ? "badge bg-success"
                      : "badge bg-primary"
                  }>
                    {user.role}
                  </span>
                </td>

                <td>
                  {editUserId === user.firestoreId ? (
                    <div className="d-flex gap-2">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="New password"
                        value={editPassword}
                        onChange={(e) => setEditPassword(e.target.value)}
                      />
                      <button
                        className="btn btn-success btn-sm"
                        onClick={() => updatePassword(user.firestoreId)}
                      >
                        Save
                      </button>
                      <button
                        className="btn btn-secondary btn-sm"
                        onClick={() => setEditUserId(null)}
                      >
                        Cancel
                      </button>
                    </div>
                  ) : (
                    "••••••••"
                  )}
                </td>

                <td>
                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => {
                        setEditUserId(user.firestoreId);
                        setEditPassword("");
                      }}
                    >
                      Change Password
                    </button>
<button
  type="button"
  className="btn btn-outline-danger btn-sm"
  onClick={() => deleteUser(user.firestoreId)}
>
  Delete
</button>
                  </div>
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
}

function ActivityLog({ db }) {
  const [logs, setLogs] = useState([]);
  const [filterUser, setFilterUser] = useState("All");
  const [logSearch, setLogSearch] = useState("");

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    const querySnapshot = await getDocs(collection(db, "activityLogs"));
    const logsData = [];
    querySnapshot.forEach((doc) => {
      logsData.push({ id: doc.id, ...doc.data() });
    });
    logsData.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
    setLogs(logsData);
  };

  const users = [...new Set(logs.map(log => log.user))];

  return (
    <div className="mt-4">
      <div className="card shadow p-4">
        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <h4>Activity Log</h4>
          <div className="d-flex gap-2">
            <input
              type="text"
              className="form-control"
              placeholder="Search by Customer ID / App ID..."
              style={{ width: "220px" }}
              value={logSearch}
              onChange={(e) => setLogSearch(e.target.value)}
            />
            <select
              className="form-control w-auto"
              value={filterUser}
              onChange={(e) => setFilterUser(e.target.value)}
            >
              <option value="All">All Users</option>
              {users.map(user => (
                <option key={user} value={user}>{user}</option>
              ))}
            </select>
          </div>
        </div>

        <table className="table table-bordered">
          <thead className="table-success">
            <tr>
              <th>Date</th>
              <th>Time</th>
              <th>User</th>
              <th>Role</th>
              <th>Action</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            {logs
              .filter(log => {
                if (filterUser !== "All" && log.user !== filterUser) return false;
                if (logSearch && !(log.details || "").toLowerCase().includes(logSearch.toLowerCase())) return false;
                return true;
              })
              .map((log) => (
                <tr key={log.id}>
                  <td>{log.date}</td>
                  <td>{log.time}</td>
                  <td>{log.user}</td>
                  <td>
                    <span className={
                      log.role === "Admin"
                        ? "badge bg-success"
                        : "badge bg-primary"
                    }>
                      {log.role}
                    </span>
                  </td>
                  <td>
                    <span className="badge bg-info">{log.action}</span>
                  </td>
                  <td>
  {log.details && log.details.split("\n\n").map((item, i) => (
    <div key={i} style={{ marginBottom: "4px" }}>{item}</div>
  ))}
</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default App;